import { $ as e, A as t, B as n, C as r, D as i, E as a, F as o, G as s, H as c, I as l, J as u, K as d, L as f, M as p, N as m, O as h, P as g, Q as _, R as v, S as y, T as b, U as x, V as S, W as C, X as w, Y as T, Z as E, _ as D, _t as O, a as ee, at as te, b as k, bt as ne, c as A, ct as re, d as ie, dt as ae, et as oe, f as se, ft as j, g as ce, gt as le, h as ue, ht as de, i as fe, it as pe, j as me, k as he, l as ge, lt as _e, m as ve, mt as ye, n as be, nt as xe, o as Se, ot as Ce, p as we, pt as Te, q as Ee, r as De, rt as Oe, s as ke, st as Ae, t as je, tt as Me, u as Ne, ut as Pe, v as Fe, vt as Ie, w as Le, x as Re, y as ze, yt as Be, z as Ve } from "./api-HJB0sydk.js";
import { t as M } from "./utils-DQJjwn-K.js";
import { a as N, i as P, n as He, o as Ue, r as We, s as F, t as Ge } from "./view-toggle-DcrfqD9e.js";
import { a as Ke, i as qe, n as Je, o as Ye, r as Xe, s as Ze, t as Qe } from "./dialog-BkE_1yXM.js";
import { a as $e, c as et, d as I, i as tt, l as nt, o as rt, r as it, s as at, t as ot, u as st } from "./dropdown-menu-Bt4mgeUb.js";
import { c as ct, d as lt, f as ut, i as dt, l as ft, m as pt, n as mt, o as ht, p as gt, r as _t, s as vt, t as yt, u as bt } from "./skill-files-B3jqIKk3.js";
import { n as xt, r as St, t as Ct } from "./raw-file-editor-D75U563f.js";
import { a as wt, c as Tt, i as Et, n as Dt, o as L, r as R, s as Ot, t as kt } from "./design-system-B26cLg1l.js";
import * as At from "react";
import { Children as jt, Component as Mt, Fragment as Nt, Suspense as Pt, createContext as z, lazy as Ft, memo as It, useCallback as B, useContext as V, useEffect as H, useId as Lt, useLayoutEffect as Rt, useMemo as U, useRef as W, useState as G } from "react";
import { Link as K, Navigate as zt, Outlet as Bt, Route as Vt, generatePath as Ht, matchPath as Ut, useLocation as Wt, useNavigate as Gt, useOutletContext as Kt, useParams as qt, useSearchParams as Jt } from "react-router-dom";
import { AlertCircle as Yt, AlertTriangle as Xt, Archive as Zt, ArrowDownIcon as Qt, ArrowLeft as $t, ArrowRight as en, ArrowUpRight as tn, Ban as nn, Bot as rn, Box as an, Building2 as on, Check as sn, CheckCircle as cn, CheckCircle2 as ln, CheckIcon as un, ChevronDown as dn, ChevronDownIcon as fn, ChevronRight as pn, ChevronUp as mn, ChevronUpIcon as hn, Copy as gn, CornerDownLeftIcon as _n, CreditCard as vn, Download as yn, Eye as bn, FileIcon as xn, FileQuestion as Sn, FileText as Cn, FolderIcon as wn, FolderOpen as Tn, Globe as En, Home as Dn, Hourglass as On, Info as kn, Link as An, Loader2 as q, Loader2Icon as jn, LogOut as Mn, Mail as Nn, Maximize2 as Pn, Menu as Fn, MessageSquare as In, Minimize2 as Ln, MoreVertical as Rn, PanelLeft as zn, PanelRight as Bn, Paperclip as Vn, Pause as Hn, Pencil as Un, Pin as Wn, Plus as Gn, PlusIcon as Kn, RefreshCw as qn, RotateCcw as Jn, Search as Yn, SearchIcon as Xn, SearchX as Zn, Settings as Qn, Share2 as $n, ShieldCheck as er, ShieldQuestion as tr, ShieldX as nr, SlidersHorizontal as rr, Sparkles as ir, StopCircle as ar, ThumbsDown as or, ThumbsUp as sr, Trash2 as cr, TriangleAlert as lr, Upload as ur, UserMinus as dr, UserRound as fr, Users as pr, X as mr, XCircle as hr, XIcon as gr } from "lucide-react";
import { CREDIT_SUBUNIT as _r, EVALUATION_COMMENT_MAX_LENGTH as vr, MAX_STEPS as yr, NEW_CONVERSATION_TITLE as br, ORGANIZATION_NAME_MAX_LENGTH as xr, commitmentEnd as Sr, isValidSlug as Cr, normalizeUploadPath as wr, periodAt as Tr, planChange as Er, planTerms as Dr } from "@livingdata/playground-core-shared";
import { HTTPError as Or } from "ky";
import { Fragment as J, jsx as Y, jsxs as X } from "react/jsx-runtime";
import { Trans as kr, useTranslation as Z } from "react-i18next";
import Ar from "p-map";
import { nanoid as jr } from "nanoid";
import { Chat as Mr, useChat as Nr } from "@ai-sdk/react";
import { DefaultChatTransport as Pr, isToolUIPart as Fr, lastAssistantMessageIsCompleteWithApprovalResponses as Ir } from "ai";
import * as Lr from "@radix-ui/react-dialog";
import { cva as Rr } from "class-variance-authority";
import * as zr from "@radix-ui/react-select";
import * as Br from "@radix-ui/react-avatar";
import { createPortal as Vr } from "react-dom";
import * as Hr from "@radix-ui/react-popover";
import { Command as Ur } from "cmdk";
import { StickToBottom as Wr, useStickToBottomContext as Gr } from "use-stick-to-bottom";
import * as Kr from "@radix-ui/react-scroll-area";
//#region src/contexts/auth-context.tsx
var qr = z(void 0);
function Jr({ fetchUser: e, children: t }) {
	let [n, r] = G(), [i, a] = G(!0), o = B(async () => {
		try {
			r(await e());
		} catch {
			r(void 0);
		} finally {
			a(!1);
		}
	}, [e]);
	return H(() => {
		o();
	}, [o]), /* @__PURE__ */ Y(qr, {
		value: U(() => ({
			user: n,
			isLoading: i,
			isAuthenticated: n !== void 0
		}), [n, i]),
		children: t
	});
}
function Yr() {
	let e = V(qr);
	if (!e) throw Error("useAuth must be used within an AuthProvider");
	return e;
}
function Xr() {
	return V(qr);
}
//#endregion
//#region src/utils/url.ts
function Zr() {
	return "/conversations/new";
}
function Qr(e) {
	return `/conversations/${e}`;
}
//#endregion
//#region src/components/panel/panel-navigation.tsx
var $r = z(void 0);
function ei() {
	return typeof globalThis > "u" || globalThis.innerWidth === void 0 ? !0 : globalThis.innerWidth >= 768;
}
function ti({ children: e, isSectionsVisibleInitially: t }) {
	let [n, r] = G(() => ({
		mode: "idle",
		sectionsVisible: t ?? ei()
	})), i = B((e) => {
		r((t) => ({
			mode: "detail",
			view: e,
			sectionsVisibleBeforeDetail: t.mode === "idle" ? t.sectionsVisible : t.sectionsVisibleBeforeDetail,
			isExpanded: t.mode === "detail" && t.isExpanded
		}));
	}, []), a = B(() => {
		r((e) => e.mode === "idle" ? e : {
			mode: "idle",
			sectionsVisible: e.sectionsVisibleBeforeDetail
		});
	}, []), o = B(() => {
		r((e) => e.mode === "idle" ? e : {
			...e,
			isExpanded: !e.isExpanded
		});
	}, []), s = B(() => {
		r((e) => e.mode === "detail" ? {
			mode: "idle",
			sectionsVisible: !1,
			foldedDetail: e
		} : e.foldedDetail ?? {
			mode: "idle",
			sectionsVisible: !e.sectionsVisible
		});
	}, []), c = B(() => {
		r((e) => e.mode === "detail" ? e : {
			mode: "idle",
			sectionsVisible: !0
		});
	}, []), l = B(() => {
		r((e) => e.mode === "detail" ? e : {
			...e,
			sectionsVisible: !1
		});
	}, []), u = B((e) => {
		r((t) => t.mode === "idle" && t.sectionsVisible === e && !t.foldedDetail ? t : {
			mode: "idle",
			sectionsVisible: e
		});
	}, []), d = U(() => ({
		rightRegion: n,
		openDetail: i,
		closeDetail: a,
		toggleDetailExpanded: o,
		toggleSections: s,
		showSections: c,
		hideSections: l,
		resetPanel: u
	}), [
		n,
		i,
		a,
		o,
		s,
		c,
		l,
		u
	]);
	return /* @__PURE__ */ Y($r.Provider, {
		value: d,
		children: e
	});
}
function ni() {
	let e = V($r);
	if (!e) throw Error("usePanelNavigation must be used within PanelNavigationProvider");
	return e;
}
//#endregion
//#region src/contexts/artifact-context.tsx
var ri = z(void 0);
function ii({ children: e }) {
	let t = Gt(), { openDetail: n } = ni(), [r, i] = G(/* @__PURE__ */ new Map()), a = B((e, { artifactId: r, version: i }) => {
		t(Qr(e)), n({
			type: "artifact-detail",
			artifactId: r,
			version: i
		});
	}, [t, n]), o = B((e, t) => {
		i((n) => {
			let r = new Map(n);
			return r.set(e, t), r;
		});
	}, []), s = B((e) => r.get(e), [r]), c = U(() => ({
		navigateToArtifact: a,
		shareTokens: r,
		updateShareToken: o,
		getShareToken: s
	}), [
		a,
		r,
		o,
		s
	]);
	return /* @__PURE__ */ Y(ri.Provider, {
		value: c,
		children: e
	});
}
function ai() {
	let e = V(ri);
	if (!e) throw Error("useArtifactContext must be used within ArtifactProvider");
	return e;
}
//#endregion
//#region src/components/ui/toast.tsx
var oi = z(void 0);
function si({ children: e }) {
	let [t, n] = G([]), r = W(/* @__PURE__ */ new Map()), i = B((e, t = "success", i = 3e3) => {
		let a = crypto.randomUUID();
		n((n) => [...n, {
			id: a,
			message: e,
			type: t
		}]);
		let o = setTimeout(() => {
			n((e) => e.filter((e) => e.id !== a)), r.current.delete(a);
		}, i);
		r.current.set(a, o);
	}, []), a = B((e) => {
		let t = r.current.get(e);
		t && (clearTimeout(t), r.current.delete(e)), n((t) => t.filter((t) => t.id !== e));
	}, []), o = U(() => ({ showToast: i }), [i]);
	return /* @__PURE__ */ X(oi.Provider, {
		value: o,
		children: [e, /* @__PURE__ */ Y("div", {
			className: "fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-50 flex flex-col gap-2 sm:max-w-md",
			role: "region",
			"aria-live": "polite",
			children: t.map((e) => /* @__PURE__ */ X("div", {
				role: e.type === "error" ? "alert" : "status",
				className: M("flex items-start gap-2 rounded-lg border px-4 py-3 shadow-lg animate-in slide-in-from-right-full", e.type === "success" && "bg-background border-green-500/50", e.type === "error" && "bg-background border-destructive/50"),
				children: [
					e.type === "success" && /* @__PURE__ */ Y(cn, { className: "h-4 w-4 text-green-500 shrink-0 mt-0.5" }),
					e.type === "error" && /* @__PURE__ */ Y(hr, { className: "h-4 w-4 text-destructive shrink-0 mt-0.5" }),
					/* @__PURE__ */ Y("span", {
						className: "text-sm flex-1 break-words",
						children: e.message
					}),
					/* @__PURE__ */ Y("button", {
						onClick: () => {
							a(e.id);
						},
						className: "text-muted-foreground hover:text-foreground shrink-0",
						"aria-label": "Dismiss notification",
						children: /* @__PURE__ */ Y(mr, { className: "h-4 w-4" })
					})
				]
			}, e.id))
		})]
	});
}
function Q() {
	let e = V(oi);
	if (!e) throw Error("useToast must be used within ToastProvider");
	return e;
}
//#endregion
//#region src/contexts/file-context.tsx
var ci = 100 * 1024 * 1024, li = 5 * 1024 * 1024;
function ui(e) {
	return e.size > ci;
}
var di = z(void 0);
function fi({ children: t, conversationId: n, ensureConversation: r }) {
	let [i, a] = G([]), [o, s] = G([]), { showToast: c } = Q(), { t: l } = Z(), u = W(/* @__PURE__ */ new Map()), d = W(n);
	H(() => {
		d.current = n;
	}, [n]), H(() => {
		if (!n) {
			a([]);
			return;
		}
		(async () => {
			try {
				a(await e(n, "user"));
			} catch (e) {
				console.error("Failed to load user files:", e);
			}
		})();
		let t = u.current;
		return () => {
			for (let e of t.values()) clearTimeout(e);
			t.clear();
		};
	}, [n]);
	let f = B(async (t, n, r, i) => {
		try {
			let o = await C(i, {
				path: r,
				size: t.size,
				contentType: t.type || "application/octet-stream"
			}), { presignedUrls: c } = o, l = c.length, u = /* @__PURE__ */ new Map(), f = () => {
				let e = [...u.values()].reduce((e, t) => e + t, 0), t = Math.floor(e / l);
				s((e) => e.map((e) => e.id === n ? {
					...e,
					progress: t
				} : e));
			}, p = await Ar(c, async (e) => {
				let n = (e.partNumber - 1) * li, r = n + e.size, i = t.slice(n, r), a = await Ie(e.url, i, (t) => {
					u.set(e.partNumber, t), f();
				});
				return {
					partNumber: e.partNumber,
					etag: a
				};
			}, { concurrency: 3 });
			await ge(i, o.id, p), s((e) => e.filter((e) => e.id !== n));
			let m = await e(i, "user");
			d.current === i && a(m);
		} catch (e) {
			let r = typeof e == "object" && !!e && "response" in e && e.response?.status === 409, i = l("fileSystem.uploadFailed", { filename: t.name });
			r && (i = l("fileSystem.fileAlreadyExists", { filename: t.name })), c(i, "error"), s((e) => e.map((e) => e.id === n ? {
				...e,
				error: i,
				progress: 0
			} : e));
			let a = setTimeout(() => {
				s((e) => e.filter((e) => e.id !== n)), u.current.delete(n);
			}, 3e3);
			u.current.set(n, a);
		}
	}, [c, l]), p = B((e, t) => {
		c(l(t), "error"), s((n) => n.map((n) => e.some((e) => e.id === n.id) ? {
			...n,
			error: l(t)
		} : n));
		for (let t of e) {
			let e = setTimeout(() => {
				s((e) => e.filter((e) => e.id !== t.id)), u.current.delete(t.id);
			}, 3e3);
			u.current.set(t.id, e);
		}
	}, [c, l]), m = B(async (e, t) => {
		let i = e.map((e, n) => ({
			file: e,
			path: t?.[n]
		})), a = i.filter(({ file: e }) => ui(e));
		if (a.length > 0) for (let { file: e } of a) c(l("fileSystem.fileTooLarge", { filename: e.name }), "error");
		let o = i.filter(({ file: e }) => !ui(e));
		if (o.length === 0) return;
		let u = !n, d = o.map(({ file: e, path: t }) => {
			let r = wr(t ? `${t}/${e.name}` : e.name);
			return {
				id: jr(),
				conversationId: n ?? void 0,
				filename: e.name,
				path: r,
				size: e.size,
				progress: 0,
				status: u ? "preparing" : "uploading"
			};
		});
		s((e) => [...e, ...d]);
		let m = n;
		if (!m) {
			if (!r) {
				c(l("fileSystem.noActiveConversation"), "error"), s((e) => e.filter((e) => !d.some((t) => t.id === e.id)));
				return;
			}
			try {
				m = (await r()).id;
			} catch {
				p(d, "fileSystem.conversationCreateFailed");
				return;
			}
		}
		if (!m) {
			p(d, "fileSystem.conversationCreateFailed");
			return;
		}
		s((e) => e.map((e) => d.some((t) => t.id === e.id) ? {
			...e,
			status: "uploading",
			conversationId: m
		} : e));
		for (let [e, t] of d.entries()) {
			let n = o[e]?.file;
			n && f(n, t.id, t.path, m);
		}
		return {
			conversationId: m,
			acceptedPaths: d.map((e) => e.path)
		};
	}, [
		n,
		r,
		p,
		f,
		c,
		l
	]), h = B(async (e) => {
		if (!n) return !1;
		try {
			return await ce(n, e), a((t) => t.filter((t) => t.id !== e)), !0;
		} catch (e) {
			return console.error("Failed to delete file:", e), c(l("fileSystem.deleteFailed"), "error"), !1;
		}
	}, [
		n,
		c,
		l
	]), g = B(() => i.length, [i]), _ = U(() => o.filter((e) => e.conversationId ? e.conversationId === n : !n), [n, o]), v = B(() => _.length > 0, [_]), y = U(() => ({
		files: i,
		uploads: _,
		addFiles: m,
		removeFile: h,
		getFileCount: g,
		hasActiveUploads: v
	}), [
		i,
		_,
		m,
		h,
		g,
		v
	]);
	return /* @__PURE__ */ Y(di.Provider, {
		value: y,
		children: t
	});
}
function pi() {
	let e = V(di);
	if (!e) throw Error("useFiles must be used within a FileProvider");
	return e;
}
//#endregion
//#region src/hooks/use-stream-end-effect.ts
function mi(e, t) {
	let n = W(e);
	H(() => {
		let r = n.current;
		n.current = e, r && !e && t();
	}, [e, t]);
}
//#endregion
//#region src/contexts/produced-files-context.tsx
var hi = z(void 0);
function gi({ children: t, conversationId: n, isStreaming: r = !1 }) {
	let [i, a] = G([]), [o, s] = G(!1), c = B(async () => {
		if (!n) {
			a([]);
			return;
		}
		s(!0);
		try {
			a(await e(n, "workflow"));
		} catch (e) {
			console.error("Failed to load produced files:", e);
		} finally {
			s(!1);
		}
	}, [n]);
	H(() => {
		c();
	}, [c]), mi(r, () => {
		c();
	});
	let l = U(() => ({
		files: i,
		isLoading: o,
		refresh: c
	}), [
		i,
		o,
		c
	]);
	return /* @__PURE__ */ Y(hi.Provider, {
		value: l,
		children: t
	});
}
function _i() {
	let e = V(hi);
	if (!e) throw Error("useProducedFiles must be used within a ProducedFilesProvider");
	return e;
}
//#endregion
//#region src/contexts/attached-files-context.tsx
function vi(e) {
	return e.map((e) => ({
		type: "data-file",
		data: {
			origin: e.origin,
			path: e.path
		}
	}));
}
var yi = z(void 0);
function bi(e) {
	return `${e.origin}:${e.path}`;
}
function xi({ children: e, conversationId: t }) {
	let [n, r] = G([]), i = W(t);
	H(() => {
		i.current !== t && (i.current !== void 0 && r([]), i.current = t);
	}, [t]);
	let a = B((e) => {
		r((t) => t.some((t) => bi(t) === bi(e)) ? t : [...t, e]);
	}, []), o = B((e) => {
		r((t) => t.filter((t) => bi(t) !== bi(e)));
	}, []), s = B((e) => {
		r((t) => t.some((t) => bi(t) === bi(e)) ? t.filter((t) => bi(t) !== bi(e)) : [...t, e]);
	}, []), c = B((e) => n.some((t) => bi(t) === bi(e)), [n]), l = B(() => {
		r([]);
	}, []), u = U(() => ({
		attached: n,
		attach: a,
		detach: o,
		toggleAttachment: s,
		isAttached: c,
		clear: l
	}), [
		n,
		a,
		o,
		s,
		c,
		l
	]);
	return /* @__PURE__ */ Y(yi.Provider, {
		value: u,
		children: e
	});
}
function Si() {
	let e = V(yi);
	if (!e) throw Error("useAttachedFiles must be used within an AttachedFilesProvider");
	return e;
}
//#endregion
//#region src/hooks/use-conversation-list.ts
function Ci() {
	let { t: e } = Z(), { showToast: t } = Q(), [n, r] = G([]), i = B(async () => {
		try {
			r(await a());
		} catch {
			t(e("errors.conversationsLoadFailed"), "error");
		}
	}, [t, e]);
	return H(() => {
		i();
	}, [i]), {
		conversations: n,
		refreshConversations: i,
		prependConversation: B((e) => {
			r((t) => [e, ...t]);
		}, []),
		removeConversation: B((e) => {
			r((t) => t.filter((t) => t.id !== e));
		}, []),
		updateConversationTitle: B((e, t) => {
			r((n) => n.map((n) => n.id === e ? {
				...n,
				title: t
			} : n));
		}, [])
	};
}
//#endregion
//#region src/hooks/use-conversation-actions.ts
function wi({ onTitleChange: e }) {
	let { t } = Z(), { showToast: n } = Q(), r = B(async (r, i) => {
		try {
			e(r, (await ye(r, { title: i })).title), n(t("renameDialog.success"), "success");
		} catch (e) {
			throw n(t("renameDialog.error"), "error"), e;
		}
	}, [
		e,
		n,
		t
	]), i = B(async (r) => {
		try {
			e(r, (await xe(r)).title), n(t("regenerateTitle.success"), "success");
		} catch (e) {
			throw n(t("regenerateTitle.error"), "error"), e;
		}
	}, [
		e,
		n,
		t
	]);
	return U(() => ({
		rename: r,
		regenerateTitle: i
	}), [r, i]);
}
//#endregion
//#region src/api/conversation-chat-transport.ts
async function Ti(e) {
	try {
		return await e.json();
	} catch {
		return {};
	}
}
function Ei(e) {
	return async (t, n) => {
		let r = await fe(t, {
			method: n?.method,
			headers: n?.headers,
			body: n?.body,
			signal: e(),
			throwHttpErrors: !1,
			retry: {
				limit: 2,
				statusCodes: [409],
				methods: ["post"]
			}
		});
		if (r.status === 403 && (n?.method ?? "GET").toUpperCase() === "POST") {
			let { code: e, error: t } = await Ti(r);
			throw e === "sandbox:limit_reached" ? new be(t) : new je();
		}
		return r;
	};
}
var Di = class extends Pr {
	onNothingToReplay;
	onReplayStarted;
	constructor({ conversationId: e, getAbortSignal: t, onNothingToReplay: n, onReplayStarted: r }) {
		super({
			api: e ? S(e) : "about:blank",
			fetch: Ei(t),
			prepareSendMessagesRequest({ messages: e, id: t }) {
				let n = e.at(-1);
				return n?.role === "assistant" ? { body: {
					message: {
						...n,
						parts: n.parts.filter((e) => Fr(e) && e.state === "approval-responded")
					},
					id: t
				} } : { body: {
					message: n,
					id: t
				} };
			},
			prepareReconnectToStreamRequest({ id: e }) {
				return { api: c(e) };
			}
		}), this.onNothingToReplay = n, this.onReplayStarted = r;
	}
	async reconnectToStream(e) {
		let t = await super.reconnectToStream(e);
		if (!t) return this.onNothingToReplay?.(), t;
		let n = !0;
		return t.pipeThrough(new TransformStream({ transform: (e, t) => {
			n && (n = !1, this.onReplayStarted?.()), t.enqueue(e);
		} }));
	}
};
//#endregion
//#region src/hooks/use-conversation-chat.ts
function Oi({ isConnectionLost: e, hasAttemptLeft: t, attempt: n }) {
	return e ? t ? n === 1 ? "resuming" : "reconnecting" : "lost" : "connected";
}
function ki(e) {
	return e.map((e) => ({
		id: e.id,
		role: e.role,
		parts: e.parts,
		metadata: e.metadata
	}));
}
function Ai(e) {
	let t = W(e), n = W(e), r = W(0), [i, a] = G(!1), [o, s] = G(-1), [c, l] = G();
	n.current !== e && (n.current = e, r.current += 1);
	let u = W(new AbortController());
	H(() => (t.current = e, u.current = new AbortController(), () => {
		u.current.abort();
	}), [e]);
	let f = W(!1), p = W(!1), m = W(0), h = U(() => new Di({
		conversationId: e,
		getAbortSignal: () => u.current.signal,
		onNothingToReplay() {
			p.current = f.current;
		},
		onReplayStarted() {
			m.current = 0;
		}
	}), [e]), [g, _] = G("connected"), v = W(void 0), y = B(() => {
		clearTimeout(v.current), v.current = void 0;
	}, []), b = B((e) => {
		y(), f.current = !0, e.resumeStream();
	}, [y]), x = U(() => {
		m.current = 0;
		let t = new Mr({
			id: e,
			transport: h,
			sendAutomaticallyWhen: Ir,
			onError(e) {
				if (console.error("Stream error:", e), Ee(e) || T(e) || ee(e)) return;
				f.current = !1;
				let n = m.current < 3;
				n && (m.current += 1, v.current = setTimeout(() => {
					b(t);
				}, 1e3 * m.current)), _(Oi({
					isConnectionLost: d(e),
					hasAttemptLeft: n,
					attempt: m.current
				}));
			},
			onFinish({ isError: e }) {
				e || (m.current = 0);
			}
		});
		return t;
	}, [
		e,
		h,
		b
	]), { messages: S, sendMessage: C, status: w, setMessages: E, error: D, addToolApprovalResponse: O } = Nr({
		chat: x,
		throttle: 50
	});
	H(() => {
		e && x.resumeStream();
	}, [x, e]), H(() => (_("connected"), () => {
		y(), f.current = !1;
	}), [x, y]);
	let te = B(async (e) => {
		let n = await Le(e);
		return t.current === e ? {
			data: n,
			messages: ki(n.messages)
		} : void 0;
	}, []);
	H(() => {
		if (w === "error" || !f.current) return;
		f.current = !1, _("connected");
		let e = t.current;
		!p.current || !e || (p.current = !1, (async () => {
			try {
				let t = await te(e);
				t && E(t.messages);
			} catch (e) {
				console.error("Failed to reload the conversation after a resume:", e);
			}
		})());
	}, [
		w,
		E,
		te
	]);
	let k = B(() => {
		g === "connected" || f.current || (g === "lost" && (m.current = 1, _("reconnecting")), b(x));
	}, [
		x,
		g,
		b
	]);
	H(() => {
		let e = () => {
			document.visibilityState === "visible" && k();
		};
		return globalThis.addEventListener("online", k), document.addEventListener("visibilitychange", e), () => {
			globalThis.removeEventListener("online", k), document.removeEventListener("visibilitychange", e);
		};
	}, [k]);
	let ne = d(D) ? void 0 : D, A = w === "submitted" || w === "streaming", re = W(!1);
	re.current = A || g !== "connected";
	let ie = !!e && o !== r.current;
	H(() => {
		A || a(!1);
	}, [A]);
	let ae = B(async (e) => {
		let t = await te(e);
		t && (re.current ? E((e) => {
			let n = new Set(t.messages.map((e) => e.id));
			return [...t.messages, ...e.filter((e) => !n.has(e.id))];
		}) : E(t.messages), l({
			conversationId: e,
			evaluation: t.data.evaluation
		}), s(r.current));
	}, [E, te]), oe = B((e, n) => {
		t.current === e && l({
			conversationId: e,
			evaluation: n
		});
	}, []);
	return {
		messages: S,
		sendMessage: C,
		addToolApprovalResponse: O,
		status: w,
		setMessages: E,
		error: ne,
		connection: g,
		retryConnection: k,
		isLoading: A,
		isConversationLoading: ie,
		isStopping: i,
		setIsStopping: a,
		loadConversation: ae,
		evaluation: c?.conversationId === e ? c?.evaluation : void 0,
		setEvaluation: oe
	};
}
//#endregion
//#region src/hooks/use-conversation-evaluation.ts
function ji({ conversationId: e, evaluation: t, onEvaluated: n }) {
	let { t: r } = Z(), { showToast: i } = Q(), a = W(0);
	return B(async (o) => {
		if (!e) return;
		let s = ++a.current;
		n(e, {
			...o,
			createdAt: (/* @__PURE__ */ new Date()).toISOString()
		});
		try {
			let t = await k(e, o);
			s === a.current && n(e, t);
		} catch {
			s === a.current && n(e, t), i(r("chatPanel.evaluation.error"), "error");
		}
	}, [
		e,
		t,
		n,
		i,
		r
	]);
}
//#endregion
//#region src/hooks/use-conversation-title-update.ts
function Mi({ conversationId: e, messagesLength: t, status: n, onTitleUpdate: r }) {
	H(() => {
		(async () => {
			if (t === 2 && e && n === "ready") try {
				let t = await Le(e);
				r(t.id, t.title);
			} catch (e) {
				console.error("Failed to fetch conversation title:", e);
			}
		})();
	}, [
		e,
		t,
		r,
		n
	]);
}
//#endregion
//#region src/hooks/use-ensure-conversation.ts
function Ni({ currentConversationId: e, onConversationCreated: t }) {
	let { t: n } = Z(), { showToast: r } = Q(), i = W(void 0), a = B(async () => e ? { id: e } : (i.current ??= (async () => {
		try {
			let e = await ie();
			return t?.(e), e;
		} catch (e) {
			throw r(n("errors.conversationCreateFailed"), "error"), i.current = void 0, e;
		}
	})(), { id: (await i.current).id }), [
		e,
		t,
		r,
		n
	]);
	return H(() => {
		i.current = void 0;
	}, [e]), {
		ensureConversation: a,
		resetEnsureConversation: B(() => {
			i.current = void 0;
		}, [])
	};
}
//#endregion
//#region src/hooks/use-pending-message-queue.ts
function Pi({ currentConversationId: e, status: t, ensureConversation: n, sendMessage: r, onSendError: i, onQueueCleared: a }) {
	let [o, s] = G([]), [c, l] = G(void 0), [u, d] = G(!1), f = o.length > 0 || u, p = B(async (e) => {
		try {
			await r({
				text: e.content,
				fileParts: e.fileParts
			});
		} catch (t) {
			i(t, e);
		}
	}, [i, r]), m = B(async (t, r) => {
		let i = {
			content: t,
			fileParts: r
		};
		if (!e) {
			s((e) => [...e, i]);
			try {
				let e = await n();
				if (!e) {
					s([]), l(void 0);
					return;
				}
				l(e.id);
			} catch {
				s([]), l(void 0), a?.("create-failed");
			}
			return;
		}
		await p(i);
	}, [
		e,
		n,
		a,
		p
	]);
	return H(() => {
		if (o.length === 0) {
			c && l(void 0);
			return;
		}
		if (!e || t !== "ready" || !c) return;
		if (e !== c) {
			console.warn("Pending messages cleared due to conversation mismatch"), s([]), l(void 0), d(!1), a?.("mismatch");
			return;
		}
		if (u) return;
		let n = o[0];
		n && (async () => {
			d(!0);
			try {
				await p(n);
			} finally {
				s((e) => e.length > 0 && e[0] === n ? e.slice(1) : e), d(!1);
			}
		})();
	}, [
		e,
		a,
		o,
		c,
		p,
		t,
		u
	]), {
		handleSendMessage: m,
		shouldBlockConversationLoad: f
	};
}
//#endregion
//#region src/contexts/balance-context.tsx
var Fi = z(void 0);
function Ii({ children: e }) {
	let [t, n] = G(), [r, i] = G(!0), a = B(async () => {
		try {
			n(await f());
		} catch {} finally {
			i(!1);
		}
	}, []);
	H(() => {
		a();
	}, [a]);
	let o = U(() => ({
		credits: t,
		isExhausted: t?.blocked ?? !1,
		isLoading: r,
		refresh: a
	}), [
		t,
		r,
		a
	]);
	return /* @__PURE__ */ Y(Fi.Provider, {
		value: o,
		children: e
	});
}
function Li() {
	let e = V(Fi);
	if (!e) throw Error("useBalance must be used within a BalanceProvider");
	return e;
}
//#endregion
//#region src/contexts/chat-state-context.tsx
var Ri = z(void 0);
function zi({ children: e }) {
	let { t } = Z(), { showToast: n } = Q(), r = Gt(), i = Wt(), { conversationId: a } = qt(), o = a === "new" ? void 0 : a, [s, c] = G(void 0), l = o ?? s, { conversations: u, prependConversation: f, removeConversation: p, updateConversationTitle: m } = Ci(), { ensureConversation: h, resetEnsureConversation: g } = Ni({
		currentConversationId: l,
		onConversationCreated: f
	}), _ = W(0), v = B(() => {
		_.current += 1, c(void 0), g();
	}, [g]), y = W(i.pathname);
	H(() => {
		y.current !== i.pathname && (y.current = i.pathname, v());
	}, [i.pathname, v]);
	let { rename: b, regenerateTitle: x } = wi({ onTitleChange: m }), [S, C] = G({
		open: !1,
		isDeleting: !1
	}), [w, E] = G(void 0), D = B(() => {
		E(void 0);
	}, []), { messages: O, sendMessage: ee, addToolApprovalResponse: te, status: k, setMessages: ne, error: A, connection: re, retryConnection: ie, isLoading: ae, isConversationLoading: oe, isStopping: se, setIsStopping: ce, loadConversation: le, evaluation: de, setEvaluation: fe } = Ai(o), pe = ji({
		conversationId: o,
		evaluation: de,
		onEvaluated: fe
	}), { refresh: me } = Li(), he = W(!1);
	H(() => {
		he.current && !ae && me(), he.current = ae;
	}, [ae, me]), H(() => {
		Ee(A) && me(), T(A) && n(A.message, "error");
	}, [
		A,
		me,
		n
	]);
	let ge = B(async () => {
		let e = _.current, t = await h();
		return _.current === e && c(t.id), t;
	}, [h]), _e = B((e, r) => {
		Ee(e) || T(e) || (typeof e == "object" && e && "status" in e && e.status === 409 ? n(t("errors.messageInProgress"), "error") : (n(t("errors.sendMessageFailed"), "error"), console.error("Failed to send message:", e)), E({
			text: r.content,
			fileParts: r.fileParts
		}));
	}, [n, t]), ve = B(async (e) => e.fileParts && e.fileParts.length > 0 ? ee({ parts: [{
		type: "text",
		text: e.text
	}, ...e.fileParts] }) : ee({ text: e.text }), [ee]), { handleSendMessage: ye, shouldBlockConversationLoad: be } = Pi({
		currentConversationId: o,
		status: k,
		ensureConversation: B(async () => {
			let e = _.current, t = await h();
			if (_.current === e) return r(Qr(t.id)), t;
		}, [h, r]),
		sendMessage: ve,
		onSendError: _e
	}), xe = oe && !be;
	Mi({
		conversationId: o,
		messagesLength: O.length,
		status: k,
		onTitleUpdate: m
	}), H(() => {
		if (!o || be) return;
		let e = !1, i = async () => {
			try {
				await le(o);
			} catch (a) {
				if (e) return;
				if (d(a)) {
					globalThis.addEventListener("online", i, { once: !0 });
					return;
				}
				n(t("errors.conversationLoadFailed"), "error"), r(Zr(), { replace: !0 });
			}
		};
		return i(), () => {
			e = !0, globalThis.removeEventListener("online", i);
		};
	}, [
		o,
		le,
		r,
		be,
		n,
		t
	]), H(() => {
		o || ne([]);
	}, [o, ne]);
	let Se = B(async () => {
		if (!(!o || se)) {
			ce(!0);
			try {
				await j(o);
			} catch (e) {
				console.error("Failed to stop generation:", e), n(t("errors.stopGenerationFailed"), "error"), ce(!1);
			}
		}
	}, [
		o,
		se,
		ce,
		n,
		t
	]), Ce = B((e) => {
		r(Qr(e));
	}, [r]), we = B(() => {
		v(), r(Zr());
	}, [v, r]), Te = B(async (e) => {
		C({
			open: !0,
			conversation: e,
			isDeleting: !1
		});
	}, []), De = B(async () => {
		let e = S.conversation;
		if (!e) return;
		let i = e.id;
		C((e) => ({
			...e,
			isDeleting: !0
		}));
		try {
			await ue(i);
			let e = u.findIndex((e) => e.id === i), a = u[e + 1] ?? u[e - 1];
			p(i), l === i && v(), o === i && r(a ? Qr(a.id) : Zr()), n(t("deleteDialog.success"), "success");
		} catch {
			n(t("deleteDialog.error"), "error");
		} finally {
			C({
				open: !1,
				isDeleting: !1
			});
		}
	}, [
		v,
		l,
		u,
		o,
		S.conversation,
		r,
		p,
		n,
		t
	]), Oe = B((e) => {
		C((t) => ({
			...t,
			open: e
		}));
	}, []), ke = U(() => u.find((e) => e.id === o), [u, o]);
	return /* @__PURE__ */ Y(Ri, {
		value: U(() => ({
			conversations: u,
			currentConversationId: o,
			activeConversationId: l,
			conversation: ke,
			messages: O,
			evaluation: de,
			isLoading: ae,
			isConversationLoading: xe,
			isStopping: se,
			error: A,
			connection: re,
			failedSend: w,
			clearFailedSend: D,
			handleSendMessage: ye,
			respondToToolApproval: te,
			handleStopGeneration: Se,
			retryConnection: ie,
			handleSelectConversation: Ce,
			handleNewConversation: we,
			handleDeleteConversation: Te,
			renameConversation: b,
			regenerateTitle: x,
			evaluateConversation: pe,
			ensureConversationForFiles: ge
		}), [
			u,
			o,
			l,
			ke,
			O,
			de,
			ae,
			xe,
			se,
			A,
			re,
			w,
			D,
			ye,
			te,
			Se,
			ie,
			Ce,
			we,
			Te,
			b,
			x,
			pe,
			ge
		]),
		children: e({
			open: S.open,
			conversationTitle: S.conversation?.title ?? "",
			isDeleting: S.isDeleting,
			onOpenChange: Oe,
			onConfirm: De
		})
	});
}
function Bi() {
	let e = V(Ri);
	if (!e) throw Error("useChatState must be used within ChatStateProvider");
	return e;
}
function Vi() {
	return V(Ri);
}
//#endregion
//#region src/components/delete-conversation-dialog.tsx
function Hi({ isOpen: e, onOpenChange: t, conversationTitle: n, onConfirm: r, isDeleting: i = !1 }) {
	let { t: a } = Z();
	return /* @__PURE__ */ Y(Qe, {
		open: e,
		onOpenChange: t,
		children: /* @__PURE__ */ X(Xe, {
			showCloseButton: !i,
			children: [/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: a("deleteDialog.title") }), /* @__PURE__ */ Y(qe, { children: a("deleteDialog.description", { title: n }) })] }), /* @__PURE__ */ X(Ke, { children: [/* @__PURE__ */ Y(I, {
				variant: "ghost",
				onClick: () => {
					t(!1);
				},
				disabled: i,
				children: a("deleteDialog.cancel")
			}), /* @__PURE__ */ Y(I, {
				variant: "destructive",
				onClick: r,
				disabled: i,
				children: a(i ? "deleteDialog.deleting" : "deleteDialog.delete")
			})] })]
		})
	});
}
//#endregion
//#region src/hooks/use-mobile.ts
function Ui() {
	let [e, t] = G(() => globalThis.innerWidth === void 0 ? !1 : globalThis.innerWidth < 768);
	return H(() => {
		let e = globalThis.matchMedia("(max-width: 767px)"), n = () => {
			t(e.matches);
		};
		return e.addEventListener("change", n), () => {
			e.removeEventListener("change", n);
		};
	}, []), !!e;
}
//#endregion
//#region src/components/layout/page-header-context.tsx
var Wi = {}, Gi = z(void 0);
function Ki({ children: e }) {
	let [t, n] = G([]), r = B((e, t) => {
		n((n) => {
			let r = n.findIndex((t) => t.id === e);
			if (r === -1) return [...n, {
				id: e,
				state: t
			}];
			let i = [...n];
			return i[r] = {
				id: e,
				state: t
			}, i;
		});
	}, []), i = B((e) => {
		n((t) => t.filter((t) => t.id !== e));
	}, []), a = t.at(-1)?.state ?? Wi;
	return /* @__PURE__ */ Y(Gi, {
		value: U(() => ({
			top: a,
			register: r,
			unregister: i
		}), [
			a,
			r,
			i
		]),
		children: e
	});
}
function qi() {
	let e = V(Gi);
	if (!e) throw Error("usePageHeaderState must be used within PageHeaderProvider");
	return e.top;
}
function Ji(e) {
	let t = V(Gi);
	if (!t) throw Error("usePageHeader must be used within PageHeaderProvider");
	let n = Lt(), { register: r, unregister: i } = t, { title: a, trailing: o, mobileTrailing: s, mobileTitle: c } = e;
	H(() => {
		r(n, {
			title: a,
			trailing: o,
			mobileTrailing: s,
			mobileTitle: c
		});
	}, [
		n,
		r,
		a,
		o,
		s,
		c
	]), H(() => () => {
		i(n);
	}, [n, i]);
}
//#endregion
//#region src/components/layout/sidebar-compact-toggle.tsx
function Yi({ isCompact: e, onToggle: t, className: n }) {
	let { t: r } = Z(), i = r(e ? "sidebar.expand" : "sidebar.collapse");
	return /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
		asChild: !0,
		children: /* @__PURE__ */ Y(I, {
			type: "button",
			variant: "ghost",
			size: "icon-sm",
			"aria-label": i,
			className: n ?? "size-[30px] text-muted-foreground",
			onClick: t,
			children: /* @__PURE__ */ Y(zn, { className: "size-4" })
		})
	}), /* @__PURE__ */ Y(N, {
		side: "bottom",
		children: i
	})] });
}
//#endregion
//#region src/constants/sidebar.ts
var Xi = "lds-sidebar-compact";
//#endregion
//#region src/hooks/use-sidebar-compact.ts
function Zi() {
	if (typeof localStorage > "u") return !1;
	try {
		return localStorage.getItem(Xi) === "true";
	} catch {
		return !1;
	}
}
function Qi(e) {
	if (!(typeof localStorage > "u")) try {
		localStorage.setItem(Xi, String(e));
	} catch {}
}
function $i() {
	let [e, t] = G(Zi);
	return H(() => {
		Qi(e);
	}, [e]), {
		isCompact: e,
		setCompact: B((e) => {
			t(e);
		}, []),
		toggleCompact: B(() => {
			t((e) => !e);
		}, [])
	};
}
//#endregion
//#region src/components/layout/sidebar-layout-context.tsx
var ea = z(void 0);
function ta({ children: e }) {
	let t = $i();
	return /* @__PURE__ */ Y(ea, {
		value: U(() => ({
			isCompact: t.isCompact,
			setCompact: t.setCompact,
			toggleCompact: t.toggleCompact
		}), [
			t.isCompact,
			t.setCompact,
			t.toggleCompact
		]),
		children: e
	});
}
function na() {
	let e = V(ea);
	if (!e) throw Error("useSidebarLayout must be used within SidebarLayoutProvider");
	return e;
}
//#endregion
//#region src/components/layout/app-header-bar.tsx
function ra({ className: e }) {
	let { isCompact: t, toggleCompact: n } = na(), { title: r, trailing: i } = qi();
	return /* @__PURE__ */ X("header", {
		className: M("flex h-14 shrink-0 items-center gap-3 border-b border-border bg-background px-3 md:px-4", e),
		children: [
			/* @__PURE__ */ Y(Yi, {
				isCompact: t,
				onToggle: n
			}),
			r && /* @__PURE__ */ Y("h1", {
				className: "truncate text-base font-semibold text-foreground md:text-lg",
				children: r
			}),
			i && /* @__PURE__ */ Y("div", {
				className: "ml-auto flex items-center gap-2",
				children: i
			})
		]
	});
}
//#endregion
//#region src/components/layout/nav-items.ts
var ia = [
	{
		id: "home",
		labelKey: "nav.home",
		icon: Dn,
		to: "/",
		matchPaths: ["/"]
	},
	{
		id: "conversations",
		labelKey: "nav.conversations",
		icon: pt("conversation").Icon,
		to: "/conversations",
		matchPaths: ["/conversations"]
	},
	{
		id: "skills",
		labelKey: "nav.skills",
		icon: pt("skill").Icon,
		to: "/skills",
		matchPaths: ["/skills"]
	}
];
function aa(e, t) {
	return e.matchPaths.includes("/") && t === "/" ? !0 : e.matchPaths.some((e) => e === "/" ? !1 : t === e || t.startsWith(`${e}/`));
}
//#endregion
//#region src/components/layout/app-nav.tsx
function oa({ mode: e, onItemClick: t, className: n }) {
	let { t: r } = Z(), { pathname: i } = Wt();
	return /* @__PURE__ */ Y("nav", {
		"aria-label": r("nav.primary"),
		className: M("flex flex-col gap-1", e === "compact" ? "items-center" : "items-stretch", n),
		children: ia.map((n) => /* @__PURE__ */ Y(sa, {
			item: n,
			isActive: aa(n, i),
			mode: e,
			label: r(n.labelKey),
			onItemClick: t
		}, n.id))
	});
}
function sa({ item: e, isActive: t, mode: n, label: r, onItemClick: i }) {
	let a = e.icon, o = M("group/nav-item flex items-center rounded-md text-sidebar-foreground transition-colors cursor-pointer", "outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring/50", t ? "bg-foreground text-background" : "hover:bg-foreground/8");
	return n === "compact" ? /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
		asChild: !0,
		children: /* @__PURE__ */ Y(K, {
			to: e.to,
			"aria-current": t ? "page" : void 0,
			"aria-label": r,
			className: M(o, "h-[38px] w-[38px] justify-center"),
			onClick: i,
			children: /* @__PURE__ */ Y(a, { className: "size-4" })
		})
	}), /* @__PURE__ */ Y(N, {
		side: "right",
		children: r
	})] }) : /* @__PURE__ */ X(K, {
		to: e.to,
		"aria-current": t ? "page" : void 0,
		className: M(o, "h-9 gap-2 px-3 text-[13.5px] font-medium"),
		onClick: i,
		children: [/* @__PURE__ */ Y(a, { className: "size-4 shrink-0" }), /* @__PURE__ */ Y("span", {
			className: "truncate",
			children: r
		})]
	});
}
//#endregion
//#region src/brand/types.ts
function ca(e) {
	return e;
}
//#endregion
//#region src/brand/context.tsx
var la = z(void 0);
function ua({ manifest: e, children: t }) {
	return /* @__PURE__ */ Y(la.Provider, {
		value: e,
		children: t
	});
}
function da(e) {
	return V(la)?.[e];
}
function fa() {
	return V(la)?.name;
}
//#endregion
//#region src/components/layout/brand-slot.tsx
function pa({ isCompact: e = !1, className: t }) {
	let { t: n } = Z(), r = da("Logo"), i = fa() ?? n("brand.fallback");
	return e ? /* @__PURE__ */ X("div", {
		className: M("flex h-9 w-9 items-center justify-center overflow-hidden rounded-md bg-white text-foreground", t),
		children: [r ? /* @__PURE__ */ Y(r, { variant: "compact" }) : /* @__PURE__ */ Y("span", {
			"aria-hidden": "true",
			className: "text-xs font-semibold tracking-tight",
			children: "LD"
		}), /* @__PURE__ */ Y("span", {
			className: "sr-only",
			children: i
		})]
	}) : /* @__PURE__ */ X("div", {
		className: M("flex items-center gap-2 min-w-0", t),
		children: [/* @__PURE__ */ Y("div", {
			className: "flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-md bg-white text-foreground",
			children: r ? /* @__PURE__ */ Y(r, { variant: "compact" }) : /* @__PURE__ */ Y("span", {
				"aria-hidden": "true",
				className: "text-xs font-semibold tracking-tight",
				children: "LD"
			})
		}), /* @__PURE__ */ Y("span", {
			className: "truncate text-sm font-semibold text-foreground",
			children: i
		})]
	});
}
//#endregion
//#region src/components/layout/new-conversation-button.tsx
function ma({ isCompact: e = !1, className: t, onNavigate: n }) {
	let { t: r } = Z(), { handleNewConversation: i } = Bi(), a = B(() => {
		i(), n?.();
	}, [i, n]), o = r("sidebar.newConversation");
	return e ? /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
		asChild: !0,
		children: /* @__PURE__ */ Y(I, {
			type: "button",
			variant: "default",
			"aria-label": o,
			onClick: a,
			className: M("h-[38px] w-[38px] rounded-md p-0", t),
			children: /* @__PURE__ */ Y(Gn, { className: "size-4" })
		})
	}), /* @__PURE__ */ Y(N, {
		side: "right",
		children: o
	})] }) : /* @__PURE__ */ X(I, {
		type: "button",
		variant: "default",
		onClick: a,
		className: M("h-9 w-full justify-center gap-2", t),
		children: [/* @__PURE__ */ Y(Gn, { className: "size-4" }), /* @__PURE__ */ Y("span", { children: o })]
	});
}
//#endregion
//#region src/components/ui/back-link.tsx
function ha({ to: e, label: t, className: n, onClick: r }) {
	return /* @__PURE__ */ X(K, {
		to: e,
		onClick: r,
		className: M("inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-foreground", n),
		children: [/* @__PURE__ */ Y($t, {
			className: "size-4",
			"aria-hidden": "true"
		}), /* @__PURE__ */ Y("span", { children: t })]
	});
}
//#endregion
//#region src/hooks/use-is-out-of-view.ts
function ga() {
	let [e, t] = G(null), [n, r] = G();
	return H(() => {
		if (!e) return;
		let t = new IntersectionObserver((t) => {
			let n = t.at(-1);
			n && r(n.isIntersecting ? void 0 : e);
		});
		return t.observe(e), () => {
			t.disconnect();
		};
	}, [e]), {
		ref: t,
		isOutOfView: e === n
	};
}
//#endregion
//#region src/components/layout/page-template.tsx
function _a({ title: e, headerTitle: t, isHeaderTitleHidden: n, description: r, meta: i, toolbar: a, action: o, leading: s, className: c, children: l }) {
	let { ref: u, isOutOfView: d } = ga();
	Ji({
		title: n ? void 0 : t ?? e,
		mobileTitle: d ? e : void 0
	});
	let f = o?.icon;
	return /* @__PURE__ */ X("div", {
		className: M("h-full overflow-y-auto", c),
		children: [/* @__PURE__ */ Y("div", {
			className: "top-0 z-10 bg-background md:[@media(min-height:30rem)]:sticky",
			children: /* @__PURE__ */ X("div", {
				className: "mx-auto flex w-full max-w-5xl flex-col gap-2 px-4 py-4 md:px-6",
				children: [
					/* @__PURE__ */ Y("div", {
						className: "min-h-5",
						children: s
					}),
					/* @__PURE__ */ X("div", {
						className: "flex flex-wrap items-center gap-3",
						children: [/* @__PURE__ */ X("div", {
							className: "flex flex-1 flex-wrap items-center gap-3",
							children: [/* @__PURE__ */ Y("h1", {
								ref: u,
								className: "text-2xl font-semibold tracking-tight md:text-3xl",
								children: e
							}), i && /* @__PURE__ */ Y("div", { children: i })]
						}), o && /* @__PURE__ */ X(I, {
							type: "button",
							variant: "default",
							disabled: o.disabled,
							"aria-label": o.ariaLabel ?? o.label,
							onClick: o.onClick,
							children: [f && /* @__PURE__ */ Y(f, { className: "size-4" }), /* @__PURE__ */ Y("span", { children: o.label })]
						})]
					}),
					r && /* @__PURE__ */ Y("p", {
						className: "text-sm text-muted-foreground",
						children: r
					}),
					a && /* @__PURE__ */ Y("div", { children: a })
				]
			})
		}), /* @__PURE__ */ Y("div", {
			className: "mx-auto w-full max-w-5xl px-4 py-6 md:px-6",
			children: l
		})]
	});
}
//#endregion
//#region src/components/ui/section-card.tsx
function $({ title: e, description: t, children: n, layout: r = "stacked", action: i, bodyClassName: a, className: o }) {
	let s = e != null, c = t != null, l = i != null, u = (s || c) && /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-1",
		children: [s && /* @__PURE__ */ Y("h2", {
			className: "text-base font-medium",
			children: e
		}), c && /* @__PURE__ */ Y("p", {
			className: "text-sm text-muted-foreground",
			children: t
		})]
	});
	return r === "inline" ? /* @__PURE__ */ X("section", {
		className: M("flex flex-col gap-3 rounded-xl border border-border bg-card p-4 shadow-sm", "sm:flex-row sm:items-center sm:justify-between sm:gap-6", o),
		children: [/* @__PURE__ */ X("div", {
			className: "flex flex-col gap-3",
			children: [u, n]
		}), l && /* @__PURE__ */ Y("div", {
			className: "shrink-0",
			children: i
		})]
	}) : /* @__PURE__ */ X("section", {
		className: M("flex flex-col gap-3", o),
		children: [
			u,
			n && /* @__PURE__ */ Y("div", {
				className: M("rounded-xl border border-border bg-card shadow-sm", a ?? "p-4"),
				children: n
			}),
			l && /* @__PURE__ */ Y("div", {
				className: "flex justify-end",
				children: i
			})
		]
	});
}
//#endregion
//#region src/components/ui/select.tsx
function va({ ...e }) {
	return /* @__PURE__ */ Y(zr.Root, {
		"data-slot": "select",
		...e
	});
}
function ya({ ...e }) {
	return /* @__PURE__ */ Y(zr.Value, {
		"data-slot": "select-value",
		...e
	});
}
function ba({ className: e, size: t = "default", children: n, ...r }) {
	return /* @__PURE__ */ X(zr.Trigger, {
		"data-slot": "select-trigger",
		"data-size": t,
		className: M("border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit cursor-pointer items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[length:var(--focus-ring-width)] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:min-w-0 *:data-[slot=select-value]:flex-1 *:data-[slot=select-value]:truncate [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
		...r,
		children: [n, /* @__PURE__ */ Y(zr.Icon, {
			asChild: !0,
			children: /* @__PURE__ */ Y(fn, { className: "size-4 opacity-50" })
		})]
	});
}
function xa({ className: e, children: t, position: n = "popper", align: r = "center", ...i }) {
	return /* @__PURE__ */ Y(zr.Portal, { children: /* @__PURE__ */ X(zr.Content, {
		"data-slot": "select-content",
		className: M("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md", n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", e),
		position: n,
		align: r,
		...i,
		children: [
			/* @__PURE__ */ Y(Ca, {}),
			/* @__PURE__ */ Y(zr.Viewport, {
				className: M("p-1", n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"),
				children: t
			}),
			/* @__PURE__ */ Y(wa, {})
		]
	}) });
}
function Sa({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ X(zr.Item, {
		"data-slot": "select-item",
		className: M("focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-pointer items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", e),
		...n,
		children: [/* @__PURE__ */ Y("span", {
			className: "absolute right-2 flex size-3.5 items-center justify-center",
			children: /* @__PURE__ */ Y(zr.ItemIndicator, { children: /* @__PURE__ */ Y(un, { className: "size-4" }) })
		}), /* @__PURE__ */ Y(zr.ItemText, { children: t })]
	});
}
function Ca({ className: e, ...t }) {
	return /* @__PURE__ */ Y(zr.ScrollUpButton, {
		"data-slot": "select-scroll-up-button",
		className: M("flex cursor-default items-center justify-center py-1", e),
		...t,
		children: /* @__PURE__ */ Y(hn, { className: "size-4" })
	});
}
function wa({ className: e, ...t }) {
	return /* @__PURE__ */ Y(zr.ScrollDownButton, {
		"data-slot": "select-scroll-down-button",
		className: M("flex cursor-default items-center justify-center py-1", e),
		...t,
		children: /* @__PURE__ */ Y(fn, { className: "size-4" })
	});
}
//#endregion
//#region src/components/ui/badge.tsx
var Ta = Rr(["inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium", "whitespace-nowrap shrink-0 [&_svg]:size-3 [&_svg]:shrink-0"].join(" "), {
	variants: { variant: {
		default: "bg-primary text-primary-foreground",
		secondary: "bg-secondary text-secondary-foreground",
		outline: "border border-border text-foreground",
		muted: "bg-muted text-muted-foreground"
	} },
	defaultVariants: { variant: "secondary" }
});
function Ea({ className: e, variant: t, ...n }) {
	return /* @__PURE__ */ Y("span", {
		className: M(Ta({ variant: t }), e),
		...n
	});
}
//#endregion
//#region src/components/settings/setting-row.tsx
function Da({ label: e, description: t, control: n }) {
	return /* @__PURE__ */ X("div", {
		className: "flex flex-wrap items-center gap-x-4 gap-y-3 border-b border-border py-4 last:border-b-0",
		children: [/* @__PURE__ */ X("div", {
			className: "min-w-0 flex-1 basis-48",
			children: [/* @__PURE__ */ Y("div", {
				className: "flex flex-wrap items-center gap-x-2 gap-y-1 text-sm font-medium",
				children: e
			}), t && /* @__PURE__ */ Y("div", {
				className: "mt-0.5 text-xs text-muted-foreground",
				children: t
			})]
		}), /* @__PURE__ */ Y("div", {
			className: "shrink-0",
			children: n
		})]
	});
}
function Oa({ isChecked: e, onCheckedChange: t, ariaLabel: n }) {
	return /* @__PURE__ */ Y("button", {
		type: "button",
		role: "switch",
		"aria-checked": e,
		"aria-label": n,
		onClick: () => {
			t(!e);
		},
		className: `relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ${e ? "bg-primary" : "bg-muted"}`,
		children: /* @__PURE__ */ Y("span", { className: `inline-block size-5 transform rounded-full bg-background shadow transition-transform ${e ? "translate-x-[22px]" : "translate-x-[2px]"}` })
	});
}
function ka({ rows: e }) {
	return /* @__PURE__ */ Y($, {
		bodyClassName: "px-4 py-2",
		children: /* @__PURE__ */ Y("div", {
			className: "flex flex-col gap-3 py-2",
			children: Array.from({ length: e }, (e, t) => /* @__PURE__ */ Y("div", { className: "h-10 animate-pulse rounded bg-muted" }, t))
		})
	});
}
//#endregion
//#region src/lib/apply-user-language.ts
function Aa(e, t) {
	t === "auto" ? (localStorage.removeItem("i18nextLng"), e.changeLanguage()) : e.changeLanguage(t);
}
//#endregion
//#region src/hooks/use-user-settings.ts
function ja() {
	let { i18n: e } = Z(), [t, n] = G();
	return H(() => {
		let t = !1;
		return (async () => {
			try {
				let r = await Ve();
				t || (n(r), Aa(e, r.language));
			} catch {}
		})(), () => {
			t = !0;
		};
	}, [e]), {
		settings: t,
		patchSettings: (e) => {
			n((t) => t && {
				...t,
				...e
			}), O(e);
		}
	};
}
//#endregion
//#region src/pages/agent-settings.tsx
var Ma = [
	10,
	yr.default,
	50
];
function Na() {
	let { t: e } = Z(), { settings: t, patchSettings: n } = ja();
	return /* @__PURE__ */ Y(_a, {
		title: e("settings.sections.agent"),
		description: e("settings.agentDescription"),
		isHeaderTitleHidden: !0,
		children: t ? /* @__PURE__ */ X($, {
			bodyClassName: "px-4 py-2",
			children: [/* @__PURE__ */ Y(Da, {
				label: /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y("span", { children: e("settings.summarization") }), /* @__PURE__ */ Y(Ea, {
					variant: "outline",
					className: "uppercase tracking-wide",
					children: e("settings.summarizationBadge")
				})] }),
				description: e("settings.summarizationDescription"),
				control: /* @__PURE__ */ Y(Oa, {
					isChecked: t.summarizationEnabled ?? !1,
					ariaLabel: e("settings.summarization"),
					onCheckedChange: (e) => {
						n({ summarizationEnabled: e });
					}
				})
			}), /* @__PURE__ */ Y(Da, {
				label: e("settings.maxSteps"),
				description: e("settings.maxStepsDescription"),
				control: /* @__PURE__ */ X(va, {
					value: String(t.maxSteps ?? yr.default),
					onValueChange: (e) => {
						n({ maxSteps: Number(e) });
					},
					children: [/* @__PURE__ */ Y(ba, {
						size: "sm",
						className: "w-44",
						children: /* @__PURE__ */ Y(ya, {})
					}), /* @__PURE__ */ Y(xa, { children: Ma.map((e) => /* @__PURE__ */ Y(Sa, {
						value: String(e),
						children: e
					}, e)) })]
				})
			})]
		}) : /* @__PURE__ */ Y(ka, { rows: 2 })
	});
}
//#endregion
//#region src/pages/preferences.tsx
function Pa() {
	let { t: e, i18n: t } = Z(), { settings: n, patchSettings: r } = ja();
	return /* @__PURE__ */ Y(_a, {
		title: e("account.sections.preferences"),
		description: e("account.preferencesDescription"),
		isHeaderTitleHidden: !0,
		children: n ? /* @__PURE__ */ Y($, {
			bodyClassName: "px-4 py-2",
			children: /* @__PURE__ */ Y(Da, {
				label: e("settings.language"),
				control: /* @__PURE__ */ X(va, {
					value: n.language,
					onValueChange: (e) => {
						let n = e;
						r({ language: n }), Aa(t, n);
					},
					children: [/* @__PURE__ */ Y(ba, {
						size: "sm",
						className: "w-44",
						children: /* @__PURE__ */ Y(ya, {})
					}), /* @__PURE__ */ X(xa, { children: [
						/* @__PURE__ */ Y(Sa, {
							value: "auto",
							children: e("settings.languageAuto")
						}),
						/* @__PURE__ */ Y(Sa, {
							value: "fr",
							children: e("settings.languageFr")
						}),
						/* @__PURE__ */ Y(Sa, {
							value: "en",
							children: e("settings.languageEn")
						})
					] })]
				})
			})
		}) : /* @__PURE__ */ Y(ka, { rows: 1 })
	});
}
//#endregion
//#region src/components/organizations/create-organization-form.tsx
function Fa({ onCreate: e }) {
	let { t } = Z(), [n, r] = G(""), [i, a] = G(), [o, s] = G(!1), c = async (t) => {
		t.preventDefault(), s(!0), a(void 0);
		try {
			await e(n.trim()), r("");
		} catch (e) {
			a(e instanceof Error ? e.message : String(e));
		} finally {
			s(!1);
		}
	};
	return /* @__PURE__ */ X("form", {
		className: "flex flex-col gap-2",
		onSubmit: (e) => {
			c(e);
		},
		children: [
			/* @__PURE__ */ X("div", {
				className: "flex gap-2",
				children: [/* @__PURE__ */ Y(St, {
					value: n,
					maxLength: xr,
					placeholder: t("account.organizations.namePlaceholder"),
					"aria-label": t("account.organizations.namePlaceholder"),
					"aria-invalid": i ? !0 : void 0,
					disabled: o,
					onChange: (e) => {
						r(e.target.value);
					}
				}), /* @__PURE__ */ X(I, {
					type: "submit",
					disabled: o || n.trim() === "",
					children: [/* @__PURE__ */ Y(Gn, { "aria-hidden": "true" }), t("account.organizations.create")]
				})]
			}),
			i && /* @__PURE__ */ Y("p", {
				role: "alert",
				className: "text-sm text-destructive",
				children: i
			}),
			/* @__PURE__ */ Y("p", {
				className: "text-sm text-muted-foreground",
				children: t("account.organizations.createHint")
			})
		]
	});
}
//#endregion
//#region src/components/organizations/confirm-removal-dialog.tsx
function Ia({ isOpen: e, title: t, description: n, confirmLabel: r, onOpenChange: i, onConfirm: a }) {
	let { t: o } = Z(), [s, c] = G(), [l, u] = G(!1), d = (e) => {
		l || (e || c(void 0), i(e));
	}, f = async () => {
		u(!0), c(void 0);
		try {
			await a();
		} catch (e) {
			c(e instanceof Error ? e.message : String(e));
		} finally {
			u(!1);
		}
	};
	return /* @__PURE__ */ Y(Qe, {
		open: e,
		onOpenChange: d,
		children: /* @__PURE__ */ X(Xe, {
			showCloseButton: !l,
			children: [
				/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: t }), /* @__PURE__ */ Y(qe, { children: n })] }),
				s && /* @__PURE__ */ Y("p", {
					role: "alert",
					className: "text-sm text-destructive",
					children: s
				}),
				/* @__PURE__ */ X(Ke, { children: [/* @__PURE__ */ Y(Je, {
					asChild: !0,
					children: /* @__PURE__ */ Y(I, {
						variant: "ghost",
						disabled: l,
						children: o("account.organizations.cancel")
					})
				}), /* @__PURE__ */ Y(I, {
					variant: "destructive",
					disabled: l,
					onClick: () => {
						f();
					},
					children: r
				})] })
			]
		})
	});
}
//#endregion
//#region src/app-paths.ts
var La = "/settings", Ra = "/account";
function za(e) {
	return `${La}/${e}`;
}
function Ba(e) {
	return `${Ra}/${e}`;
}
var Va = "/organizations";
function Ha(e, t) {
	let n = `${Va}/${e}`;
	return t ? `${n}/${t}` : n;
}
//#endregion
//#region src/components/ui/avatar.tsx
function Ua({ className: e, ...t }) {
	return /* @__PURE__ */ Y(Br.Root, {
		"data-slot": "avatar",
		className: M("relative flex size-8 shrink-0 overflow-hidden rounded-full", e),
		...t
	});
}
function Wa({ className: e, ...t }) {
	return /* @__PURE__ */ Y(Br.Fallback, {
		"data-slot": "avatar-fallback",
		className: M("bg-muted flex size-full items-center justify-center rounded-full", e),
		...t
	});
}
//#endregion
//#region src/components/organizations/organization-avatar.tsx
function Ga({ name: e }) {
	return /* @__PURE__ */ Y(Ua, {
		className: "size-8 rounded-md",
		children: /* @__PURE__ */ Y(Wa, {
			className: "rounded-md bg-secondary text-secondary-foreground text-sm font-medium",
			children: e.charAt(0).toUpperCase()
		})
	});
}
//#endregion
//#region src/components/organizations/role-badge.tsx
function Ka({ role: e }) {
	let { t } = Z();
	return e === "admin" ? /* @__PURE__ */ Y(Ea, {
		variant: "secondary",
		children: t("account.organizations.roles.admin")
	}) : /* @__PURE__ */ Y(Ea, {
		variant: "muted",
		children: t("account.organizations.roles.member")
	});
}
//#endregion
//#region src/components/organizations/organization-item.tsx
function qa({ name: e, role: t, settingsPath: n, onLeave: r }) {
	let { t: i } = Z(), { pathname: a } = Wt(), o = { from: a };
	return /* @__PURE__ */ X("div", {
		className: "flex items-center gap-3 py-3",
		children: [
			/* @__PURE__ */ Y(Ga, { name: e }),
			/* @__PURE__ */ X("div", {
				className: "flex min-w-0 flex-1 flex-col items-start gap-1 sm:flex-row sm:items-center sm:gap-3",
				children: [/* @__PURE__ */ Y("span", {
					className: "w-full min-w-0 truncate text-sm font-medium sm:w-auto sm:flex-1",
					children: e
				}), /* @__PURE__ */ Y(Ka, { role: t })]
			}),
			/* @__PURE__ */ X(ot, { children: [/* @__PURE__ */ Y(st, {
				asChild: !0,
				children: /* @__PURE__ */ Y(I, {
					variant: "ghost",
					size: "icon-sm",
					className: "shrink-0",
					"aria-label": i("account.organizations.actions", { name: e }),
					children: /* @__PURE__ */ Y(Rn, { "aria-hidden": "true" })
				})
			}), /* @__PURE__ */ X(it, {
				align: "end",
				children: [/* @__PURE__ */ Y($e, {
					asChild: !0,
					children: /* @__PURE__ */ X(K, {
						to: n,
						state: o,
						children: [/* @__PURE__ */ Y(Qn, { "aria-hidden": "true" }), i("account.organizations.settings")]
					})
				}), r && /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y(nt, {}), /* @__PURE__ */ X($e, {
					variant: "destructive",
					onSelect: r,
					children: [/* @__PURE__ */ Y(Mn, { "aria-hidden": "true" }), i("account.organizations.leave")]
				})] })]
			})] })
		]
	});
}
//#endregion
//#region src/components/organizations/organization-list.tsx
function Ja({ organizations: e, isCreationOpen: t, onLeave: n }) {
	let { t: r } = Z();
	return e.length === 0 ? /* @__PURE__ */ Y($, {
		title: r("account.organizations.listTitleEmpty"),
		bodyClassName: "border-dashed shadow-none",
		children: /* @__PURE__ */ X("div", {
			className: "flex flex-col items-center gap-1 py-6 text-center text-sm",
			children: [/* @__PURE__ */ Y("p", {
				className: "font-semibold",
				children: r("account.organizations.emptyTitle")
			}), /* @__PURE__ */ Y("p", {
				className: "text-muted-foreground",
				children: r(t ? "account.organizations.emptyCanCreate" : "account.organizations.empty")
			})]
		})
	}) : /* @__PURE__ */ Y($, {
		title: r("account.organizations.listTitle", { count: e.length }),
		bodyClassName: "px-4 py-1 divide-y divide-border",
		children: e.map((e) => /* @__PURE__ */ Y(qa, {
			name: e.name,
			role: e.role,
			settingsPath: Ha(e.id),
			onLeave: e.abilities.leave ? () => {
				n(e);
			} : void 0
		}, e.id))
	});
}
//#endregion
//#region src/components/organizations/invitation-item.tsx
function Ya({ organizationName: e, inviterName: t, expiresAt: n, onAccept: r, onDecline: i }) {
	let { t: a, i18n: o } = Z(), [s, c] = G(!1), [l, u] = G(), d = async (e) => {
		c(!0), u(void 0);
		try {
			await e();
		} catch (e) {
			u(e instanceof Error ? e.message : String(e)), c(!1);
		}
	}, f = new Intl.DateTimeFormat(o.language, {
		day: "numeric",
		month: "long",
		hour: "2-digit",
		minute: "2-digit"
	}).format(new Date(n));
	return /* @__PURE__ */ X("div", {
		className: "flex flex-wrap items-center gap-x-3 gap-y-2 py-3",
		children: [
			/* @__PURE__ */ Y(Ga, { name: e }),
			/* @__PURE__ */ X("div", {
				className: "flex min-w-0 flex-1 flex-col gap-0.5",
				children: [/* @__PURE__ */ Y("span", {
					className: "min-w-0 truncate text-sm font-medium",
					children: e
				}), /* @__PURE__ */ Y("p", {
					className: "text-xs text-muted-foreground",
					children: t ? a("invitations.fromInviter", {
						inviter: t,
						date: f
					}) : a("invitations.validUntil", { date: f })
				})]
			}),
			/* @__PURE__ */ X("div", {
				className: "flex w-full justify-end gap-2 sm:w-auto",
				children: [/* @__PURE__ */ Y(I, {
					variant: "ghost",
					size: "sm",
					disabled: s,
					onClick: () => {
						d(i);
					},
					children: a("invitations.decline")
				}), /* @__PURE__ */ Y(I, {
					size: "sm",
					disabled: s,
					onClick: () => {
						d(r);
					},
					children: a("invitations.accept")
				})]
			}),
			l && /* @__PURE__ */ Y("p", {
				role: "alert",
				className: "w-full text-sm text-destructive",
				children: l
			})
		]
	});
}
//#endregion
//#region src/components/organizations/received-invitations.tsx
function Xa({ invitations: e, onAccept: t, onDecline: n }) {
	let { t: r } = Z(), { showToast: i } = Q();
	return e.map((e) => /* @__PURE__ */ Y(Ya, {
		organizationName: e.organization.name,
		inviterName: e.inviterName,
		expiresAt: e.expiresAt,
		onAccept: async () => {
			i(r("invitations.joined", { organization: (await t(e.id)).name }));
		},
		onDecline: async () => {
			await n(e.id), i(r("invitations.declined", { organization: e.organization.name }));
		}
	}, e.id));
}
function Za(e) {
	let { t } = Z(), n = Lt();
	return e.invitations.length === 0 ? null : /* @__PURE__ */ X("section", {
		"aria-labelledby": n,
		className: "flex flex-col gap-3",
		children: [/* @__PURE__ */ Y("h2", {
			id: n,
			className: "text-lg font-semibold",
			children: t("invitations.title")
		}), /* @__PURE__ */ Y("div", {
			className: "divide-y divide-border rounded-xl border border-border bg-card px-4 py-1 shadow-sm",
			children: /* @__PURE__ */ Y(Xa, { ...e })
		})]
	});
}
//#endregion
//#region src/hooks/use-my-invitations.ts
function Qa() {
	let { t: e } = Z(), [t, n] = G([]);
	H(() => {
		let e = !1;
		return (async () => {
			try {
				let { items: t } = await h();
				e || n(t);
			} catch {}
		})(), () => {
			e = !0;
		};
	}, []);
	let r = (e) => {
		n((t) => t.filter(({ id: t }) => t !== e));
	};
	return {
		invitations: t,
		accept: async (t) => {
			let n = await Be(De(t), e("invitations.acceptFailed"));
			return r(t), n;
		},
		decline: async (t) => {
			await Be(ve(t), e("invitations.declineFailed")), r(t);
		}
	};
}
//#endregion
//#region src/hooks/use-my-organizations.ts
function $a(e, t) {
	return e.name.localeCompare(t.name, void 0, { sensitivity: "base" });
}
function eo() {
	let { t: e } = Z(), { user: t } = Yr(), [n, r] = G(), [i, a] = G(!1), o = B(async () => {
		try {
			r(await he()), a(!1);
		} catch {
			r(void 0), a(!0);
		}
	}, []);
	H(() => {
		o();
	}, [o]);
	let s = (e) => {
		r((t) => !t || t.items.some(({ id: t }) => t === e.id) ? t : {
			...t,
			items: [...t.items, e].sort($a)
		});
	};
	return {
		organizations: n,
		isLoadFailed: i,
		reload: o,
		create: async (t) => {
			s(await Be(se(t), e("account.organizations.createFailed")));
		},
		leave: async (n) => {
			await Be(Oe(n, t.id), e("account.organizations.leaveFailed")), r((e) => e && {
				...e,
				items: e.items.filter(({ id: e }) => e !== n)
			});
		},
		include: s
	};
}
//#endregion
//#region src/pages/my-organizations.tsx
function to() {
	let { t: e } = Z(), { organizations: t, isLoadFailed: n, reload: r, create: i, leave: a, include: o } = eo(), { invitations: s, accept: c, decline: l } = Qa(), [u, d] = G(), [f, p] = G(!1);
	return /* @__PURE__ */ X(_a, {
		title: e("account.sections.organizations"),
		description: e("account.organizations.description"),
		isHeaderTitleHidden: !0,
		children: [/* @__PURE__ */ X("div", {
			className: "flex flex-col gap-stack-lg",
			children: [
				n && /* @__PURE__ */ X("div", {
					className: "flex flex-col items-center gap-stack",
					children: [/* @__PURE__ */ Y(R, {
						variant: "error",
						title: e("account.organizations.loadFailed")
					}), /* @__PURE__ */ Y(I, {
						variant: "outline",
						size: "sm",
						onClick: () => {
							r();
						},
						children: e("account.organizations.retry")
					})]
				}),
				!t && !n && /* @__PURE__ */ Y(ka, { rows: 2 }),
				t && /* @__PURE__ */ X(J, { children: [
					s.length > 0 && /* @__PURE__ */ Y($, {
						title: e("account.organizations.invitationsTitle"),
						bodyClassName: "px-4 py-1 divide-y divide-border",
						children: /* @__PURE__ */ Y(Xa, {
							invitations: s,
							onAccept: async (e) => {
								let t = await c(e);
								return o(t), t;
							},
							onDecline: l
						})
					}),
					/* @__PURE__ */ Y(Ja, {
						organizations: t.items,
						isCreationOpen: t.canCreate,
						onLeave: (e) => {
							d(e), p(!0);
						}
					}),
					t.canCreate && /* @__PURE__ */ Y($, {
						title: e("account.organizations.createTitle"),
						children: /* @__PURE__ */ Y(Fa, { onCreate: i })
					})
				] })
			]
		}), /* @__PURE__ */ Y(Ia, {
			isOpen: f,
			title: e("account.organizations.leaveDialog.title", { name: u?.name }),
			description: e("account.organizations.leaveDialog.description"),
			confirmLabel: e("account.organizations.leave"),
			onOpenChange: p,
			onConfirm: async () => {
				u && (await a(u.id), p(!1));
			}
		})]
	});
}
//#endregion
//#region src/hooks/use-organization.ts
var no = "organizations:invitation_not_sent";
function ro(e) {
	return e instanceof Or && e.response.status === 404;
}
function io(e) {
	let { t: n } = Z(), { user: r } = Yr(), [i, a] = G(), [o, c] = G(), [l, u] = G([]), d = B(async () => {
		try {
			let { items: t } = await me(e);
			u(t);
		} catch {}
	}, [e]), f = B(async () => {
		c(void 0);
		try {
			let n = await t(e);
			a(n), n.abilities.invite && await d();
		} catch (e) {
			a(void 0), c(ro(e) ? "notFound" : "failed");
		}
	}, [e, d]);
	return H(() => {
		f();
	}, [f]), {
		organization: i,
		loadError: o,
		reload: f,
		invitations: l,
		invite: async (t) => {
			try {
				await s(e, t);
			} catch (e) {
				let { code: t, message: r } = await Re(e);
				if (t !== no) throw Error(r ?? n("organizationSettings.members.inviteFailed"));
			}
			await d();
		},
		revoke: async (t) => {
			await Be(Ae(e, t), n("organizationSettings.members.revokeFailed")), u((e) => e.filter(({ id: e }) => e !== t));
		},
		changeRole: async (t, i) => {
			let o = await Be(de(e, t, i), n("organizationSettings.members.roleFailed"));
			if (t === r?.id) {
				await f();
				return;
			}
			a((e) => e && {
				...e,
				members: e.members.map((e) => e.userId === t ? {
					...e,
					role: o.role
				} : e)
			});
		},
		removeMember: async (t) => {
			await Be(Oe(e, t), n("organizationSettings.members.removeFailed")), a((e) => e && {
				...e,
				members: e.members.filter((e) => e.userId !== t)
			});
		},
		rename: async (t) => {
			let r = await Be(pe(e, t), n("organizationSettings.general.renameFailed"));
			a((e) => e && {
				...e,
				name: r.name
			});
		},
		deleteOrganization: async () => {
			await Be(D(e), n("organizationSettings.general.deleteFailed"));
		},
		leave: async () => {
			await Be(Oe(e, r.id), n("account.organizations.leaveFailed"));
		}
	};
}
//#endregion
//#region src/components/organizations/organization-settings-frame.tsx
function ao() {
	let { organizationId: e = "" } = qt();
	return /* @__PURE__ */ Y(oo, { organizationId: e }, e);
}
function oo({ organizationId: e }) {
	return /* @__PURE__ */ Y(Bt, { context: io(e) });
}
function so({ title: e, description: t, children: n }) {
	let { t: r } = Z(), { organization: i, loadError: a, ...o } = Kt();
	return /* @__PURE__ */ Y(_a, {
		title: e,
		description: t,
		isHeaderTitleHidden: !0,
		leading: i && /* @__PURE__ */ X("span", {
			className: "flex items-center gap-2 text-sm text-muted-foreground",
			children: [/* @__PURE__ */ Y(Ga, { name: i.name }), /* @__PURE__ */ Y("span", {
				className: "truncate",
				children: i.name
			})]
		}),
		children: /* @__PURE__ */ X("div", {
			className: "flex flex-col gap-stack-lg",
			children: [
				a === "notFound" && /* @__PURE__ */ X("div", {
					className: "flex flex-col items-center gap-stack",
					children: [/* @__PURE__ */ Y(R, {
						variant: "error",
						title: r("organizationSettings.notFound.title"),
						description: r("organizationSettings.notFound.description")
					}), /* @__PURE__ */ Y(I, {
						isAsChild: !0,
						variant: "outline",
						size: "sm",
						children: /* @__PURE__ */ Y(K, {
							to: Ba(ls.organizations),
							children: r("organizationSettings.notFound.back")
						})
					})]
				}),
				a === "failed" && /* @__PURE__ */ X("div", {
					className: "flex flex-col items-center gap-stack",
					children: [/* @__PURE__ */ Y(R, {
						variant: "error",
						title: r("organizationSettings.loadFailed")
					}), /* @__PURE__ */ Y(I, {
						variant: "outline",
						size: "sm",
						onClick: () => {
							o.reload();
						},
						children: r("organizationSettings.retry")
					})]
				}),
				!i && !a && /* @__PURE__ */ Y(ka, { rows: 3 }),
				i && n({
					organization: i,
					...o
				})
			]
		})
	});
}
//#endregion
//#region src/components/ui/danger-zone.tsx
function co({ title: e, children: t, className: n }) {
	let r = Lt();
	return /* @__PURE__ */ X("section", {
		"aria-labelledby": r,
		className: M("overflow-hidden rounded-xl border border-destructive/40 bg-card shadow-sm", n),
		children: [/* @__PURE__ */ X("div", {
			className: "flex items-center gap-2 px-4 py-3 text-destructive",
			children: [/* @__PURE__ */ Y("span", {
				className: "flex size-7 shrink-0 items-center justify-center rounded-full bg-destructive/10",
				children: /* @__PURE__ */ Y(lr, {
					className: "size-4",
					"aria-hidden": "true"
				})
			}), /* @__PURE__ */ Y("h2", {
				id: r,
				className: "text-sm font-semibold",
				children: e
			})]
		}), t]
	});
}
function lo({ title: e, description: t, actionLabel: n, onAction: r }) {
	return /* @__PURE__ */ X("div", {
		className: "mx-4 flex flex-col items-start gap-3 border-t border-destructive/15 py-4 sm:flex-row sm:items-center sm:gap-4",
		children: [/* @__PURE__ */ X("div", {
			className: "min-w-0 sm:flex-1",
			children: [/* @__PURE__ */ Y("div", {
				className: "text-sm font-medium text-foreground",
				children: e
			}), /* @__PURE__ */ Y("p", {
				className: "mt-0.5 text-xs text-muted-foreground",
				children: t
			})]
		}), /* @__PURE__ */ Y(I, {
			variant: "ghost-destructive",
			className: "shrink-0 self-end border border-destructive/40 bg-background sm:self-auto",
			onClick: r,
			children: n
		})]
	});
}
//#endregion
//#region src/components/organizations/organization-danger-zone.tsx
function uo({ onLeave: e, onDelete: t }) {
	let { t: n } = Z();
	return !e && !t ? null : /* @__PURE__ */ X(co, {
		title: n("organizationSettings.general.dangerZone"),
		children: [e && /* @__PURE__ */ Y(lo, {
			title: n("organizationSettings.general.leaveTitle"),
			description: n("organizationSettings.general.leaveDescription"),
			actionLabel: n("account.organizations.leave"),
			onAction: e
		}), t && /* @__PURE__ */ Y(lo, {
			title: n("organizationSettings.general.deleteTitle"),
			description: n("organizationSettings.general.deleteDescription"),
			actionLabel: n("organizationSettings.general.delete"),
			onAction: t
		})]
	});
}
//#endregion
//#region src/components/organizations/rename-organization-form.tsx
function fo({ name: e, onRename: t, onCancel: n }) {
	let { t: r } = Z(), [i, a] = G(e), [o, s] = G(), [c, l] = G(!1), u = i.trim(), d = async (e) => {
		e.preventDefault(), l(!0), s(void 0);
		try {
			await t(u);
		} catch (e) {
			s(e instanceof Error ? e.message : String(e)), l(!1);
		}
	};
	return /* @__PURE__ */ X("form", {
		className: "flex w-full flex-col gap-2",
		onSubmit: (e) => {
			d(e);
		},
		children: [/* @__PURE__ */ X("div", {
			className: "flex flex-col gap-2 sm:flex-row sm:items-center",
			children: [/* @__PURE__ */ Y(St, {
				autoFocus: !0,
				value: i,
				maxLength: xr,
				"aria-label": r("organizationSettings.general.name"),
				"aria-invalid": o ? !0 : void 0,
				disabled: c,
				className: "min-w-0 sm:flex-1",
				onChange: (e) => {
					a(e.target.value);
				}
			}), /* @__PURE__ */ X("div", {
				className: "flex justify-end gap-2",
				children: [/* @__PURE__ */ Y(I, {
					type: "button",
					variant: "ghost",
					disabled: c,
					onClick: n,
					children: r("organizationSettings.general.cancel")
				}), /* @__PURE__ */ Y(I, {
					type: "submit",
					disabled: c || u === "" || u === e,
					children: r("organizationSettings.general.save")
				})]
			})]
		}), o && /* @__PURE__ */ Y("p", {
			role: "alert",
			className: "text-sm text-destructive",
			children: o
		})]
	});
}
//#endregion
//#region src/components/organizations/organization-identity.tsx
function po({ name: e, createdAt: t, role: n, onRename: r }) {
	let { t: i, i18n: a } = Z(), [o, s] = G(!1), c = new Intl.DateTimeFormat(a.language, {
		day: "numeric",
		month: "long",
		year: "numeric"
	}).format(new Date(t));
	return /* @__PURE__ */ X($, {
		bodyClassName: "px-4 py-0",
		children: [
			/* @__PURE__ */ X("div", {
				className: "flex flex-col gap-1 border-b border-border py-4",
				children: [/* @__PURE__ */ Y("div", {
					className: "text-xs text-muted-foreground",
					children: i("organizationSettings.general.name")
				}), r && o ? /* @__PURE__ */ Y(fo, {
					name: e,
					onRename: async (e) => {
						await r(e), s(!1);
					},
					onCancel: () => {
						s(!1);
					}
				}) : /* @__PURE__ */ X("div", {
					className: "flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4",
					children: [/* @__PURE__ */ Y("span", {
						className: "flex min-h-9 min-w-0 flex-1 items-center truncate text-sm font-medium",
						children: e
					}), r && /* @__PURE__ */ Y(I, {
						variant: "outline",
						className: "self-end sm:self-auto",
						onClick: () => {
							s(!0);
						},
						children: i("organizationSettings.general.rename")
					})]
				})]
			}),
			/* @__PURE__ */ Y(Da, {
				label: i("organizationSettings.general.createdAt"),
				control: /* @__PURE__ */ Y("span", {
					className: "text-sm text-muted-foreground",
					children: c
				})
			}),
			/* @__PURE__ */ Y(Da, {
				label: i("organizationSettings.general.yourRole"),
				control: /* @__PURE__ */ Y(Ka, { role: n })
			})
		]
	});
}
//#endregion
//#region src/pages/organization-general.tsx
function mo() {
	let { t: e } = Z();
	return /* @__PURE__ */ Y(so, {
		title: e("organizationSettings.sections.general"),
		description: e("organizationSettings.general.description"),
		children: (e) => /* @__PURE__ */ Y(ho, { ...e })
	});
}
function ho({ organization: e, rename: t, deleteOrganization: n, leave: r }) {
	let { t: i } = Z(), { showToast: a } = Q(), o = Gt(), [s, c] = G("leave"), [l, u] = G(!1), { name: d, abilities: f } = e, p = (e) => {
		c(e), u(!0);
	}, m = (e) => {
		a(e), o(Ba(ls.organizations), { replace: !0 });
	}, h = {
		leave: {
			title: i("account.organizations.leaveDialog.title", { name: d }),
			description: i("account.organizations.leaveDialog.description"),
			confirmLabel: i("account.organizations.leave"),
			async onConfirm() {
				await r(), m(i("organizationSettings.general.left", { name: d }));
			}
		},
		delete: {
			title: i("organizationSettings.general.deleteDialog.title", { name: d }),
			description: i("organizationSettings.general.deleteDialog.description", { count: e.members.length }),
			confirmLabel: i("organizationSettings.general.delete"),
			async onConfirm() {
				await n(), m(i("organizationSettings.general.deleted", { name: d }));
			}
		}
	};
	return /* @__PURE__ */ X(J, { children: [
		/* @__PURE__ */ Y(po, {
			name: d,
			createdAt: e.createdAt,
			role: e.role,
			onRename: f.update ? async (e) => {
				await t(e), a(i("organizationSettings.general.renamed"));
			} : void 0
		}),
		/* @__PURE__ */ Y(uo, {
			onLeave: f.leave ? () => {
				p("leave");
			} : void 0,
			onDelete: f.delete ? () => {
				p("delete");
			} : void 0
		}),
		/* @__PURE__ */ Y(Ia, {
			isOpen: l,
			...h[s],
			onOpenChange: u
		})
	] });
}
//#endregion
//#region src/components/organizations/invite-member-form.tsx
function go({ onInvite: e }) {
	let { t } = Z(), [n, r] = G(""), [i, a] = G(), [o, s] = G(!1), c = Lt(), l = Lt(), u = async (t) => {
		t.preventDefault(), s(!0), a(void 0);
		try {
			await e(n.trim()), r("");
		} catch (e) {
			a(e instanceof Error ? e.message : String(e));
		} finally {
			s(!1);
		}
	};
	return /* @__PURE__ */ X("form", {
		className: "flex flex-col gap-2",
		onSubmit: (e) => {
			u(e);
		},
		children: [
			/* @__PURE__ */ X("div", {
				className: "flex gap-2",
				children: [/* @__PURE__ */ Y(St, {
					type: "email",
					required: !0,
					value: n,
					placeholder: t("organizationSettings.members.emailPlaceholder"),
					"aria-label": t("organizationSettings.members.emailLabel"),
					"aria-invalid": i ? !0 : void 0,
					"aria-describedby": i ? `${c} ${l}` : l,
					disabled: o,
					onChange: (e) => {
						r(e.target.value);
					}
				}), /* @__PURE__ */ X(I, {
					type: "submit",
					disabled: o || n.trim() === "",
					children: [/* @__PURE__ */ Y(Nn, { "aria-hidden": "true" }), t("organizationSettings.members.invite")]
				})]
			}),
			i && /* @__PURE__ */ Y("p", {
				id: c,
				role: "alert",
				className: "text-sm text-destructive",
				children: i
			}),
			/* @__PURE__ */ Y("p", {
				id: l,
				className: "text-sm text-muted-foreground",
				children: t("organizationSettings.members.inviteHint")
			})
		]
	});
}
//#endregion
//#region src/components/organizations/pending-invitation-item.tsx
function _o({ email: e, createdAt: t, expiresAt: n, onRevoke: r }) {
	let { t: i, i18n: a } = Z(), [o, s] = G(!1), [c, l] = G(), u = (e) => new Intl.DateTimeFormat(a.language, {
		day: "numeric",
		month: "long"
	}).format(new Date(e)), d = async () => {
		s(!0), l(void 0);
		try {
			await r();
		} catch (e) {
			l(e instanceof Error ? e.message : String(e)), s(!1);
		}
	};
	return /* @__PURE__ */ X("div", {
		className: "flex flex-wrap items-center gap-x-3 gap-y-2 py-3",
		children: [
			/* @__PURE__ */ Y(Nn, {
				className: "size-4 shrink-0 text-muted-foreground",
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ X("div", {
				className: "flex min-w-0 flex-1 flex-col gap-0.5",
				children: [/* @__PURE__ */ Y("span", {
					className: "min-w-0 truncate text-sm font-medium",
					children: e
				}), /* @__PURE__ */ Y("span", {
					className: "text-xs text-muted-foreground",
					children: i("organizationSettings.members.pending", {
						sent: u(t),
						expires: u(n)
					})
				})]
			}),
			/* @__PURE__ */ Y(I, {
				variant: "ghost-destructive",
				size: "sm",
				disabled: o,
				"aria-label": i("organizationSettings.members.revokeLabel", { email: e }),
				onClick: () => {
					d();
				},
				children: i("organizationSettings.members.revoke")
			}),
			c && /* @__PURE__ */ Y("p", {
				role: "alert",
				className: "w-full text-sm text-destructive",
				children: c
			})
		]
	});
}
//#endregion
//#region src/components/organizations/member-invitations.tsx
function vo({ invitations: e, onInvite: t, onRevoke: n }) {
	let { t: r } = Z(), { showToast: i } = Q();
	return /* @__PURE__ */ Y($, {
		title: r("organizationSettings.members.inviteTitle"),
		children: /* @__PURE__ */ X("div", {
			className: "flex flex-col gap-4",
			children: [/* @__PURE__ */ Y(go, { onInvite: async (e) => {
				await t(e), i(r("organizationSettings.members.invited", { email: e }));
			} }), e.length > 0 ? /* @__PURE__ */ Y("div", {
				className: "divide-y divide-border rounded-lg border border-border px-4 py-1",
				children: e.map((e) => /* @__PURE__ */ Y(_o, {
					email: e.email,
					createdAt: e.createdAt,
					expiresAt: e.expiresAt,
					onRevoke: async () => {
						await n(e.id), i(r("organizationSettings.members.revoked"));
					}
				}, e.id))
			}) : /* @__PURE__ */ Y("p", {
				className: "text-xs text-muted-foreground",
				children: r("organizationSettings.members.noPending")
			})]
		})
	});
}
//#endregion
//#region src/lib/initials.ts
function yo(e) {
	let t = e.trim().split(/\s+/).filter(Boolean);
	return t.length === 0 ? "?" : t.length === 1 ? t[0].slice(0, 2).toUpperCase() : ((t[0][0] ?? "") + (t.at(-1)?.[0] ?? "")).toUpperCase();
}
//#endregion
//#region src/components/organizations/member-name.ts
function bo() {
	let { t: e } = Z();
	return ({ name: t, email: n }) => t ?? n ?? e("organizationSettings.members.unnamed");
}
//#endregion
//#region src/components/organizations/member-item.tsx
function xo({ name: e, email: t, role: n, joinedAt: r, isSelf: i, isLastAdmin: a = !1, onRoleChange: o, onRemove: s }) {
	let { t: c, i18n: l } = Z(), [u, d] = G(!1), [f, p] = G(), m = bo()({
		name: e,
		email: t
	}), h = new Intl.DateTimeFormat(l.language, {
		day: "numeric",
		month: "long",
		year: "numeric"
	}).format(new Date(r)), g = e ? t : void 0, _ = async (e) => {
		d(!0), p(void 0);
		try {
			await o(e);
		} catch (e) {
			p(e instanceof Error ? e.message : String(e));
		} finally {
			d(!1);
		}
	}, v = c("organizationSettings.members.roleLabel", { name: m }), y = !!(o ?? s);
	return /* @__PURE__ */ X("div", {
		className: "flex flex-wrap items-start gap-x-3 gap-y-2 py-3 sm:items-center",
		children: [
			/* @__PURE__ */ Y(Ua, {
				className: "size-8",
				"aria-hidden": "true",
				children: /* @__PURE__ */ Y(Wa, {
					className: "bg-primary text-primary-foreground text-xs font-medium",
					children: yo(m)
				})
			}),
			/* @__PURE__ */ X("div", {
				className: "flex min-w-0 flex-1 flex-col items-start gap-0.5",
				children: [
					/* @__PURE__ */ Y("span", {
						className: "w-full min-w-0 truncate text-sm font-medium",
						children: i ? c("organizationSettings.members.you", { name: m }) : m
					}),
					/* @__PURE__ */ Y("span", {
						className: "my-0.5 sm:hidden",
						children: /* @__PURE__ */ Y(Ka, { role: n })
					}),
					g && /* @__PURE__ */ Y("span", {
						className: "w-full min-w-0 truncate text-xs text-muted-foreground sm:hidden",
						children: g
					}),
					/* @__PURE__ */ X("span", {
						className: "w-full min-w-0 truncate text-xs text-muted-foreground",
						children: [/* @__PURE__ */ Y("span", {
							className: "sm:hidden",
							children: c("organizationSettings.members.since", { date: h })
						}), /* @__PURE__ */ Y("span", {
							className: "hidden sm:inline",
							children: g ? c("organizationSettings.members.sinceWithEmail", {
								email: g,
								date: h
							}) : c("organizationSettings.members.since", { date: h })
						})]
					})
				]
			}),
			/* @__PURE__ */ X("div", {
				className: "flex items-center gap-2",
				children: [
					/* @__PURE__ */ Y("div", {
						className: "hidden sm:block",
						children: o ? /* @__PURE__ */ X(va, {
							value: n,
							disabled: a || u,
							onValueChange: (e) => {
								_(e);
							},
							children: [/* @__PURE__ */ Y(ba, {
								size: "sm",
								className: "w-40",
								"aria-label": v,
								children: /* @__PURE__ */ Y(ya, {})
							}), /* @__PURE__ */ X(xa, { children: [/* @__PURE__ */ Y(Sa, {
								value: "admin",
								children: c("account.organizations.roles.admin")
							}), /* @__PURE__ */ Y(Sa, {
								value: "member",
								children: c("account.organizations.roles.member")
							})] })]
						}) : /* @__PURE__ */ Y(Ka, { role: n })
					}),
					y && /* @__PURE__ */ X(ot, { children: [/* @__PURE__ */ Y(st, {
						asChild: !0,
						children: /* @__PURE__ */ Y(I, {
							variant: "ghost",
							size: "icon-sm",
							className: M("shrink-0", !s && "sm:hidden"),
							"aria-label": c("organizationSettings.members.actions", { name: m }),
							children: /* @__PURE__ */ Y(Rn, { "aria-hidden": "true" })
						})
					}), /* @__PURE__ */ X(it, {
						align: "end",
						children: [o && /* @__PURE__ */ X(tt, {
							className: "sm:hidden",
							children: [
								/* @__PURE__ */ Y(rt, { children: v }),
								/* @__PURE__ */ X(at, {
									value: n,
									onValueChange: (e) => {
										_(e);
									},
									children: [/* @__PURE__ */ Y(et, {
										value: "admin",
										disabled: a || u,
										children: c("account.organizations.roles.admin")
									}), /* @__PURE__ */ Y(et, {
										value: "member",
										disabled: a || u,
										children: c("account.organizations.roles.member")
									})]
								}),
								s && /* @__PURE__ */ Y(nt, {})
							]
						}), s && /* @__PURE__ */ X($e, {
							variant: "destructive",
							onSelect: s,
							children: [/* @__PURE__ */ Y(dr, { "aria-hidden": "true" }), c("organizationSettings.members.remove")]
						})]
					})] }),
					o && !s && /* @__PURE__ */ Y("span", {
						className: "hidden size-btn-sm shrink-0 sm:block",
						"aria-hidden": "true"
					})
				]
			}),
			a && o && /* @__PURE__ */ Y("p", {
				className: "w-full text-xs text-muted-foreground",
				children: c("organizationSettings.members.lastAdmin")
			}),
			f && /* @__PURE__ */ Y("p", {
				role: "alert",
				className: "w-full text-sm text-destructive",
				children: f
			})
		]
	});
}
//#endregion
//#region src/components/organizations/member-list.tsx
function So({ members: e, selfId: t, onRoleChange: n, onRemove: r }) {
	let { t: i } = Z(), a = e.filter(({ role: e }) => e === "admin").length;
	return /* @__PURE__ */ Y($, {
		title: /* @__PURE__ */ X("span", {
			className: "flex items-baseline justify-between gap-3",
			children: [/* @__PURE__ */ Y("span", { children: i("organizationSettings.members.listTitle", { count: e.length }) }), /* @__PURE__ */ Y("span", {
				className: "text-xs font-normal text-muted-foreground",
				children: i("organizationSettings.members.adminCount", { count: a })
			})]
		}),
		bodyClassName: "px-4 py-1 divide-y divide-border",
		children: e.map((e) => /* @__PURE__ */ Y(xo, {
			name: e.name,
			email: e.email,
			role: e.role,
			joinedAt: e.createdAt,
			isSelf: e.userId === t,
			isLastAdmin: e.role === "admin" && a === 1,
			onRoleChange: n && (async (t) => n(e, t)),
			onRemove: r && e.userId !== t ? () => {
				r(e);
			} : void 0
		}, e.userId))
	});
}
//#endregion
//#region src/pages/organization-members.tsx
function Co() {
	let { t: e } = Z();
	return /* @__PURE__ */ Y(so, {
		title: e("organizationSettings.sections.members"),
		description: e("organizationSettings.members.description"),
		children: (e) => /* @__PURE__ */ Y(wo, { ...e })
	});
}
function wo({ organization: e, invitations: t, invite: n, revoke: r, changeRole: i, removeMember: a }) {
	let { t: o } = Z(), { user: s } = Yr(), { showToast: c } = Q(), [l, u] = G(), [d, f] = G(!1), p = bo(), m = l && p(l);
	return /* @__PURE__ */ X(J, { children: [
		/* @__PURE__ */ Y(So, {
			members: e.members,
			selfId: s?.id,
			onRoleChange: e.abilities.roles ? async (e, t) => {
				await i(e.userId, t);
				let n = p(e);
				c(o(t === "admin" ? "organizationSettings.members.nowAdmin" : "organizationSettings.members.nowMember", { name: n }));
			} : void 0,
			onRemove: e.abilities.members ? (e) => {
				u(e), f(!0);
			} : void 0
		}),
		e.abilities.invite && /* @__PURE__ */ Y(vo, {
			invitations: t,
			onInvite: n,
			onRevoke: r
		}),
		/* @__PURE__ */ Y(Ia, {
			isOpen: d,
			title: o("organizationSettings.members.removeDialog.title", { name: m }),
			description: o("organizationSettings.members.removeDialog.description", { name: m }),
			confirmLabel: o("organizationSettings.members.remove"),
			onOpenChange: f,
			onConfirm: async () => {
				l && (await a(l.userId), f(!1), c(o("organizationSettings.members.removed", { name: m })));
			}
		})
	] });
}
//#endregion
//#region src/components/settings/model-table.tsx
function To(e) {
	return e >= 1e6 ? `${Math.round(e / 1e5) / 10} M` : `${Math.round(e / 1024)} k`;
}
var Eo = {
	"cost+score": "md:grid-cols-[2rem_minmax(0,1fr)_6.5rem_10.5rem_7.5rem_6rem]",
	cost: "md:grid-cols-[2rem_minmax(0,1fr)_6.5rem_7.5rem_6rem]",
	score: "md:grid-cols-[2rem_minmax(0,1fr)_10.5rem_7.5rem_6rem]",
	bare: "md:grid-cols-[2rem_minmax(0,1fr)_7.5rem_6rem]"
};
function Do({ cost: e, score: t }) {
	return `grid grid-cols-[2rem_minmax(0,1fr)] items-center gap-x-3 ${Eo[e ? t ? "cost+score" : "cost" : t ? "score" : "bare"]}`;
}
function Oo({ column: e, align: t, children: n }) {
	let { t: r } = Z();
	return /* @__PURE__ */ X("span", {
		className: M("flex min-w-0 flex-col gap-0.5", t === "right" ? "md:items-end md:text-right" : "md:pl-4"),
		children: [/* @__PURE__ */ Y("span", {
			className: "text-xs text-muted-foreground md:hidden",
			children: r(`settings.model.columns.${e}`)
		}), n]
	});
}
function ko({ children: e }) {
	return /* @__PURE__ */ Y("span", {
		className: "text-xs font-normal text-muted-foreground",
		children: e
	});
}
var Ao = "size-4 shrink-0 cursor-pointer accent-primary", jo = ["cursor-pointer border-2 transition-colors", "has-[:focus-visible]:outline-none has-[:focus-visible]:ring-[length:var(--focus-ring-width)] has-[:focus-visible]:ring-ring/50"].join(" ");
function Mo(e, t) {
	return e ? "border-primary bg-primary/5" : `${t} hover:border-muted-foreground/40 hover:bg-muted/60`;
}
var No = { b: /* @__PURE__ */ Y("strong", { className: "mb-0.5 block font-semibold" }) }, Po = {
	cost: "settings.model.help.cost",
	intelligence: "settings.model.help.intelligence",
	context: "settings.model.help.context",
	vision: "settings.model.help.vision"
};
function Fo({ column: e, align: t }) {
	let { t: n } = Z(), r = n(`settings.model.columns.${e}`);
	return /* @__PURE__ */ X("span", {
		className: M("flex items-center gap-0.5", t === "right" ? "justify-end" : "pl-4"),
		children: [r, /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
			asChild: !0,
			children: /* @__PURE__ */ Y("button", {
				type: "button",
				"aria-label": n("settings.model.about", { column: r }),
				className: "grid size-6 cursor-help place-items-center rounded-full text-muted-foreground hover:bg-muted focus-visible:bg-muted focus-visible:outline-none",
				children: /* @__PURE__ */ Y(kn, { className: "size-3.5" })
			})
		}), /* @__PURE__ */ Y(N, {
			sideOffset: 6,
			className: "max-w-64 py-2.5 text-left text-[13px] leading-relaxed",
			children: /* @__PURE__ */ Y(kr, {
				i18nKey: Po[e],
				components: No
			})
		})] })]
	});
}
function Io({ model: e, shown: t, topScore: n, isSelected: r, onSelect: i }) {
	let { t: a, i18n: o } = Z(), s = new Intl.NumberFormat(o.language, { maximumFractionDigits: 1 });
	return /* @__PURE__ */ X("label", {
		className: M(Do(t), jo, Mo(r, "border-border bg-card md:border-transparent md:bg-transparent"), "min-h-15 rounded-lg px-3 py-3 md:py-2"),
		children: [
			/* @__PURE__ */ Y("input", {
				type: "radio",
				name: "model",
				value: e.id,
				checked: r,
				className: Ao,
				onChange: i
			}),
			/* @__PURE__ */ X("span", {
				className: "flex min-w-0 flex-col gap-0.5",
				children: [/* @__PURE__ */ X("span", {
					className: "flex flex-wrap items-center gap-2 font-semibold",
					children: [e.label, e.isDefault && /* @__PURE__ */ Y(Ea, {
						variant: "muted",
						className: "rounded-full",
						children: a("settings.model.recommended.badge")
					})]
				}), /* @__PURE__ */ Y("span", {
					className: "text-xs text-muted-foreground",
					children: e.vendorLabel
				})]
			}),
			/* @__PURE__ */ X("span", {
				className: "col-start-2 mt-2 grid grid-cols-2 gap-x-4 gap-y-2 md:contents",
				children: [
					t.cost && /* @__PURE__ */ Y(Oo, {
						column: "cost",
						align: "right",
						children: /* @__PURE__ */ Y("span", {
							className: "font-semibold tabular-nums",
							children: e.costRatio === void 0 ? /* @__PURE__ */ Y(ko, { children: a("settings.model.missing.cost") }) : `×${s.format(e.costRatio)}`
						})
					}),
					t.score && /* @__PURE__ */ Y(Oo, {
						column: "intelligence",
						align: "left",
						children: e.intelligence === void 0 ? /* @__PURE__ */ Y(ko, { children: a("settings.model.missing.intelligence") }) : /* @__PURE__ */ X("span", {
							className: "flex items-center gap-2.5",
							children: [/* @__PURE__ */ Y("span", {
								className: "w-6 text-right font-semibold tabular-nums",
								children: Math.round(e.intelligence)
							}), /* @__PURE__ */ Y("span", {
								className: "h-1.5 flex-1 overflow-hidden rounded-full bg-muted",
								"aria-hidden": "true",
								children: /* @__PURE__ */ Y("span", {
									className: "block h-full rounded-full bg-primary",
									style: { width: `${Math.round(e.intelligence / n * 100)}%` }
								})
							})]
						})
					}),
					/* @__PURE__ */ Y(Oo, {
						column: "context",
						align: "right",
						children: /* @__PURE__ */ Y("span", {
							className: "font-semibold tabular-nums",
							children: e.contextWindow === void 0 ? /* @__PURE__ */ Y(ko, { children: a("settings.model.missing.context") }) : To(e.contextWindow)
						})
					}),
					/* @__PURE__ */ Y(Oo, {
						column: "vision",
						align: "left",
						children: e.capabilities.includes("vision") ? /* @__PURE__ */ Y(sn, { className: "size-4 text-success" }) : /* @__PURE__ */ Y(mr, { className: "size-4 text-destructive" })
					})
				]
			})
		]
	});
}
function Lo({ models: e, value: t, onChange: n }) {
	let { t: r } = Z(), i = {
		cost: e.some((e) => e.costRatio !== void 0),
		score: e.some((e) => e.intelligence !== void 0)
	}, a = Math.max(1, ...e.map((e) => e.intelligence ?? 0));
	return /* @__PURE__ */ Y("div", {
		className: "overflow-x-auto",
		children: /* @__PURE__ */ X("div", {
			className: "text-sm md:min-w-[44rem] md:rounded-xl md:border md:border-border md:bg-card md:px-3 md:pt-2 md:pb-3 md:shadow-sm",
			children: [/* @__PURE__ */ X("div", {
				className: M(Do(i), "hidden border-b border-border px-3 pt-3 pb-2.5 font-semibold md:grid"),
				children: [
					/* @__PURE__ */ Y("span", {}),
					/* @__PURE__ */ Y("span", { children: r("settings.model.columns.model") }),
					i.cost && /* @__PURE__ */ Y(Fo, {
						column: "cost",
						align: "right"
					}),
					i.score && /* @__PURE__ */ Y(Fo, {
						column: "intelligence",
						align: "left"
					}),
					/* @__PURE__ */ Y(Fo, {
						column: "context",
						align: "right"
					}),
					/* @__PURE__ */ Y(Fo, {
						column: "vision",
						align: "left"
					})
				]
			}), /* @__PURE__ */ Y("div", {
				className: "flex flex-col gap-1.5 md:pt-1.5",
				children: e.map((e) => /* @__PURE__ */ Y(Io, {
					model: e,
					shown: i,
					topScore: a,
					isSelected: e.id === t,
					onSelect: () => {
						n(e.id);
					}
				}, e.id))
			})]
		})
	});
}
//#endregion
//#region src/components/settings/unavailable-models.tsx
var Ro = {
	retired: {
		title: "settings.model.retired.title",
		explanation: "settings.model.retired.explanation"
	},
	restricted: {
		title: "settings.model.restricted.title",
		explanation: "settings.model.restricted.explanation"
	}
};
function zo({ models: e, status: t }) {
	let { t: n } = Z(), [r, i] = G(!1), a = `${t}-models`;
	return /* @__PURE__ */ X("section", {
		className: "flex flex-col gap-2 border-t border-border pt-2",
		children: [
			/* @__PURE__ */ X("button", {
				type: "button",
				"aria-expanded": r,
				"aria-controls": a,
				className: "inline-flex min-h-11 cursor-pointer items-center gap-2.5 self-start rounded-lg py-2 pr-3 pl-2 font-semibold hover:bg-muted",
				onClick: () => {
					i((e) => !e);
				},
				children: [
					/* @__PURE__ */ Y(pn, { className: M("size-4.5 transition-transform", r && "rotate-90") }),
					n(Ro[t].title),
					/* @__PURE__ */ X("span", {
						className: "font-medium text-muted-foreground",
						children: [
							"(",
							e.length,
							")"
						]
					})
				]
			}),
			/* @__PURE__ */ Y("p", {
				className: "ml-9 text-xs leading-relaxed text-muted-foreground",
				children: n(Ro[t].explanation)
			}),
			r && /* @__PURE__ */ Y("ul", {
				id: a,
				className: "mt-1 ml-9 flex flex-col gap-1.5",
				children: e.map((e) => /* @__PURE__ */ X("li", {
					className: "flex flex-col gap-0.5 rounded-xl border border-dashed border-border bg-muted/40 px-4 py-3",
					children: [/* @__PURE__ */ Y("span", {
						className: "font-semibold text-muted-foreground",
						children: e.label
					}), /* @__PURE__ */ Y("span", {
						className: "text-xs text-muted-foreground",
						children: e.vendorLabel
					})]
				}, e.id))
			})
		]
	});
}
//#endregion
//#region src/components/settings/model-select.tsx
function Bo(e, t) {
	return e.vendorLabel.localeCompare(t.vendorLabel) || (e.costRatio ?? Infinity) - (t.costRatio ?? Infinity) || e.label.localeCompare(t.label);
}
function Vo({ models: e, value: t, onChange: n }) {
	let { t: r } = Z(), i = e.find((e) => e.id === t), a = e.find((e) => e.isDefault)?.label ?? "…", o = e.filter((e) => e.status === "offered").sort(Bo), s = e.filter((e) => e.status === "restricted"), c = e.filter((e) => e.status === "retired"), l = t === void 0, u = (() => {
		if (t && !i) return r("settings.model.unknownWithFallback", {
			id: t,
			fallback: a
		});
		if (i?.status === "retired") return r("settings.model.retiredWithFallback", {
			name: i.label,
			fallback: a
		});
		if (i?.status === "restricted") return r("settings.model.restrictedPreference", { name: i.label });
	})();
	return /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-7",
		children: [
			u && /* @__PURE__ */ Y(xt, {
				variant: "warning",
				children: u
			}),
			/* @__PURE__ */ X("fieldset", {
				className: "flex min-w-0 flex-col gap-3",
				children: [
					/* @__PURE__ */ Y("legend", {
						className: "sr-only",
						children: r("settings.model.legend")
					}),
					/* @__PURE__ */ X("label", {
						className: M(jo, Mo(l, "border-border bg-card"), "flex items-center gap-4 rounded-xl px-5 py-4"),
						children: [/* @__PURE__ */ Y("input", {
							type: "radio",
							name: "model",
							value: "",
							checked: l,
							className: Ao,
							onChange: () => {
								n(null);
							}
						}), /* @__PURE__ */ X("span", {
							className: "flex flex-col gap-1",
							children: [/* @__PURE__ */ X("span", {
								className: "flex items-center gap-2 font-semibold",
								children: [/* @__PURE__ */ Y(ir, { className: "size-4" }), r("settings.model.recommended.title")]
							}), /* @__PURE__ */ Y("span", {
								className: "text-sm text-muted-foreground",
								children: r("settings.model.recommended.hint", { name: a })
							})]
						})]
					}),
					/* @__PURE__ */ Y("div", {
						className: "my-1 flex items-center gap-3 text-sm text-muted-foreground before:h-px before:flex-1 before:bg-border after:h-px after:flex-1 after:bg-border",
						children: r("settings.model.pickHint")
					}),
					/* @__PURE__ */ Y(Lo, {
						models: o,
						value: t,
						onChange: n
					})
				]
			}),
			s.length > 0 && /* @__PURE__ */ Y(zo, {
				models: s,
				status: "restricted"
			}),
			c.length > 0 && /* @__PURE__ */ Y(zo, {
				models: c,
				status: "retired"
			})
		]
	});
}
//#endregion
//#region src/pages/models.tsx
function Ho() {
	let { t: e } = Z(), [t, n] = G(), [r, a] = G([]);
	return H(() => {
		let e = !1;
		return (async () => {
			let [t, r] = await Promise.allSettled([Ve(), i()]);
			e || (t.status === "fulfilled" && n(t.value), r.status === "fulfilled" && a(r.value));
		})(), () => {
			e = !0;
		};
	}, []), /* @__PURE__ */ Y(_a, {
		title: e("settings.sections.models"),
		description: e("settings.model.description"),
		isHeaderTitleHidden: !0,
		children: t === void 0 ? /* @__PURE__ */ Y("div", { className: "h-96 animate-pulse rounded-xl bg-muted" }) : r.length === 0 ? /* @__PURE__ */ Y("p", {
			className: "text-sm text-muted-foreground",
			children: e("settings.model.empty")
		}) : /* @__PURE__ */ Y(Vo, {
			models: r,
			value: t.model,
			onChange: (e) => {
				n((t) => t && {
					...t,
					model: e ?? void 0
				}), O({ model: e });
			}
		})
	});
}
//#endregion
//#region src/components/settings/subscription/use-subscription-format.ts
function Uo() {
	let { i18n: e } = Z();
	return U(() => {
		let t = new Intl.DateTimeFormat(e.language, {
			day: "numeric",
			month: "long",
			year: "numeric"
		}), n = new Intl.DateTimeFormat(e.language, {
			day: "numeric",
			month: "short",
			year: "numeric"
		}), r = new Intl.NumberFormat(e.language), i = new Intl.NumberFormat(e.language, { maximumFractionDigits: 2 });
		return {
			factor: (e) => i.format(e),
			rate: (e) => `×${i.format(e)}`,
			date: (e) => t.format(e),
			range: (e, t) => n.formatRange(e, t),
			credits: (e) => r.format(e)
		};
	}, [e.language]);
}
//#endregion
//#region src/components/settings/subscription/plan-card.tsx
function Wo(e) {
	let { t } = Z(), n = Uo(), { endsAt: r, cancelledAt: i, scheduled: a, isSelfService: o } = e, s = i !== void 0 && r !== void 0, c = o && e.isPaid && !r && !a;
	return /* @__PURE__ */ Y($, {
		title: t("settings.subscription.plan.title"),
		children: /* @__PURE__ */ X("div", {
			className: "flex flex-col gap-stack",
			children: [
				/* @__PURE__ */ X("div", {
					className: "flex items-start justify-between gap-stack",
					children: [/* @__PURE__ */ Y(Go, {
						planName: e.planName,
						isPaid: e.isPaid,
						coefficient: e.coefficient,
						termPeriods: e.termPeriods,
						renewsAt: e.renewsAt,
						commitmentEndsAt: e.commitmentEndsAt,
						endsAt: r,
						cancelledAt: i
					}), o && !a && /* @__PURE__ */ Y(I, {
						size: "sm",
						variant: "outline",
						onClick: e.onChangePlan,
						children: t("settings.subscription.plan.change")
					})]
				}),
				a && /* @__PURE__ */ Y(Ko, {
					action: o && t("settings.subscription.plan.cancelScheduled"),
					onAction: e.onCancelScheduled,
					children: t("settings.subscription.plan.scheduled", {
						plan: a.planName,
						date: n.date(a.startsAt)
					})
				}),
				c && /* @__PURE__ */ Y("div", {
					className: "border-t border-border pt-section-sm",
					children: /* @__PURE__ */ Y(I, {
						size: "sm",
						variant: "link",
						className: "h-auto px-0 text-muted-foreground hover:text-destructive",
						onClick: e.onCancel,
						children: t("settings.subscription.plan.cancel")
					})
				}),
				s && o && !a && /* @__PURE__ */ Y("div", {
					className: "border-t border-border pt-section-sm",
					children: /* @__PURE__ */ Y(I, {
						size: "sm",
						variant: "link",
						className: "h-auto px-0",
						onClick: e.onWithdrawCancellation,
						children: t("settings.subscription.plan.withdraw")
					})
				}),
				!o && /* @__PURE__ */ Y("div", {
					className: "border-t border-border pt-section-sm text-xs text-muted-foreground",
					children: e.managedNotice ?? t("settings.subscription.plan.managed")
				})
			]
		})
	});
}
function Go({ planName: e, isPaid: t, coefficient: n, termPeriods: r, renewsAt: i, commitmentEndsAt: a, endsAt: o, cancelledAt: s }) {
	let { t: c } = Z(), l = Uo();
	return /* @__PURE__ */ X("div", {
		className: "flex min-w-0 flex-1 flex-col gap-1",
		children: [
			/* @__PURE__ */ X("div", {
				className: "flex flex-wrap items-center gap-inline",
				children: [
					/* @__PURE__ */ Y("span", {
						className: "text-lg font-semibold",
						children: e
					}),
					!t && /* @__PURE__ */ Y(Ea, {
						variant: "muted",
						children: c("settings.subscription.plan.free")
					}),
					r > 1 && /* @__PURE__ */ Y(Ea, {
						variant: "outline",
						children: c("settings.subscription.plan.commitment", { count: r })
					}),
					s && /* @__PURE__ */ Y(Ea, {
						variant: "outline",
						children: c("settings.subscription.plan.cancelledBadge")
					})
				]
			}),
			(o ?? i) && /* @__PURE__ */ X("p", {
				className: "text-sm text-muted-foreground",
				children: [o ? c("settings.subscription.plan.endsAt", { date: l.date(o) }) : i && c("settings.subscription.plan.renewsAt", { date: l.date(i) }), o && s && ` · ${c("settings.subscription.plan.cancelled", { date: l.date(s) })}`]
			}),
			r > 1 && !o && a && /* @__PURE__ */ Y("p", {
				className: "text-sm text-muted-foreground",
				children: c("settings.subscription.plan.commitmentUntil", { date: l.date(a) })
			}),
			n !== 1 && /* @__PURE__ */ Y("p", {
				className: "text-sm text-muted-foreground",
				children: c("settings.subscription.plan.rate", {
					rate: l.rate(n),
					coefficient: l.factor(n)
				})
			})
		]
	});
}
function Ko({ children: e, action: t, onAction: n }) {
	return /* @__PURE__ */ X("div", {
		className: "flex flex-wrap items-center justify-between gap-inline rounded-lg bg-muted px-section-sm py-2 text-sm",
		children: [/* @__PURE__ */ Y("span", { children: e }), t && /* @__PURE__ */ Y(I, {
			size: "sm",
			variant: "link",
			className: "h-auto px-0",
			onClick: n,
			children: t
		})]
	});
}
//#endregion
//#region src/components/settings/subscription/usage-card.tsx
function qo({ period: e, planCredits: t, recharges: n, isBlocked: r, nextGrantAt: i }) {
	let { t: a } = Z(), o = Uo(), s = t.granted > 0 ? Math.min(100, Math.round(t.consumed / t.granted * 100)) : 0;
	return /* @__PURE__ */ Y($, {
		title: a("settings.subscription.usage.title"),
		description: a("settings.subscription.usage.period", { range: o.range(e.startsAt, e.endsAt) }),
		children: /* @__PURE__ */ X("div", {
			className: "flex flex-col gap-stack",
			children: [
				/* @__PURE__ */ X("div", {
					className: "flex flex-col gap-inline",
					children: [/* @__PURE__ */ X("div", {
						className: "flex items-baseline justify-between gap-stack text-sm",
						children: [/* @__PURE__ */ Y("span", {
							className: "font-medium",
							children: a("settings.subscription.usage.planCredits")
						}), t.granted > 0 && /* @__PURE__ */ X("span", {
							className: "tabular-nums",
							children: [/* @__PURE__ */ Y("span", {
								className: "font-medium",
								children: o.credits(t.consumed)
							}), /* @__PURE__ */ X("span", {
								className: "text-muted-foreground",
								children: [" / ", o.credits(t.granted)]
							})]
						})]
					}), t.granted > 0 ? /* @__PURE__ */ Y("div", {
						role: "progressbar",
						"aria-valuenow": s,
						"aria-valuemin": 0,
						"aria-valuemax": 100,
						className: "h-2 w-full overflow-hidden rounded-full bg-muted",
						children: /* @__PURE__ */ Y("div", {
							className: M("h-full rounded-full", r ? "bg-destructive" : "bg-primary"),
							style: { width: `${s}%` }
						})
					}) : /* @__PURE__ */ Y("p", {
						className: "text-sm text-muted-foreground",
						children: a("settings.subscription.usage.noCredits")
					})]
				}),
				n && /* @__PURE__ */ X("div", {
					className: "flex flex-col gap-inline border-t border-border pt-section",
					children: [/* @__PURE__ */ Y("span", {
						className: "text-sm font-medium",
						children: a("settings.subscription.usage.recharges")
					}), /* @__PURE__ */ X("dl", {
						className: "grid grid-cols-2 gap-stack",
						children: [/* @__PURE__ */ X("div", {
							className: "flex flex-col gap-0.5",
							children: [/* @__PURE__ */ Y("dt", {
								className: "text-xs text-muted-foreground",
								children: a("settings.subscription.usage.rechargesUsed")
							}), /* @__PURE__ */ Y("dd", {
								className: "text-base font-medium tabular-nums",
								children: o.credits(n.consumedThisPeriod)
							})]
						}), /* @__PURE__ */ X("div", {
							className: "flex flex-col gap-0.5",
							children: [/* @__PURE__ */ Y("dt", {
								className: "text-xs text-muted-foreground",
								children: a("settings.subscription.usage.rechargesRemaining")
							}), /* @__PURE__ */ Y("dd", {
								className: "text-base font-medium tabular-nums",
								children: o.credits(n.remaining)
							})]
						})]
					})]
				}),
				r && (t.granted > 0 || n) && /* @__PURE__ */ X("p", {
					className: "rounded-lg bg-destructive/10 px-section-sm py-2 text-sm text-destructive",
					children: [a("settings.subscription.usage.blocked"), i && ` ${a("settings.subscription.usage.nextGrant", { date: o.date(i) })}`]
				})
			]
		})
	});
}
//#endregion
//#region src/components/settings/subscription/change-plan-dialog.tsx
function Jo({ isOpen: e, onOpenChange: t, plans: n, onChoose: r, isApplying: i = !1, initialChoiceId: a }) {
	let { t: o } = Z(), [s, c] = G(a), [l, u] = G(e);
	e !== l && (u(e), e && c(void 0));
	let d = n.find((e) => e.id === s), f = n.some((e) => e.coefficient !== 1);
	return /* @__PURE__ */ Y(Qe, {
		open: e,
		onOpenChange: t,
		children: /* @__PURE__ */ Y(Xe, {
			className: "sm:max-w-lg",
			showCloseButton: !i,
			children: d ? /* @__PURE__ */ Y(Zo, {
				choice: d,
				isApplying: i,
				onBack: () => {
					c(void 0);
				},
				onConfirm: () => {
					r(d);
				}
			}) : /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: o("settings.subscription.changeDialog.title") }), /* @__PURE__ */ Y(qe, { children: o("settings.subscription.changeDialog.description") })] }), /* @__PURE__ */ Y("ul", {
				className: "flex flex-col gap-inline",
				children: n.map((e) => /* @__PURE__ */ Y(Yo, {
					plan: e,
					isRateShown: f,
					onChoose: c
				}, e.id))
			})] })
		})
	});
}
function Yo({ plan: e, isRateShown: t, onChoose: n }) {
	let { t: r } = Z(), i = Uo(), { effect: a } = e;
	return /* @__PURE__ */ X("li", {
		className: "flex items-center justify-between gap-stack rounded-lg border border-border p-section-sm",
		children: [/* @__PURE__ */ X("div", {
			className: "flex min-w-0 flex-col gap-0.5",
			children: [
				/* @__PURE__ */ X("div", {
					className: "flex flex-wrap items-center gap-inline",
					children: [
						/* @__PURE__ */ Y("span", {
							className: "font-medium",
							children: e.name
						}),
						!e.isPaid && /* @__PURE__ */ Y(Ea, {
							variant: "muted",
							children: r("settings.subscription.plan.free")
						}),
						e.isCurrent && /* @__PURE__ */ Y(Ea, {
							variant: "outline",
							children: r("settings.subscription.changeDialog.current")
						})
					]
				}),
				/* @__PURE__ */ X("span", {
					className: "text-sm text-muted-foreground",
					children: [r("settings.subscription.changeDialog.credits", { credits: i.credits(e.periodCredits) }), t && ` · ${r("settings.subscription.changeDialog.rate", { rate: i.rate(e.coefficient) })}`]
				}),
				!e.isCurrent && /* @__PURE__ */ Y(Xo, { effect: a })
			]
		}), !e.isCurrent && /* @__PURE__ */ Y(I, {
			size: "sm",
			variant: a.kind === "now" ? "default" : "outline",
			disabled: a.kind === "unavailable",
			onClick: () => {
				n(e.id);
			},
			children: r("settings.subscription.changeDialog.choose")
		})]
	});
}
function Xo({ effect: e }) {
	let { t } = Z(), n = Uo();
	return /* @__PURE__ */ X("span", {
		className: "text-xs text-muted-foreground",
		children: [
			e.kind === "now" && t("settings.subscription.changeDialog.now"),
			e.kind === "termEnd" && t("settings.subscription.changeDialog.termEnd", { date: n.date(e.at) }),
			e.kind === "unavailable" && t("settings.subscription.changeDialog.unavailable")
		]
	});
}
function Zo({ choice: e, isApplying: t, onBack: n, onConfirm: r }) {
	let { t: i } = Z(), a = Uo();
	return /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: i("settings.subscription.changeDialog.confirmTitle", { plan: e.name }) }), /* @__PURE__ */ Y(qe, { children: e.effect.kind === "termEnd" ? i("settings.subscription.changeDialog.confirmTermEnd", {
		plan: e.name,
		date: a.date(e.effect.at)
	}) : i("settings.subscription.changeDialog.confirmNow", { plan: e.name }) })] }), /* @__PURE__ */ X(Ke, { children: [/* @__PURE__ */ Y(I, {
		variant: "ghost",
		disabled: t,
		onClick: n,
		children: i("settings.subscription.changeDialog.back")
	}), /* @__PURE__ */ Y(I, {
		disabled: t,
		onClick: r,
		children: i(t ? "settings.subscription.changeDialog.applying" : "settings.subscription.changeDialog.confirm")
	})] })] });
}
//#endregion
//#region src/components/settings/subscription/cancel-subscription-dialog.tsx
function Qo({ isOpen: e, onOpenChange: t, endsAt: n, onConfirm: r, isCancelling: i = !1 }) {
	let { t: a } = Z(), o = Uo();
	return /* @__PURE__ */ Y(Qe, {
		open: e,
		onOpenChange: t,
		children: /* @__PURE__ */ X(Xe, {
			showCloseButton: !i,
			children: [/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: a("settings.subscription.cancelDialog.title") }), /* @__PURE__ */ Y(qe, { children: a("settings.subscription.cancelDialog.description", { date: o.date(n) }) })] }), /* @__PURE__ */ X(Ke, { children: [/* @__PURE__ */ Y(I, {
				variant: "ghost",
				disabled: i,
				onClick: () => {
					t(!1);
				},
				children: a("settings.subscription.cancelDialog.keep")
			}), /* @__PURE__ */ Y(I, {
				variant: "destructive",
				disabled: i,
				onClick: r,
				children: a(i ? "settings.subscription.cancelDialog.cancelling" : "settings.subscription.cancelDialog.confirm")
			})] })]
		})
	});
}
//#endregion
//#region src/components/settings/subscription/subscription-view.ts
var $o = (e) => Math.round(e / _r);
function es(e, t) {
	if (e.plan.limits.periodCredits === 0) return;
	let n = Tr(new Date(e.subscription.anchorAt), t).endsAt, { endsAt: r } = e.subscription;
	return r && n >= new Date(r) ? void 0 : n;
}
function ts(e, t) {
	return Sr({
		anchorAt: new Date(e.subscription.anchorAt),
		termStartsAt: new Date(e.subscription.termStartsAt),
		termPeriods: e.plan.termPeriods
	}, t);
}
function ns(e, t) {
	let { current: n, scheduled: r } = e, { plan: i, subscription: a } = n, o = a.cancelledAt ? new Date(a.cancelledAt) : void 0, s = r !== void 0 && !o;
	return {
		planName: i.name,
		isPaid: i.paid,
		coefficient: i.limits.coefficient,
		termPeriods: i.termPeriods,
		renewsAt: s ? void 0 : es(n, t),
		commitmentEndsAt: i.termPeriods > 1 ? ts(n, t) : void 0,
		endsAt: !s && a.endsAt ? new Date(a.endsAt) : void 0,
		cancelledAt: o,
		scheduled: r && {
			planName: r.plan.name,
			startsAt: new Date(r.subscription.startsAt)
		},
		isSelfService: e.isSelfService
	};
}
function rs(e, t, n) {
	if (e.paid) return { kind: "unavailable" };
	let r = Er({
		effectiveAt: n,
		target: Dr(e),
		current: t && {
			...Dr(t.plan),
			anchorAt: new Date(t.subscription.anchorAt),
			termStartsAt: new Date(t.subscription.termStartsAt)
		}
	});
	return r.status === "granted" ? { kind: "now" } : r.status === "waits" ? {
		kind: "termEnd",
		at: r.until
	} : { kind: "unavailable" };
}
function is(e, t) {
	let { current: n } = e, r = e.eligible.filter((e) => e.id !== n?.plan.id), i = (e, r) => ({
		id: e.id,
		name: e.name,
		periodCredits: e.limits.periodCredits,
		coefficient: e.limits.coefficient,
		isPaid: e.paid,
		isCurrent: r,
		effect: r ? { kind: "now" } : rs(e, n, t)
	});
	return [...n ? [i(n.plan, !0)] : [], ...r.map((e) => i(e, !1))];
}
function as(e, t) {
	return {
		period: {
			startsAt: new Date(e.period.startsAt),
			endsAt: new Date(e.period.endsAt)
		},
		planCredits: {
			granted: $o(e.planCredits.granted),
			consumed: $o(e.planCredits.consumed)
		},
		recharges: e.recharges && {
			consumedThisPeriod: $o(e.recharges.consumedThisPeriod),
			remaining: $o(Math.max(e.recharges.remaining, 0))
		},
		isBlocked: e.blocked,
		nextGrantAt: t
	};
}
//#endregion
//#region src/pages/subscription.tsx
function os() {
	let { t: e } = Z(), { credits: t, refresh: n } = Li(), r = da("SubscriptionManagedNotice"), { showToast: i } = Q(), [a, o] = G(), [s, c] = G(!1), [l, u] = G(), [d, f] = G(!1), p = W(/* @__PURE__ */ new Map()), m = B(async () => {
		try {
			o(await v()), c(!1);
		} catch {
			c(!0);
		}
	}, []);
	H(() => {
		m();
	}, [m]);
	let h = async (t) => {
		f(!0);
		try {
			await t();
		} catch (t) {
			i(await y(t) ?? e("settings.subscription.actionFailed"), "error");
			return;
		} finally {
			f(!1);
		}
		p.current.clear(), u(void 0), await Promise.all([m(), n()]);
	}, g = s ? void 0 : a?.current, _ = /* @__PURE__ */ new Date();
	return /* @__PURE__ */ X(_a, {
		title: e("settings.sections.subscription"),
		description: e("settings.subscription.description"),
		isHeaderTitleHidden: !0,
		children: [
			/* @__PURE__ */ X("div", {
				className: "flex flex-col gap-stack-lg",
				children: [
					s && /* @__PURE__ */ X("div", {
						className: "flex flex-col items-center gap-stack",
						children: [/* @__PURE__ */ Y(R, {
							variant: "error",
							title: e("settings.subscription.loadFailed")
						}), /* @__PURE__ */ Y(I, {
							variant: "outline",
							size: "sm",
							onClick: () => {
								m();
							},
							children: e("settings.subscription.retry")
						})]
					}),
					a && g && /* @__PURE__ */ Y(Wo, {
						...ns({
							...a,
							current: g
						}, _),
						managedNotice: r ? /* @__PURE__ */ Y(r, {}) : void 0,
						onChangePlan: () => {
							u("change");
						},
						onCancel: () => {
							u("cancel");
						},
						onWithdrawCancellation: () => {
							h(ne);
						},
						onCancelScheduled: () => {
							h(Se);
						}
					}),
					t && /* @__PURE__ */ Y(qo, { ...as(t, g && es(g, _)) })
				]
			}),
			a && g && /* @__PURE__ */ Y(Jo, {
				isOpen: l === "change",
				plans: is(a, _),
				isApplying: d,
				onOpenChange: (e) => {
					u(e ? "change" : void 0);
				},
				onChoose: (e) => {
					let t = p.current.get(e.id) ?? crypto.randomUUID();
					p.current.set(e.id, t), h(async () => A(e.id, t, e.effect.kind === "termEnd" ? "termEnd" : "now"));
				}
			}),
			g && /* @__PURE__ */ Y(ss, {
				current: g,
				isOpen: l === "cancel",
				isApplying: d,
				onOpenChange: (e) => {
					u(e ? "cancel" : void 0);
				},
				onConfirm: () => {
					h(ke);
				}
			})
		]
	});
}
function ss({ current: e, isOpen: t, isApplying: n, onOpenChange: r, onConfirm: i }) {
	return /* @__PURE__ */ Y(Qo, {
		isOpen: t,
		endsAt: ts(e, /* @__PURE__ */ new Date()),
		isCancelling: n,
		onOpenChange: r,
		onConfirm: i
	});
}
//#endregion
//#region src/components/layout/settings-sections.tsx
var cs = {
	agent: "agent",
	models: "models",
	subscription: "subscription"
}, ls = {
	preferences: "preferences",
	organizations: "organizations"
};
function us(e, t) {
	return e === t || e.startsWith(`${t}/`);
}
function ds(e) {
	return us(e, La);
}
function fs(e) {
	return us(e, Ra);
}
function ps() {
	let { t: e } = Z(), { agent: t, models: n, subscription: r } = cs;
	return [
		{
			id: t,
			path: t,
			label: e("settings.sections.agent"),
			icon: /* @__PURE__ */ Y(rn, { className: "size-4" }),
			element: /* @__PURE__ */ Y(Na, {})
		},
		{
			id: n,
			path: n,
			label: e("settings.sections.models"),
			icon: /* @__PURE__ */ Y(ir, { className: "size-4" }),
			element: /* @__PURE__ */ Y(Ho, {})
		},
		{
			id: r,
			path: r,
			label: e("settings.sections.subscription"),
			icon: /* @__PURE__ */ Y(vn, { className: "size-4" }),
			element: /* @__PURE__ */ Y(os, {})
		}
	];
}
function ms() {
	let { t: e } = Z(), { preferences: t, organizations: n } = ls;
	return [{
		id: t,
		path: t,
		label: e("account.sections.preferences"),
		icon: /* @__PURE__ */ Y(rr, { className: "size-4" }),
		element: /* @__PURE__ */ Y(Pa, {})
	}, {
		id: n,
		path: n,
		label: e("account.sections.organizations"),
		icon: /* @__PURE__ */ Y(on, { className: "size-4" }),
		element: /* @__PURE__ */ Y(to, {})
	}];
}
var hs = z({
	settings: [],
	account: []
});
function gs({ settingsSections: e, accountSections: t, children: n }) {
	let r = U(() => ({
		settings: e ?? [],
		account: t ?? []
	}), [e, t]);
	return /* @__PURE__ */ Y(hs.Provider, {
		value: r,
		children: n
	});
}
function _s() {
	return V(hs).settings;
}
function vs() {
	return V(hs).account;
}
function ys(e) {
	let t = _s().find((t) => t.id === e);
	return t && za(t.path);
}
function bs(e) {
	let { t } = Z(), n = V(hs)[e];
	if (n.length !== 0) return e === "settings" ? {
		basePath: La,
		title: t("settings.title"),
		sections: n
	} : {
		basePath: Ra,
		title: t("account.myAccount"),
		sections: n
	};
}
var xs = [{
	id: "general",
	path: "general",
	element: /* @__PURE__ */ Y(mo, {})
}, {
	id: "members",
	path: "members",
	element: /* @__PURE__ */ Y(Co, {})
}], Ss = `${Va}/:organizationId`;
function Cs() {
	let { t: e } = Z(), t = {
		general: {
			label: e("organizationSettings.sections.general"),
			icon: /* @__PURE__ */ Y(rr, { className: "size-4" })
		},
		members: {
			label: e("organizationSettings.sections.members"),
			icon: /* @__PURE__ */ Y(pr, { className: "size-4" })
		}
	};
	return xs.map((e) => ({
		...e,
		...t[e.id]
	}));
}
function ws(e) {
	return e.some(({ id: e }) => e === ls.organizations);
}
function Ts() {
	let { t: e } = Z(), { pathname: t } = Wt(), n = bs("settings"), r = bs("account"), i = Cs();
	if (ds(t)) return n;
	if (fs(t)) return r;
	let a = Ut(`${Ss}/*`, t)?.params.organizationId;
	if (a && r && ws(r.sections)) return {
		basePath: Ha(a),
		title: e("organizationSettings.title"),
		sections: i
	};
}
function Es(e) {
	return Os(La, e);
}
function Ds(e) {
	let t = e.find((e) => e.id === ls.preferences);
	return /* @__PURE__ */ X(J, { children: [
		Os(Ra, e),
		ws(e) && Os(Ss, xs, /* @__PURE__ */ Y(ao, {})),
		t && /* @__PURE__ */ Y(Vt, {
			path: za("general"),
			element: /* @__PURE__ */ Y(ks, { to: Ba(t.path) })
		})
	] });
}
function Os(e, t, n = /* @__PURE__ */ Y(Bt, {})) {
	if (t.length === 0) return null;
	let r = `${e}/${t[0].path}`;
	return /* @__PURE__ */ X(Vt, {
		path: e,
		element: n,
		children: [
			/* @__PURE__ */ Y(Vt, {
				index: !0,
				element: /* @__PURE__ */ Y(ks, { to: r })
			}),
			t.map((e) => /* @__PURE__ */ Y(Vt, {
				path: e.path,
				element: e.element
			}, e.id)),
			/* @__PURE__ */ Y(Vt, {
				path: "*",
				element: /* @__PURE__ */ Y(ks, { to: r })
			})
		]
	});
}
function ks({ to: e }) {
	let t = Wt();
	return /* @__PURE__ */ Y(zt, {
		to: Ht(e, qt()),
		replace: !0,
		state: t.state
	});
}
//#endregion
//#region src/components/layout/settings-nav.tsx
function As(e, t, n, r) {
	return us(n, e) ? !0 : r && (n === t || n === `${t}/`);
}
function js({ basePath: e, title: t, sections: n, mode: r, onItemClick: i, isHeaderHidden: a = !1, className: o }) {
	let { t: s } = Z(), c = Wt(), { pathname: l } = c, u = us(l, e) ? c.state?.from ?? "/" : l;
	return /* @__PURE__ */ X("div", {
		className: M("flex flex-col gap-3", r === "compact" && "items-center", o),
		children: [
			!a && (r === "compact" ? /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
				asChild: !0,
				children: /* @__PURE__ */ Y(K, {
					to: u,
					"aria-label": s("account.back"),
					onClick: i,
					className: "flex h-[38px] w-[38px] items-center justify-center rounded-md text-muted-foreground transition-colors hover:text-foreground",
					children: /* @__PURE__ */ Y($t, {
						className: "size-4",
						"aria-hidden": "true"
					})
				})
			}), /* @__PURE__ */ Y(N, {
				side: "right",
				children: s("account.back")
			})] }) : /* @__PURE__ */ Y(ha, {
				to: u,
				label: s("account.back"),
				onClick: i,
				className: "py-2"
			})),
			!a && r !== "compact" && /* @__PURE__ */ Y("h2", {
				className: "px-3 text-base font-semibold tracking-tight text-foreground",
				children: t
			}),
			/* @__PURE__ */ Y("nav", {
				"aria-label": t,
				className: M("flex flex-col gap-1", r === "compact" ? "items-center" : "items-stretch"),
				children: n.map((t, a) => {
					let o = `${e}/${t.path}`, s = As(o, e, l, a === 0);
					return /* @__PURE__ */ X(Nt, { children: [r !== "compact" && !!t.group && t.group !== n[a - 1]?.group && /* @__PURE__ */ Y("div", {
						className: "px-3 pb-1 pt-3 text-xs font-medium uppercase tracking-wide text-muted-foreground first:pt-0",
						children: t.group
					}), /* @__PURE__ */ Y(Ms, {
						section: t,
						url: o,
						isActive: s,
						mode: r,
						backTo: u,
						onItemClick: i
					})] }, t.id);
				})
			})
		]
	});
}
function Ms({ section: e, url: t, isActive: n, mode: r, backTo: i, onItemClick: a }) {
	let o = M("group/settings-item flex items-center rounded-md text-sidebar-foreground transition-colors cursor-pointer", "outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring/50", n ? "bg-foreground text-background" : "hover:bg-foreground/8"), s = { from: i };
	return r === "compact" ? /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
		asChild: !0,
		children: /* @__PURE__ */ Y(K, {
			to: t,
			state: s,
			"aria-current": n ? "page" : void 0,
			"aria-label": e.label,
			className: M(o, "h-[38px] w-[38px] justify-center"),
			onClick: a,
			children: e.icon
		})
	}), /* @__PURE__ */ Y(N, {
		side: "right",
		children: e.label
	})] }) : /* @__PURE__ */ X(K, {
		to: t,
		state: s,
		"aria-current": n ? "page" : void 0,
		className: M(o, "h-9 gap-2 px-3 text-[13.5px] font-medium"),
		onClick: a,
		children: [/* @__PURE__ */ Y("span", {
			className: "flex size-4 shrink-0 items-center justify-center",
			children: e.icon
		}), /* @__PURE__ */ Y("span", {
			className: "truncate",
			children: e.label
		})]
	});
}
//#endregion
//#region src/components/layout/user-account-menu.tsx
function Ns() {
	let e = Xr();
	if (!e) return {
		displayName: "",
		initials: "?",
		isLoading: !1
	};
	if (e.isLoading || !e.user) return {
		displayName: "",
		initials: "?",
		isLoading: !0
	};
	let t = e.user.name ?? e.user.email ?? e.user.id;
	return {
		displayName: t,
		initials: yo(t),
		subline: e.user.email && e.user.email !== t ? e.user.email : void 0,
		isLoading: !1
	};
}
function Ps({ isCompact: e, displayName: t, initials: n, isLoading: r, trailing: i }) {
	return r ? /* @__PURE__ */ X("div", {
		className: "flex w-full items-center gap-2",
		children: [/* @__PURE__ */ Y("div", { className: "size-7 shrink-0 animate-pulse rounded-full bg-muted-foreground/20" }), !e && /* @__PURE__ */ Y("div", { className: "h-4 flex-1 animate-pulse rounded bg-muted-foreground/20" })]
	}) : /* @__PURE__ */ X(J, { children: [
		/* @__PURE__ */ Y(Ua, {
			className: "size-7",
			children: /* @__PURE__ */ Y(Wa, {
				className: "bg-primary text-primary-foreground text-xs font-medium",
				children: n
			})
		}),
		!e && /* @__PURE__ */ Y("span", {
			className: "min-w-0 flex-1 truncate text-sm font-medium text-foreground",
			children: t
		}),
		!e && i
	] });
}
function Fs() {
	let e = Gt(), t = Wt();
	return (n) => {
		e(n, { state: { from: t.pathname } });
	};
}
function Is({ isCompact: e = !1, logout: t }) {
	let { t: n } = Z(), r = Xr(), i = Ns(), a = Fs(), o = _s().length > 0, s = vs().length > 0;
	return r ? /* @__PURE__ */ X(ot, { children: [/* @__PURE__ */ Y(st, {
		"aria-label": i.displayName || i.initials,
		className: M("group flex items-center rounded-md text-left transition-colors cursor-pointer hover:bg-foreground/8", "outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring/50", e ? "h-[38px] w-[38px] justify-center p-0" : "h-9 w-full gap-2 px-2"),
		children: /* @__PURE__ */ Y(Ps, {
			isCompact: e,
			displayName: i.displayName,
			initials: i.initials,
			isLoading: i.isLoading
		})
	}), /* @__PURE__ */ X(it, {
		align: e ? "start" : "end",
		side: "top",
		sideOffset: 8,
		className: "min-w-[220px]",
		children: [
			o && /* @__PURE__ */ X($e, {
				onSelect: () => {
					a("/settings");
				},
				children: [/* @__PURE__ */ Y(Qn, { className: "size-4" }), n("account.settings")]
			}),
			o && (s || t) && /* @__PURE__ */ Y(nt, {}),
			s && /* @__PURE__ */ X($e, {
				onSelect: () => {
					a("/account");
				},
				children: [/* @__PURE__ */ Y(fr, { className: "size-4" }), n("account.myAccount")]
			}),
			t && /* @__PURE__ */ X($e, {
				variant: "destructive",
				onSelect: () => {
					t();
				},
				children: [/* @__PURE__ */ Y(Mn, { className: "size-4" }), n("account.logout")]
			})
		]
	})] }) : null;
}
function Ls({ onOpenAccount: e }) {
	let t = Xr(), n = Ns();
	return t ? /* @__PURE__ */ Y("button", {
		type: "button",
		"aria-label": n.displayName || n.initials,
		className: M("group flex w-full items-center gap-2 rounded-md px-2 py-2 text-left transition-colors cursor-pointer hover:bg-foreground/8", "outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring/50"),
		onClick: e,
		children: /* @__PURE__ */ Y(Ps, {
			isCompact: !1,
			displayName: n.displayName,
			initials: n.initials,
			isLoading: n.isLoading,
			trailing: /* @__PURE__ */ Y(pn, {
				className: "size-4 text-muted-foreground",
				"aria-hidden": "true"
			})
		})
	}) : null;
}
function Rs({ logout: e, onBack: t, onOpenPanel: n, onCloseDrawer: r }) {
	let { t: i } = Z(), a = Ns(), o = _s().length > 0, s = vs().length > 0;
	return /* @__PURE__ */ X("div", {
		className: "flex h-full flex-col",
		children: [
			/* @__PURE__ */ Y(Bs, { onBack: t }),
			/* @__PURE__ */ X("div", {
				className: "flex-1 overflow-y-auto p-3",
				children: [/* @__PURE__ */ X("div", {
					className: "flex items-center gap-3 rounded-lg border bg-card p-3",
					children: [/* @__PURE__ */ Y(Ua, {
						className: "size-10",
						children: /* @__PURE__ */ Y(Wa, {
							className: "bg-primary text-primary-foreground text-sm font-medium",
							children: a.initials
						})
					}), /* @__PURE__ */ X("div", {
						className: "min-w-0 flex-1",
						children: [/* @__PURE__ */ Y("p", {
							className: "truncate text-sm font-semibold text-foreground",
							children: a.displayName
						}), a.subline && /* @__PURE__ */ Y("p", {
							className: "truncate text-xs text-muted-foreground",
							children: a.subline
						})]
					})]
				}), (o || s) && /* @__PURE__ */ X("div", {
					className: "mt-3 flex flex-col",
					children: [
						o && /* @__PURE__ */ Y(zs, {
							icon: /* @__PURE__ */ Y(Qn, { className: "size-4 text-muted-foreground" }),
							label: i("account.settings"),
							onClick: () => {
								n("settings");
							}
						}),
						o && s && /* @__PURE__ */ Y("div", {
							role: "separator",
							className: "my-1 h-px bg-border"
						}),
						s && /* @__PURE__ */ Y(zs, {
							icon: /* @__PURE__ */ Y(fr, { className: "size-4 text-muted-foreground" }),
							label: i("account.myAccount"),
							onClick: () => {
								n("account");
							}
						})
					]
				})]
			}),
			e && /* @__PURE__ */ Y("div", {
				className: "shrink-0 border-t border-sidebar-border p-3",
				children: /* @__PURE__ */ X(I, {
					type: "button",
					variant: "ghost-destructive",
					className: "w-full justify-center gap-2",
					onClick: () => {
						r(), e();
					},
					children: [/* @__PURE__ */ Y(Mn, { className: "size-4" }), i("account.logout")]
				})
			})
		]
	});
}
function zs({ icon: e, label: t, onClick: n }) {
	return /* @__PURE__ */ X("button", {
		type: "button",
		className: "flex h-11 items-center gap-3 rounded-md px-3 text-left text-sm font-medium text-foreground cursor-pointer hover:bg-foreground/8",
		onClick: n,
		children: [e, t]
	});
}
function Bs({ title: e, onBack: t }) {
	let { t: n } = Z();
	return /* @__PURE__ */ X("header", {
		className: "flex h-13 shrink-0 items-center gap-2 border-b border-sidebar-border px-2",
		children: [/* @__PURE__ */ Y(I, {
			type: "button",
			variant: "ghost",
			size: "icon",
			className: "size-10",
			"aria-label": n("account.back"),
			onClick: t,
			children: /* @__PURE__ */ Y($t, { className: "size-5" })
		}), e && /* @__PURE__ */ Y("h2", {
			className: "text-base font-semibold",
			children: e
		})]
	});
}
//#endregion
//#region src/components/layout/app-sidebar.tsx
function Vs({ isCompact: e, logout: t }) {
	let { t: n } = Z(), r = Ts();
	return /* @__PURE__ */ Y("aside", {
		"aria-label": n("nav.primary"),
		className: "flex h-full shrink-0 flex-col overflow-hidden border-r border-sidebar-border bg-sidebar text-sidebar-foreground",
		style: { width: e ? 60 : 248 },
		children: r ? /* @__PURE__ */ Y("div", {
			className: M("flex-1 overflow-y-auto px-3 py-4", e && "flex flex-col items-center px-0"),
			children: /* @__PURE__ */ Y(js, {
				...r,
				mode: e ? "compact" : "expanded"
			})
		}) : /* @__PURE__ */ X(J, { children: [
			/* @__PURE__ */ Y("div", {
				className: M("flex items-center gap-2 px-3 pt-4", e && "justify-center px-0"),
				children: /* @__PURE__ */ Y(pa, { isCompact: e })
			}),
			/* @__PURE__ */ Y("div", {
				className: M("px-3 pt-4", e && "flex justify-center px-0"),
				children: /* @__PURE__ */ Y(ma, { isCompact: e })
			}),
			/* @__PURE__ */ Y("div", {
				className: M("flex-1 overflow-y-auto px-3 py-4", e && "flex flex-col items-center px-0"),
				children: /* @__PURE__ */ Y(oa, { mode: e ? "compact" : "expanded" })
			}),
			/* @__PURE__ */ Y("div", {
				className: M("flex h-header-height shrink-0 items-center border-t border-sidebar-border px-2", e && "justify-center px-0"),
				children: /* @__PURE__ */ Y(Is, {
					isCompact: e,
					logout: t
				})
			})
		] })
	});
}
//#endregion
//#region src/components/layout/app-mobile-topbar.tsx
function Hs({ onOpenDrawer: e }) {
	let { t } = Z(), { mobileTitle: n, mobileTrailing: r } = qi();
	return /* @__PURE__ */ X("header", {
		className: "flex shrink-0 items-center gap-2 border-b border-sidebar-border bg-sidebar px-3",
		style: { height: 52 },
		children: [
			/* @__PURE__ */ Y(I, {
				type: "button",
				variant: "ghost",
				size: "icon",
				"aria-label": t("sidebar.openMenu"),
				className: "size-10",
				onClick: e,
				children: /* @__PURE__ */ Y(Fn, { className: "size-5" })
			}),
			/* @__PURE__ */ Y("div", {
				className: "flex min-w-0 flex-1 items-center justify-center",
				children: n ? /* @__PURE__ */ Y("span", {
					className: "truncate text-base font-semibold text-foreground",
					children: n
				}) : /* @__PURE__ */ Y(pa, {})
			}),
			r ?? /* @__PURE__ */ Y("div", { className: "size-10" })
		]
	});
}
//#endregion
//#region src/components/layout/app-mobile-drawer.tsx
function Us({ isOpen: e, onOpenChange: t, logout: n }) {
	let { t: r } = Z(), [i, a] = G("main"), o = (e) => {
		e || a("main"), t(e);
	}, s = () => {
		o(!1);
	};
	return /* @__PURE__ */ Y(Lr.Root, {
		open: e,
		onOpenChange: o,
		children: /* @__PURE__ */ X(Lr.Portal, { children: [/* @__PURE__ */ Y(Lr.Overlay, { className: M("fixed inset-0 z-50 bg-foreground/40", "data-[state=open]:animate-in data-[state=open]:fade-in-0", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0") }), /* @__PURE__ */ X(Lr.Content, {
			"aria-describedby": void 0,
			className: M("fixed inset-y-0 left-0 z-50 flex flex-col bg-sidebar text-sidebar-foreground shadow-[8px_0_28px_rgba(0,0,0,0.18)]", "duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=open]:slide-in-from-left data-[state=closed]:slide-out-to-left"),
			style: { width: 296 },
			children: [
				/* @__PURE__ */ Y(Lr.Title, {
					className: "sr-only",
					children: r("sidebar.menu")
				}),
				i === "main" && /* @__PURE__ */ Y(Gs, {
					onOpenAccount: () => {
						a("userMenu");
					},
					onCloseDrawer: s
				}),
				i === "userMenu" && /* @__PURE__ */ Y(Rs, {
					logout: n,
					onBack: () => {
						a("main");
					},
					onOpenPanel: (e) => {
						a({ panel: e });
					},
					onCloseDrawer: s
				}),
				typeof i == "object" && /* @__PURE__ */ Y(Ws, {
					kind: i.panel,
					onBack: () => {
						a("userMenu");
					},
					onCloseDrawer: s
				})
			]
		})] })
	});
}
function Ws({ kind: e, onBack: t, onCloseDrawer: n }) {
	let r = bs(e);
	return r ? /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y(Bs, {
		title: r.title,
		onBack: t
	}), /* @__PURE__ */ Y("div", {
		className: "flex-1 overflow-y-auto px-3 py-4",
		children: /* @__PURE__ */ Y(js, {
			...r,
			isHeaderHidden: !0,
			mode: "mobile",
			onItemClick: n
		})
	})] }) : null;
}
function Gs({ onOpenAccount: e, onCloseDrawer: t }) {
	let n = Ts();
	return n ? /* @__PURE__ */ Y("div", {
		className: "flex-1 overflow-y-auto px-3 py-4",
		children: /* @__PURE__ */ Y(js, {
			...n,
			mode: "mobile",
			onItemClick: t
		})
	}) : /* @__PURE__ */ X(J, { children: [
		/* @__PURE__ */ Y("div", {
			className: "px-3 pt-4",
			children: /* @__PURE__ */ Y(pa, {})
		}),
		/* @__PURE__ */ Y("div", {
			className: "px-3 pt-4",
			children: /* @__PURE__ */ Y(ma, { onNavigate: t })
		}),
		/* @__PURE__ */ Y("div", {
			className: "flex-1 overflow-y-auto px-3 py-4",
			children: /* @__PURE__ */ Y(oa, {
				mode: "mobile",
				onItemClick: t
			})
		}),
		/* @__PURE__ */ Y("div", {
			className: "shrink-0 border-t border-sidebar-border px-2 py-2 empty:hidden",
			children: /* @__PURE__ */ Y(Ls, { onOpenAccount: e })
		})
	] });
}
//#endregion
//#region src/components/layout/app-shell.tsx
function Ks({ children: e, logout: t }) {
	return /* @__PURE__ */ Y(ta, { children: /* @__PURE__ */ Y(Ki, { children: /* @__PURE__ */ Y(qs, {
		logout: t,
		children: e
	}) }) });
}
function qs({ children: e, logout: t }) {
	let n = Ui(), { isCompact: r } = na(), [i, a] = G(!1);
	return n ? /* @__PURE__ */ X("div", {
		className: "flex h-dvh flex-col overflow-hidden bg-background",
		children: [
			/* @__PURE__ */ Y(Hs, { onOpenDrawer: () => {
				a(!0);
			} }),
			/* @__PURE__ */ Y("main", {
				className: "relative flex-1 min-h-0 overflow-hidden",
				children: e
			}),
			/* @__PURE__ */ Y(Us, {
				isOpen: i,
				onOpenChange: a,
				logout: t
			})
		]
	}) : /* @__PURE__ */ X("div", {
		className: "flex h-dvh overflow-hidden bg-background",
		children: [/* @__PURE__ */ Y(Vs, {
			isCompact: r,
			logout: t
		}), /* @__PURE__ */ X("div", {
			className: "flex min-w-0 flex-1 flex-col overflow-hidden",
			children: [/* @__PURE__ */ Y(ra, {}), /* @__PURE__ */ Y("main", {
				className: "min-h-0 flex-1 overflow-hidden",
				children: e
			})]
		})]
	});
}
//#endregion
//#region src/hooks/use-sync-user-language.ts
function Js() {
	let { i18n: e } = Z();
	H(() => {
		let t = !1;
		return (async () => {
			try {
				let { language: n } = await Ve();
				t || Aa(e, n);
			} catch {}
		})(), () => {
			t = !0;
		};
	}, [e]);
}
//#endregion
//#region src/pages/no-plan.tsx
function Ys({ message: e, logout: t }) {
	let { t: n } = Z(), r = da("PlanChooser"), [i, a] = G(), o = W(/* @__PURE__ */ new Map());
	return H(() => {
		let e = !1;
		return (async () => {
			let t = [];
			try {
				({eligible: t} = await v());
			} catch {}
			e || a(t);
		})(), () => {
			e = !0;
		};
	}, []), i === void 0 ? /* @__PURE__ */ Y("div", {
		className: "flex h-screen w-full items-center justify-center",
		children: /* @__PURE__ */ Y(q, { className: "h-8 w-8 animate-spin text-muted-foreground" })
	}) : i.length === 0 ? /* @__PURE__ */ Y(Xs, {
		logout: t,
		message: e
	}) : Y(r || Zs, {
		choose: async (e) => {
			let t = o.current.get(e) ?? crypto.randomUUID();
			o.current.set(e, t), await Be(A(e, t), n("noPlan.chooseFailed")), globalThis.location.reload();
		},
		logout: t,
		plans: i
	});
}
function Xs({ message: e, logout: t }) {
	let { t: n } = Z();
	return /* @__PURE__ */ Y(Et, {
		icon: /* @__PURE__ */ Y("div", {
			className: "rounded-full bg-muted p-6",
			children: /* @__PURE__ */ Y(On, { className: "h-12 w-12 text-muted-foreground" })
		}),
		title: e,
		action: /* @__PURE__ */ X("div", {
			className: "flex gap-2",
			children: [/* @__PURE__ */ Y(I, {
				onClick: () => {
					globalThis.location.reload();
				},
				children: n("noPlan.retry")
			}), t && /* @__PURE__ */ Y(I, {
				variant: "outline",
				onClick: () => {
					t();
				},
				children: n("account.logout")
			})]
		}),
		className: "h-screen w-full bg-background px-4"
	});
}
function Zs({ plans: e, choose: t, logout: n }) {
	let { t: r } = Z(), [i, a] = G(), [o, s] = G(), c = async (e) => {
		a(e), s(void 0);
		try {
			await t(e);
		} catch (e) {
			s(e instanceof Error ? e.message : r("noPlan.chooseFailed")), a(void 0);
		}
	};
	return /* @__PURE__ */ Y("div", {
		className: "h-dvh w-full overflow-y-auto bg-background",
		children: /* @__PURE__ */ X("div", {
			className: "mx-auto flex min-h-full w-full max-w-xl flex-col justify-center gap-4 px-4 py-10",
			children: [
				/* @__PURE__ */ X("div", {
					className: "flex flex-col gap-1",
					children: [/* @__PURE__ */ Y("h1", {
						className: "text-xl font-semibold",
						children: r("noPlan.chooseTitle")
					}), /* @__PURE__ */ Y("p", {
						className: "text-sm text-muted-foreground",
						children: r("noPlan.chooseDescription")
					})]
				}),
				e.map((e) => /* @__PURE__ */ Y($, {
					layout: "inline",
					title: e.name,
					description: e.paid ? r("noPlan.paid") : r("noPlan.creditsPerPeriod", { credits: e.limits.periodCredits }),
					action: /* @__PURE__ */ Y(I, {
						disabled: e.paid || i !== void 0,
						onClick: () => {
							c(e.id);
						},
						children: i === e.id ? /* @__PURE__ */ Y(q, { className: "h-4 w-4 animate-spin" }) : r("noPlan.choose")
					})
				}, e.id)),
				o && /* @__PURE__ */ Y("p", {
					role: "alert",
					className: "text-sm text-destructive",
					children: o
				}),
				n && /* @__PURE__ */ Y(I, {
					className: "self-start",
					variant: "ghost",
					onClick: () => {
						n();
					},
					children: r("account.logout")
				})
			]
		})
	});
}
//#endregion
//#region src/playground.tsx
function Qs() {
	return Js(), null;
}
function $s({ logout: e }) {
	let { activeConversationId: t, ensureConversationForFiles: n, isLoading: r } = Bi();
	return /* @__PURE__ */ Y(fi, {
		conversationId: t,
		ensureConversation: n,
		children: /* @__PURE__ */ Y(gi, {
			conversationId: t,
			isStreaming: r,
			children: /* @__PURE__ */ Y(xi, {
				conversationId: t,
				children: /* @__PURE__ */ Y(Ks, {
					logout: e,
					children: /* @__PURE__ */ Y(Bt, {})
				})
			})
		})
	});
}
function ec({ loginPage: e, brand: t, logout: n, settingsSections: r, accountSections: i }) {
	let a = Xr(), [o, s] = G(!1), [c, l] = G();
	if (H(() => (_e(() => {
		s(!0);
	}), re((e) => {
		l(e);
	}), () => {
		_e(void 0), re(void 0);
	}), []), a) {
		if (a.isLoading) return /* @__PURE__ */ Y("div", {
			className: "flex h-screen w-full items-center justify-center",
			children: /* @__PURE__ */ Y(q, { className: "h-8 w-8 animate-spin text-muted-foreground" })
		});
		if (!a.isAuthenticated || o) return e;
	}
	return c === void 0 ? /* @__PURE__ */ X(ua, {
		manifest: t,
		children: [/* @__PURE__ */ Y(Qs, {}), /* @__PURE__ */ Y(gs, {
			settingsSections: r,
			accountSections: i,
			children: /* @__PURE__ */ Y(ti, { children: /* @__PURE__ */ Y(ii, { children: /* @__PURE__ */ Y(Ue, {
				delayDuration: 0,
				children: /* @__PURE__ */ Y(Ii, { children: /* @__PURE__ */ Y(zi, { children: (e) => /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y($s, { logout: n }), /* @__PURE__ */ Y(Hi, {
					isOpen: e.open,
					onOpenChange: e.onOpenChange,
					conversationTitle: e.conversationTitle,
					onConfirm: () => {
						e.onConfirm();
					},
					isDeleting: e.isDeleting
				})] }) }) })
			}) }) })
		})]
	}) : /* @__PURE__ */ Y(ua, {
		manifest: t,
		children: /* @__PURE__ */ Y(Ys, {
			logout: n,
			message: c
		})
	});
}
//#endregion
//#region src/components/ui/drop-zone.tsx
function tc({ label: e }) {
	return /* @__PURE__ */ X("div", {
		className: "animate-in zoom-in-95 slide-in-from-bottom-2 flex flex-col items-center gap-3 duration-200",
		children: [/* @__PURE__ */ Y("div", {
			className: "flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 ring-1 ring-inset ring-primary/20",
			children: /* @__PURE__ */ Y(ur, {
				className: "h-7 w-7 text-primary",
				strokeWidth: 1.5
			})
		}), /* @__PURE__ */ Y(L, {
			variant: "caption",
			weight: "semibold",
			color: "primary",
			children: e
		})]
	});
}
function nc(e) {
	return !!e?.types?.includes("Files");
}
async function rc(e) {
	let { items: t, files: n } = e;
	if (!t) return [...n].map((e) => ({ file: e }));
	let r = [];
	for (let e of t) {
		if (e.kind !== "file") continue;
		let t = e.webkitGetAsEntry();
		t && r.push(t);
	}
	if (r.length === 0) return [...n].map((e) => ({ file: e }));
	try {
		let { traverseFileTree: e } = await import("./file-tree-utils-BKASVvlU.js"), t = [], i = [];
		for (let n of r) i.push(e(n, "", t));
		return await Promise.all(i), t.length > 0 ? t : [...n].map((e) => ({ file: e }));
	} catch (e) {
		return console.warn("[DropZone] Failed to traverse file tree, falling back to flat file list", e), [...n].map((e) => ({ file: e }));
	}
}
function ic({ onDrop: e, onError: t, label: n = "Drop files or folders here", isActive: r, className: i, children: a, fullPage: o = !1, disabled: s = !1 }) {
	let [c, l] = G(!1), u = W(null), d = W(0), f = !s && (r ?? c), p = W(e), m = W(t), h = W(s);
	H(() => {
		p.current = e, m.current = t, h.current = s;
	});
	let g = B(async (e) => {
		let t = p.current;
		if (!(h.current || !t)) try {
			let n = await rc(e);
			n.length > 0 && await t(n.map((e) => e.file), n.map((e) => e.path));
		} catch (e) {
			m.current?.(e);
		}
	}, []);
	H(() => {
		if (!o || s) return;
		let e = (e) => {
			nc(e.dataTransfer) && (d.current += 1, l(!0));
		}, t = (e) => {
			nc(e.dataTransfer) && (e.preventDefault(), e.dataTransfer && (e.dataTransfer.dropEffect = "copy"));
		}, n = () => {
			d.current = Math.max(0, d.current - 1), d.current === 0 && l(!1);
		}, r = (e) => {
			e.preventDefault(), d.current = 0, l(!1), e.dataTransfer && g(e.dataTransfer);
		};
		return globalThis.addEventListener("dragenter", e), globalThis.addEventListener("dragover", t), globalThis.addEventListener("dragleave", n), globalThis.addEventListener("drop", r), () => {
			globalThis.removeEventListener("dragenter", e), globalThis.removeEventListener("dragover", t), globalThis.removeEventListener("dragleave", n), globalThis.removeEventListener("drop", r), d.current = 0;
		};
	}, [
		o,
		s,
		g
	]);
	let _ = () => {
		u.current && clearTimeout(u.current), u.current = setTimeout(() => {
			l(!1);
		}, 200);
	};
	return o ? /* @__PURE__ */ X("div", {
		className: i,
		children: [a, f && Vr(/* @__PURE__ */ X("div", {
			role: "status",
			"aria-live": "polite",
			"aria-label": n,
			className: "animate-in fade-in fixed inset-0 z-50 flex items-center justify-center bg-background/90 backdrop-blur-sm duration-150",
			children: [/* @__PURE__ */ Y("div", { className: "absolute inset-4 rounded-xl border-2 border-dashed border-primary/60" }), /* @__PURE__ */ Y(tc, { label: n })]
		}), document.body)]
	}) : /* @__PURE__ */ X("div", {
		className: M("relative", i),
		role: "region",
		"aria-label": n,
		onDrop: async (e) => {
			e.preventDefault(), e.stopPropagation(), u.current && clearTimeout(u.current), l(!1), await g(e.dataTransfer);
		},
		onDragOver: (e) => {
			e.preventDefault(), e.stopPropagation(), _();
		},
		onDragEnter: (e) => {
			e.preventDefault(), e.stopPropagation(), l(!0);
		},
		onDragLeave: (e) => {
			e.preventDefault(), e.stopPropagation();
			let t = e.currentTarget.getBoundingClientRect(), { clientX: n, clientY: r } = e;
			(n <= t.left || n >= t.right || r <= t.top || r >= t.bottom) && l(!1);
		},
		children: [a, f && /* @__PURE__ */ Y("div", {
			role: "status",
			"aria-live": "polite",
			className: "animate-in fade-in absolute inset-1.5 z-10 flex items-center justify-center rounded-md border-2 border-dashed border-primary/60 bg-background/90 backdrop-blur-sm duration-150",
			children: /* @__PURE__ */ Y(tc, { label: n })
		})]
	});
}
//#endregion
//#region src/components/chat-input-attachments.tsx
function ac(e) {
	return e.split("/").pop() || e;
}
function oc() {
	let { t: e } = Z(), { attached: t, detach: n } = Si(), { files: r, uploads: i } = pi(), { files: a } = _i();
	H(() => {
		for (let e of t) e.origin === "user" && i.some((t) => t.path === e.path && t.error) && n(e);
	}, [
		t,
		i,
		n
	]);
	let o = t.map((e) => {
		if (e.origin === "workflow") {
			let t = a.find((t) => t.path === e.path);
			return t ? {
				ref: e,
				name: ac(t.path)
			} : void 0;
		}
		let t = r.find((t) => t.path === e.path);
		if (t) return {
			ref: e,
			name: ac(t.path)
		};
		let n = i.find((t) => t.path === e.path && !t.error);
		return n ? {
			ref: e,
			name: ac(n.path),
			progress: n.progress
		} : void 0;
	}).filter((e) => e !== void 0);
	return o.length === 0 ? null : /* @__PURE__ */ Y("div", {
		className: "flex w-full flex-wrap items-center gap-2 p-3",
		children: o.map(({ ref: t, name: r, progress: i }) => {
			let { Icon: a, color: o } = lt(r);
			return /* @__PURE__ */ X("div", {
				className: "flex h-8 select-none items-center gap-1.5 rounded-md border border-border px-1.5 text-sm font-medium",
				children: [
					/* @__PURE__ */ Y(a, { className: M("h-4 w-4 shrink-0", o) }),
					/* @__PURE__ */ Y("span", {
						className: "max-w-48 truncate text-xs",
						children: r
					}),
					i !== void 0 && /* @__PURE__ */ X("span", {
						className: "shrink-0 font-mono text-[10px] text-muted-foreground",
						children: [i, "%"]
					}),
					/* @__PURE__ */ Y("button", {
						type: "button",
						"aria-label": e("fileSystem.detach"),
						className: "shrink-0 rounded p-0.5 text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground",
						onClick: () => {
							n(t);
						},
						children: /* @__PURE__ */ Y(gr, { className: "h-3 w-3" })
					})
				]
			}, `${t.origin}:${t.path}`);
		})
	});
}
//#endregion
//#region src/components/ui/popover.tsx
function sc(e) {
	return /* @__PURE__ */ Y(Hr.Root, {
		"data-slot": "popover",
		...e
	});
}
function cc(e) {
	return /* @__PURE__ */ Y(Hr.Trigger, {
		"data-slot": "popover-trigger",
		...e
	});
}
function lc(e) {
	return /* @__PURE__ */ Y(Hr.Anchor, {
		"data-slot": "popover-anchor",
		...e
	});
}
function uc({ className: e, align: t = "center", sideOffset: n = 4, ...r }) {
	return /* @__PURE__ */ Y(Hr.Portal, { children: /* @__PURE__ */ Y(Hr.Content, {
		"data-slot": "popover-content",
		align: t,
		sideOffset: n,
		className: M("z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none", "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95", e),
		...r
	}) });
}
//#endregion
//#region src/components/ui/command.tsx
function dc({ className: e, ...t }) {
	return /* @__PURE__ */ Y(Ur, {
		"data-slot": "command",
		className: M("bg-popover text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md", e),
		...t
	});
}
function fc({ className: e, ...t }) {
	return /* @__PURE__ */ X("div", {
		"data-slot": "command-input-wrapper",
		className: "flex h-9 items-center gap-2 border-b px-3",
		children: [/* @__PURE__ */ Y(Xn, { className: "size-4 shrink-0 opacity-50" }), /* @__PURE__ */ Y(Ur.Input, {
			"data-slot": "command-input",
			className: M("placeholder:text-muted-foreground flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50", e),
			...t
		})]
	});
}
function pc({ className: e, ...t }) {
	return /* @__PURE__ */ Y(Ur.List, {
		"data-slot": "command-list",
		className: M("max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto", e),
		...t
	});
}
function mc({ ...e }) {
	return /* @__PURE__ */ Y(Ur.Empty, {
		"data-slot": "command-empty",
		className: "py-6 text-center text-sm",
		...e
	});
}
function hc({ className: e, ...t }) {
	return /* @__PURE__ */ Y(Ur.Group, {
		"data-slot": "command-group",
		className: M("text-foreground [&_[cmdk-group-heading]]:text-muted-foreground overflow-hidden p-1 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium", e),
		...t
	});
}
function gc({ className: e, ...t }) {
	return /* @__PURE__ */ Y(Ur.Separator, {
		"data-slot": "command-separator",
		className: M("bg-border -mx-1 h-px", e),
		...t
	});
}
function _c({ className: e, ...t }) {
	return /* @__PURE__ */ Y(Ur.Item, {
		"data-slot": "command-item",
		className: M("data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
		...t
	});
}
//#endregion
//#region src/components/ui/input-group.tsx
function vc({ className: e, ...t }) {
	return /* @__PURE__ */ Y("div", {
		"data-slot": "input-group",
		role: "group",
		className: M("group/input-group border-input dark:bg-input/30 relative flex w-full items-center rounded-md border shadow-xs transition-[color,box-shadow] outline-none", "h-9 min-w-0 has-[>textarea]:h-auto", "has-[>[data-align=inline-start]]:[&>input]:pl-2", "has-[>[data-align=inline-end]]:[&>input]:pr-2", "has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3", "has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3", "has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot=input-group-control]:focus-visible]:ring-[length:var(--focus-ring-width)]", "has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[[data-slot][aria-invalid=true]]:border-destructive dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40", e),
		...t
	});
}
var yc = Rr("text-muted-foreground flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium select-none [&>svg:not([class*='size-'])]:size-4 [&>kbd]:rounded-[calc(var(--radius)-5px)] group-data-[disabled=true]/input-group:opacity-50", {
	variants: { align: {
		"inline-start": "order-first pl-3 has-[>button]:ml-[-0.45rem] has-[>kbd]:ml-[-0.35rem]",
		"inline-end": "order-last pr-3 has-[>button]:mr-[-0.45rem] has-[>kbd]:mr-[-0.35rem]",
		"block-start": "order-first w-full justify-start px-3 pt-3 [.border-b]:pb-3 group-has-[>input]/input-group:pt-2.5",
		"block-end": "order-last w-full justify-start px-3 pb-3 [.border-t]:pt-3 group-has-[>input]/input-group:pb-2.5"
	} },
	defaultVariants: { align: "inline-start" }
});
function bc({ className: e, align: t = "inline-start", ...n }) {
	return /* @__PURE__ */ Y("div", {
		role: "group",
		"data-slot": "input-group-addon",
		"data-align": t,
		className: M(yc({ align: t }), e),
		onClick: (e) => {
			e.target.closest("button") || e.currentTarget.parentElement?.querySelector("input")?.focus();
		},
		...n
	});
}
var xc = Rr("text-sm shadow-none flex gap-2 items-center", {
	variants: { size: {
		xs: "h-6 gap-1 px-2 rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-3.5 has-[>svg]:px-2",
		sm: "h-8 px-2.5 gap-1.5 rounded-md has-[>svg]:px-2.5",
		"icon-xs": "size-6 rounded-[calc(var(--radius)-5px)] p-0 has-[>svg]:p-0",
		"icon-sm": "size-8 p-0 has-[>svg]:p-0"
	} },
	defaultVariants: { size: "xs" }
});
function Sc({ className: e, type: t = "button", variant: n = "ghost", size: r = "xs", ...i }) {
	return /* @__PURE__ */ Y(I, {
		type: t,
		"data-size": r,
		variant: n,
		className: M(xc({ size: r }), e),
		...i
	});
}
function Cc({ className: e, ...t }) {
	return /* @__PURE__ */ Y(St, {
		"data-slot": "input-group-control",
		className: M("flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent", e),
		...t
	});
}
var wc = At.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ Y(He, {
	ref: n,
	"data-slot": "input-group-control",
	className: M("grow shrink basis-auto resize-none rounded-none border-0 bg-transparent py-3 shadow-none focus-visible:ring-0 dark:bg-transparent", e),
	...t
}));
wc.displayName = "InputGroupTextarea";
//#endregion
//#region src/hooks/use-auto-resize-textarea.ts
var Tc = typeof CSS < "u" && CSS.supports?.("field-sizing", "content");
function Ec({ value: e } = {}) {
	let t = W(null), n = B(() => {
		let e = t.current;
		!e || Tc || (e.style.height = "auto", e.style.height = `${e.scrollHeight}px`);
	}, []);
	return H(() => {
		Tc || n();
	}, [n]), Rt(() => {
		let r = t.current;
		r && (Tc ? e || (r.style.setProperty("field-sizing", "fixed"), r.offsetHeight, r.style.setProperty("field-sizing", "content")) : n());
	}, [e, n]), {
		textareaRef: t,
		style: Tc ? { fieldSizing: "content" } : void 0,
		handleAutoResizeInput: n
	};
}
//#endregion
//#region src/components/ai-elements/prompt-input.tsx
function Dc({ className: e, onSubmit: t, children: n, ...r }) {
	return /* @__PURE__ */ Y("form", {
		className: M("w-full", e),
		onSubmit: (e) => {
			e.preventDefault();
			let n = e.currentTarget, r = new FormData(n).get("message") || "";
			n.reset(), t({ text: r }, e);
		},
		...r,
		children: /* @__PURE__ */ Y(vc, {
			className: "overflow-hidden bg-card",
			children: n
		})
	});
}
function Oc({ className: e, ...t }) {
	return /* @__PURE__ */ Y("div", {
		className: M("contents", e),
		...t
	});
}
function kc({ onChange: e, className: t, placeholder: n = "What would you like to know?", autoFocus: r, ...i }) {
	let [a, o] = G(!1), { textareaRef: s, style: c, handleAutoResizeInput: l } = Ec();
	return H(() => {
		r && s.current && s.current.focus();
	}, [r, s]), /* @__PURE__ */ Y(wc, {
		ref: s,
		className: M("max-h-[40vh] min-h-6 overflow-y-auto", t),
		style: c,
		name: "message",
		onCompositionEnd: () => {
			o(!1);
		},
		onCompositionStart: () => {
			o(!0);
		},
		onInput: l,
		onKeyDown: (e) => {
			if (e.key === "Enter") {
				if (a || e.nativeEvent.isComposing || e.shiftKey) return;
				e.preventDefault();
				let { form: t } = e.currentTarget;
				if (t?.querySelector("button[type=\"submit\"]")?.disabled) return;
				t?.requestSubmit();
			}
		},
		placeholder: n,
		...i,
		onChange: e
	});
}
function Ac({ className: e, ...t }) {
	return /* @__PURE__ */ Y(bc, {
		align: "block-end",
		className: M("justify-between gap-1", e),
		...t
	});
}
function jc({ variant: e = "ghost", className: t, size: n, ...r }) {
	let i = n ?? (jt.count(r.children) > 1 ? "sm" : "icon-sm");
	return /* @__PURE__ */ Y(Sc, {
		className: M(t),
		size: i,
		type: "button",
		variant: e,
		...r
	});
}
function Mc({ className: e, variant: t = "default", size: n = "icon-sm", status: r, children: i, ...a }) {
	let { t: o } = Z(), s = /* @__PURE__ */ Y(_n, { className: "size-4" });
	switch (r) {
		case "submitted":
		case "streaming":
			s = /* @__PURE__ */ Y(jn, { className: "size-4 animate-spin" });
			break;
		case "error":
			s = /* @__PURE__ */ Y(gr, { className: "size-4" });
			break;
	}
	return /* @__PURE__ */ Y(Sc, {
		"aria-label": o("chatPanel.input.submit"),
		className: M(e),
		size: n,
		type: "submit",
		variant: t,
		...a,
		children: i ?? s
	});
}
//#endregion
//#region src/components/chat-input-file-menu.tsx
function Nc({ heading: e, origin: t, files: n }) {
	let { isAttached: r, toggleAttachment: i } = Si();
	return n.length === 0 ? null : /* @__PURE__ */ Y(hc, {
		heading: e,
		children: n.map((e) => {
			let { Icon: n, color: a } = lt(e.path), o = r({
				origin: t,
				path: e.path
			});
			return /* @__PURE__ */ X(_c, {
				value: `${t}:${e.path}`,
				className: "group",
				onSelect: () => {
					i({
						origin: t,
						path: e.path
					});
				},
				children: [
					/* @__PURE__ */ Y(n, { className: M("h-4 w-4 shrink-0", a) }),
					/* @__PURE__ */ Y("span", {
						className: "flex-1 truncate",
						children: e.path
					}),
					/* @__PURE__ */ Y("span", {
						className: M("flex size-6 shrink-0 items-center justify-center rounded-md transition", o ? "bg-current/15 text-primary opacity-100 group-data-[selected=true]:text-accent-foreground" : "text-muted-foreground opacity-0 group-data-[selected=true]:opacity-100 group-data-[selected=true]:text-accent-foreground"),
						children: /* @__PURE__ */ Y(Vn, { className: "size-4" })
					})
				]
			}, `${t}:${e.path}`);
		})
	});
}
function Pc({ onUpload: e, isDisabled: t = !1 }) {
	let { t: n } = Z(), [r, i] = G(!1), { files: a } = pi(), { files: o } = _i(), s = a.length > 0 || o.length > 0, c = `upload:${n("chatPanel.input.fileMenu.upload")}`;
	return /* @__PURE__ */ X(sc, {
		open: r && !t,
		onOpenChange: i,
		children: [/* @__PURE__ */ Y(cc, {
			asChild: !0,
			children: /* @__PURE__ */ Y(jc, {
				"aria-label": n("chatPanel.input.fileMenu.open"),
				disabled: t,
				children: /* @__PURE__ */ Y(Kn, { className: "size-4" })
			})
		}), /* @__PURE__ */ Y(uc, {
			align: "start",
			className: "w-80 p-0",
			children: /* @__PURE__ */ X(dc, {
				defaultValue: s ? void 0 : c,
				children: [/* @__PURE__ */ Y("div", {
					className: M(!s && "sr-only"),
					children: /* @__PURE__ */ Y(fc, { placeholder: n("chatPanel.input.fileMenu.searchPlaceholder") })
				}), /* @__PURE__ */ X(pc, { children: [
					s && /* @__PURE__ */ Y(mc, { children: n("chatPanel.input.fileMenu.noResults") }),
					/* @__PURE__ */ Y(Nc, {
						heading: n("panel.sections.files"),
						origin: "user",
						files: a
					}),
					/* @__PURE__ */ Y(Nc, {
						heading: n("panel.sections.producedFiles"),
						origin: "workflow",
						files: o
					}),
					s && /* @__PURE__ */ Y(gc, {}),
					/* @__PURE__ */ Y(hc, {
						forceMount: !0,
						children: /* @__PURE__ */ X(_c, {
							forceMount: !0,
							value: c,
							className: "text-muted-foreground",
							onSelect: () => {
								i(!1), e();
							},
							children: [/* @__PURE__ */ Y(ur, { className: "h-4 w-4 shrink-0" }), n("chatPanel.input.fileMenu.upload")]
						})
					})
				] })]
			})
		})]
	});
}
//#endregion
//#region src/components/chat-input-model.tsx
function Fc({ conversationModelId: e }) {
	let [t, n] = G([]);
	H(() => {
		let e = !1;
		return (async () => {
			try {
				let t = await i();
				e || n(t);
			} catch {}
		})(), () => {
			e = !0;
		};
	}, []);
	let r = t.find((t) => t.id === e && t.status !== "retired");
	return r ? /* @__PURE__ */ Y(Ic, { label: r.label }) : null;
}
function Ic({ label: e }) {
	let { t } = Z();
	return /* @__PURE__ */ X(Ea, {
		variant: "outline",
		className: "min-w-0 shrink gap-1.5 text-muted-foreground cursor-default",
		title: t("chatPanel.input.model", { name: e }),
		children: [/* @__PURE__ */ Y(an, {}), /* @__PURE__ */ Y("span", {
			className: "truncate",
			children: e
		})]
	});
}
function Lc(e) {
	return e.findLast((e) => e.metadata?.model)?.metadata?.model;
}
//#endregion
//#region src/hooks/use-file-picker.tsx
function Rc(e) {
	let t = e.webkitRelativePath;
	if (!t) return;
	let n = t.split("/");
	return n.pop(), n.length > 0 ? n.join("/") : void 0;
}
function zc({ onFiles: e }) {
	let t = W(null);
	return {
		open: B(() => {
			t.current?.click();
		}, []),
		inputElement: /* @__PURE__ */ Y("input", {
			ref: t,
			type: "file",
			multiple: !0,
			className: "hidden",
			onChange: B((t) => {
				let n = t.target.files;
				if (n && n.length > 0) {
					let t = [...n];
					e(t, t.map(Rc));
				}
				t.target.value = "";
			}, [e])
		})
	};
}
//#endregion
//#region src/hooks/use-suggestions.ts
function Bc() {
	let { t: e } = Z();
	return (da("suggestions") ?? []).map((t) => ({
		id: t.id,
		Icon: ft(t.icon).Icon,
		title: e(`${t.i18nKey}.title`),
		description: e(`${t.i18nKey}.description`),
		prompt: e(`${t.i18nKey}.prompt`)
	}));
}
//#endregion
//#region src/components/ui/suggestion-pill.tsx
function Vc({ icon: e, title: t, description: n, onClick: r, isDisabled: i = !1, className: a }) {
	return /* @__PURE__ */ X("button", {
		type: "button",
		disabled: i,
		title: n,
		onClick: r,
		className: M("group/suggestion-pill cursor-pointer flex w-full items-center gap-3 rounded-lg border border-border bg-card px-3 py-2.5 text-left transition-colors hover:border-foreground/20 hover:bg-muted/40 disabled:opacity-50 disabled:hover:bg-card", a),
		children: [
			/* @__PURE__ */ Y("span", {
				className: "flex size-7 shrink-0 items-center justify-center rounded-md bg-muted text-foreground/70",
				children: /* @__PURE__ */ Y(e, {
					className: "size-3.5",
					"aria-hidden": "true"
				})
			}),
			/* @__PURE__ */ X("span", {
				className: "flex min-w-0 flex-1 flex-col gap-0.5",
				children: [/* @__PURE__ */ Y("span", {
					className: "truncate text-sm font-medium text-foreground",
					children: t
				}), n && /* @__PURE__ */ Y("span", {
					className: "max-sm:hidden line-clamp-2 text-xs text-muted-foreground",
					children: n
				})]
			}),
			/* @__PURE__ */ Y(tn, {
				className: "size-4 shrink-0 text-muted-foreground transition-transform group-hover/suggestion-pill:translate-x-0.5 group-hover/suggestion-pill:-translate-y-0.5",
				"aria-hidden": "true"
			})
		]
	});
}
//#endregion
//#region src/components/suggestions.tsx
function Hc({ suggestions: e, onSelect: t, isDisabled: n = !1, className: r }) {
	let { t: i } = Z();
	return e.length === 0 ? null : /* @__PURE__ */ Y("section", {
		"aria-label": i("home.suggestions.label"),
		className: M("grid grid-cols-1 gap-2 sm:grid-cols-2", r),
		children: e.map((e) => /* @__PURE__ */ Y(Vc, {
			icon: e.Icon,
			title: e.title,
			description: e.description,
			isDisabled: n,
			onClick: () => {
				t(e.prompt);
			}
		}, e.id))
	});
}
//#endregion
//#region src/components/chat-panel-constants.ts
var Uc = "mx-auto w-full max-w-[960px]", Wc = "message-margin-right w-fit rounded-xl bg-muted/50 px-4 py-2.5 text-sm";
//#endregion
//#region src/components/chat-input.tsx
function Gc({ input: e, setInput: t, onSend: n, isLoading: r, isStopping: i, onStopGeneration: a, status: o, isMobile: s, isHomeSuggestionsVisible: c, isCenteredMode: l = !1, isDisabled: u = !1, isAiDisclaimerVisible: d = !1, conversationModelId: f, evaluationControl: p }) {
	let { t: m } = Z(), { showToast: h } = Q(), { addFiles: g, uploads: _ } = pi(), { attach: v, attached: y, clear: b } = Si(), { showSections: x } = ni(), S = Bc(), C = y.some((e) => e.origin === "user" && _.some((t) => t.path === e.path && !t.error)), [w, T] = G(!1), E = (e) => {
		if (u) return;
		let t = e.text?.trim() ?? "";
		!t || r || C || w || (n(t, vi(y)), b());
	}, D = async (e, t) => {
		if (!u) {
			T(!0);
			try {
				let n = await g(e, t);
				for (let e of n?.acceptedPaths ?? []) v({
					origin: "user",
					path: e
				});
				x();
			} catch (e) {
				console.error("Failed to add dropped files:", e), h(m("fileSystem.dropFailed"), "error");
			} finally {
				T(!1);
			}
		}
	}, { open: O, inputElement: ee } = zc({ onFiles: D });
	return /* @__PURE__ */ X("div", {
		className: M(l ? "w-full" : "shrink-0", !l && (s ? "p-inline" : "p-section"), !l && "pb-section-sm"),
		children: [
			c && /* @__PURE__ */ Y(Hc, {
				suggestions: S,
				onSelect: (e) => {
					n(e, []);
				},
				isDisabled: r || u,
				className: M("mb-3", !s && "mx-auto w-full max-w-[960px]")
			}),
			p && /* @__PURE__ */ Y("div", {
				className: M("mb-inline", !s && "mx-auto w-full max-w-[960px]"),
				children: p
			}),
			ee,
			/* @__PURE__ */ Y(ic, {
				onDrop: D,
				disabled: u,
				onError: () => {
					h(m("fileSystem.dropFailed"), "error");
				},
				label: m("fileSystem.dropZone"),
				fullPage: !l,
				className: M("w-full", !s && "mx-auto w-full max-w-[960px]"),
				children: /* @__PURE__ */ X(Dc, {
					onSubmit: E,
					className: "w-full",
					children: [
						/* @__PURE__ */ Y(oc, {}),
						/* @__PURE__ */ Y(Oc, { children: /* @__PURE__ */ Y(kc, {
							value: e,
							onChange: (e) => {
								t(e.target.value);
							},
							placeholder: m("chatPanel.input.placeholder"),
							className: s ? "min-h-[60px]" : "min-h-24",
							autoFocus: c,
							disabled: u
						}) }),
						/* @__PURE__ */ Y(Kc, {
							onOpenFilePicker: O,
							isLoading: r,
							isStopping: i,
							onStopGeneration: a,
							input: e,
							status: o,
							isUploadingAttachment: C || w,
							isDisabled: u,
							conversationModelId: f
						})
					]
				})
			}),
			!l && /* @__PURE__ */ Y(L, {
				variant: "detail",
				color: "muted",
				"aria-hidden": !d,
				className: M("mt-section-sm text-center", !d && "invisible", !s && "mx-auto w-full max-w-[960px]"),
				children: m("chatPanel.aiDisclaimer")
			})
		]
	});
}
function Kc({ onOpenFilePicker: e, isLoading: t, isStopping: n, onStopGeneration: r, input: i, status: a, isUploadingAttachment: o, isDisabled: s, conversationModelId: c }) {
	let { t: l } = Z(), u = t && !!r;
	return /* @__PURE__ */ X(Ac, { children: [/* @__PURE__ */ X("div", {
		className: "flex min-w-0 flex-1 items-center gap-1",
		children: [
			/* @__PURE__ */ Y(Pc, {
				onUpload: e,
				isDisabled: s
			}),
			/* @__PURE__ */ Y(Fc, { conversationModelId: c }),
			o && /* @__PURE__ */ X("span", {
				className: "flex items-center gap-1.5 text-xs text-muted-foreground",
				children: [/* @__PURE__ */ Y(q, { className: "h-3.5 w-3.5 animate-spin" }), /* @__PURE__ */ Y("span", {
					className: "hidden sm:inline",
					children: l("chatPanel.input.waitingForUploads")
				})]
			})
		]
	}), u ? /* @__PURE__ */ Y(I, {
		onClick: r,
		variant: "destructive",
		size: "sm",
		className: "gap-2 text-xs shrink-0",
		disabled: n,
		children: n ? /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y(q, { className: "h-3.5 w-3.5 animate-spin" }), /* @__PURE__ */ Y("span", {
			className: "hidden sm:inline",
			children: l("chatPanel.input.stoppingGeneration")
		})] }) : /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y(ar, { className: "h-3.5 w-3.5" }), /* @__PURE__ */ Y("span", {
			className: "hidden sm:inline",
			children: l("chatPanel.input.stopGeneration")
		})] })
	}) : /* @__PURE__ */ Y(Mc, {
		className: "bg-primary text-primary-foreground hover:bg-primary/90 shrink-0",
		disabled: s || !i.trim() || t || o,
		status: a
	})] });
}
//#endregion
//#region src/components/credit-exhausted-banner.tsx
function qc() {
	let e = da("CreditExhaustedNotice");
	return /* @__PURE__ */ Y("div", {
		className: `${Uc} mb-2 flex items-center gap-2 rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive`,
		children: Y(e || Jc, {})
	});
}
function Jc() {
	let { t: e } = Z(), { pathname: t } = Wt(), n = ys(cs.subscription);
	return /* @__PURE__ */ X(J, { children: [
		/* @__PURE__ */ Y(Xt, {
			className: "size-4 shrink-0",
			"aria-hidden": "true"
		}),
		/* @__PURE__ */ Y("span", {
			className: "flex-1",
			children: e("chat.credits.exhaustedTitle")
		}),
		n && /* @__PURE__ */ Y(K, {
			to: n,
			state: { from: t },
			className: "shrink-0 font-medium underline underline-offset-2",
			children: e("chat.credits.viewUsage")
		})
	] });
}
//#endregion
//#region src/hooks/use-restore-failed-send.ts
function Yc(e) {
	let t = Vi(), { attach: n } = Si(), r = t?.failedSend, i = t?.clearFailedSend;
	H(() => {
		if (!(!r || !i)) {
			e(r.text);
			for (let e of r.fileParts ?? []) n({
				origin: e.data.origin,
				path: e.data.path
			});
			i();
		}
	}, [
		r,
		n,
		i,
		e
	]);
}
//#endregion
//#region src/components/ui/rename-conversation-dialog.tsx
var Xc = 200;
function Zc({ open: e, currentTitle: t, isSaving: n = !1, onOpenChange: r, onSubmit: i }) {
	let { t: a } = Z(), [o, s] = G(t);
	H(() => {
		e && s(t);
	}, [e, t]);
	let c = o.trim(), l = c === t.trim(), u = c.length > 0 && !l && !n;
	return /* @__PURE__ */ Y(Qe, {
		open: e,
		onOpenChange: r,
		children: /* @__PURE__ */ X(Xe, { children: [/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: a("renameDialog.title") }), /* @__PURE__ */ Y(qe, { children: a("renameDialog.description") })] }), /* @__PURE__ */ X("form", {
			className: "flex flex-col gap-4",
			onSubmit: (e) => {
				e.preventDefault(), u && i(c);
			},
			children: [/* @__PURE__ */ Y(St, {
				autoFocus: !0,
				value: o,
				maxLength: Xc,
				"aria-label": a("renameDialog.label"),
				placeholder: a("renameDialog.placeholder"),
				onChange: (e) => {
					s(e.target.value);
				}
			}), /* @__PURE__ */ X(Ke, { children: [/* @__PURE__ */ Y(I, {
				type: "button",
				variant: "outline",
				disabled: n,
				onClick: () => {
					r(!1);
				},
				children: a("renameDialog.cancel")
			}), /* @__PURE__ */ Y(I, {
				type: "submit",
				disabled: !u,
				children: a(n ? "renameDialog.saving" : "renameDialog.save")
			})] })]
		})] })
	});
}
//#endregion
//#region src/components/ui/conversation-actions.tsx
var Qc = bt("ai").Icon;
function $c({ conversationTitle: e, onRename: t, onRegenerate: n, onDelete: r, triggerClassName: i }) {
	let { t: a } = Z(), [o, s] = G(!1), [c, l] = G(!1), [u, d] = G(!1), [f, p] = G(!1), m = e === br ? "" : e, h = async (e) => {
		d(!0);
		try {
			await t(e), l(!1);
		} catch {} finally {
			d(!1);
		}
	}, g = async () => {
		p(!0);
		try {
			await n();
		} catch {} finally {
			p(!1), s(!1);
		}
	};
	return /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ X(ot, {
		open: o,
		onOpenChange: s,
		children: [/* @__PURE__ */ Y(st, {
			asChild: !0,
			children: /* @__PURE__ */ Y(I, {
				type: "button",
				variant: "ghost",
				size: "icon-sm",
				"aria-label": a("sidebar.conversationOptions"),
				className: M("shrink-0", i),
				onClick: (e) => {
					e.stopPropagation();
				},
				children: /* @__PURE__ */ Y(Rn, { className: "size-4" })
			})
		}), /* @__PURE__ */ X(it, {
			align: "end",
			onClick: (e) => {
				e.stopPropagation();
			},
			children: [
				/* @__PURE__ */ X($e, {
					onSelect: () => {
						l(!0);
					},
					children: [/* @__PURE__ */ Y(Un, { className: "size-4" }), a("sidebar.renameConversation")]
				}),
				/* @__PURE__ */ X($e, {
					disabled: f,
					onSelect: (e) => {
						e.preventDefault(), g();
					},
					children: [f ? /* @__PURE__ */ Y(q, { className: "size-4 animate-spin" }) : /* @__PURE__ */ Y(Qc, { className: "size-4" }), a("sidebar.regenerateTitle")]
				}),
				r && /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y(nt, {}), /* @__PURE__ */ X($e, {
					variant: "destructive",
					onSelect: () => {
						r();
					},
					children: [/* @__PURE__ */ Y(cr, { className: "size-4" }), a("sidebar.deleteConversation")]
				})] })
			]
		})]
	}), /* @__PURE__ */ Y(Zc, {
		open: c,
		currentTitle: m,
		isSaving: u,
		onOpenChange: l,
		onSubmit: (e) => {
			h(e);
		}
	})] });
}
//#endregion
//#region src/utils/format.ts
function el(e) {
	if (e === 0) return "0 B";
	let t = 1024, n = [
		"B",
		"KB",
		"MB",
		"GB",
		"TB"
	], r = Math.min(Math.floor(Math.log(e) / Math.log(t)), n.length - 1);
	return `${Number.parseFloat((e / t ** r).toFixed(2))} ${n[r]}`;
}
function tl(e) {
	return e >= 1e6 ? `${(e / 1e6).toFixed(1)}M` : e >= 1e3 ? `${(e / 1e3).toFixed(1)}k` : String(e);
}
function nl(e) {
	if (e < 1e3) return `${Math.round(e)}ms`;
	let t = Math.round(e / 1e3);
	if (t < 60) return `${t}s`;
	let n = Math.floor(t / 60), r = t % 60;
	return r === 0 ? `${n}min` : `${n}min ${r}s`;
}
function rl(e, t) {
	return new Intl.DateTimeFormat(t, {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	}).format(e);
}
//#endregion
//#region src/components/ui/conversation-item.tsx
function il(e) {
	let { t } = Z();
	return e && e !== br ? e : t("sidebar.newChat");
}
function al(e) {
	let { i18n: t } = Z();
	return U(() => rl(typeof e == "string" ? new Date(e) : e, t.language), [e, t.language]);
}
function ol({ label: e, kind: t = "muted" }) {
	let n = {
		info: "bg-info/15 text-info",
		success: "bg-success/15 text-success",
		destructive: "bg-destructive/15 text-destructive",
		muted: "bg-muted text-muted-foreground"
	}[t];
	return /* @__PURE__ */ Y("span", {
		className: M("inline-flex h-5 items-center rounded-md px-2 text-[11px] font-medium", n),
		children: e
	});
}
function sl({ filesCount: e, artefactsCount: t }) {
	let { t: n } = Z();
	if (e === void 0 && t === void 0) return null;
	let r = [];
	return e !== void 0 && e > 0 && r.push(n("conversationItem.files", { count: e })), t !== void 0 && t > 0 && r.push(n("conversationItem.artefacts", { count: t })), r.length === 0 ? null : /* @__PURE__ */ Y("span", {
		className: "font-mono text-[11px] text-muted-foreground",
		children: r.join(" · ")
	});
}
function cl({ variant: e, conversation: t, isActive: n = !1, meta: r, onClick: i, onRename: a, onRegenerate: o, onDelete: s, className: c }) {
	let l = il(t.title), u = al(t.updatedAt), { Icon: d } = pt("conversation");
	return e === "card" ? /* @__PURE__ */ X("button", {
		type: "button",
		onClick: i,
		"aria-current": n ? "page" : void 0,
		className: M("group/conversation-item flex min-h-[130px] w-full flex-col gap-3 rounded-xl border border-border bg-card p-4 text-left transition-shadow hover:shadow-md hover:border-foreground/20 cursor-pointer", n && "border-foreground/30 shadow-sm", c),
		children: [
			/* @__PURE__ */ X("div", {
				className: "flex items-center justify-between gap-2",
				children: [/* @__PURE__ */ Y("span", {
					className: "flex size-7 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground",
					children: /* @__PURE__ */ Y(d, {
						className: "size-3.5",
						"aria-hidden": "true"
					})
				}), /* @__PURE__ */ X("div", {
					className: "flex flex-1 items-center justify-end gap-2",
					children: [r?.tag && /* @__PURE__ */ Y(ol, {
						label: r.tag.label,
						kind: r.tag.kind
					}), /* @__PURE__ */ Y("span", {
						className: "font-mono text-xs text-muted-foreground",
						children: u
					})]
				})]
			}),
			/* @__PURE__ */ X("div", {
				className: "flex min-w-0 flex-1 flex-col gap-1",
				children: [/* @__PURE__ */ X("div", {
					className: "flex items-center gap-2",
					children: [/* @__PURE__ */ Y("h3", {
						className: "line-clamp-2 text-sm font-semibold text-foreground",
						children: l
					}), r?.pinned && /* @__PURE__ */ Y(Wn, {
						className: "size-3.5 shrink-0 text-muted-foreground",
						"aria-hidden": "true"
					})]
				}), r?.snippet && /* @__PURE__ */ Y("p", {
					className: "line-clamp-2 text-xs text-muted-foreground",
					children: r.snippet
				})]
			}),
			/* @__PURE__ */ Y(sl, {
				filesCount: r?.filesCount,
				artefactsCount: r?.artefactsCount
			})
		]
	}) : /* @__PURE__ */ X("div", {
		className: M("group/conversation-item flex items-center gap-3 px-[18px] py-[14px] transition-colors cursor-pointer", n ? "bg-muted" : "hover:bg-muted", c),
		onClick: i,
		children: [/* @__PURE__ */ X("button", {
			type: "button",
			onClick: (e) => {
				e.stopPropagation(), i();
			},
			"aria-current": n ? "page" : void 0,
			className: "grid min-w-0 flex-1 cursor-pointer grid-cols-[auto_minmax(0,1fr)] items-center gap-x-3 gap-y-1 text-left sm:flex",
			children: [
				/* @__PURE__ */ Y("span", {
					className: "row-span-2 flex size-7 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground",
					children: /* @__PURE__ */ Y(d, {
						className: "size-3.5",
						"aria-hidden": "true"
					})
				}),
				/* @__PURE__ */ X("div", {
					className: "flex min-w-0 flex-1 flex-col gap-0.5",
					children: [/* @__PURE__ */ X("div", {
						className: "flex items-center gap-1.5",
						children: [/* @__PURE__ */ Y("span", {
							className: "truncate text-sm font-semibold text-foreground",
							children: l
						}), r?.pinned && /* @__PURE__ */ Y(Wn, {
							className: "size-3 shrink-0 text-muted-foreground",
							"aria-hidden": "true"
						})]
					}), r?.snippet && /* @__PURE__ */ Y("span", {
						className: "truncate text-[12.5px] text-muted-foreground",
						children: r.snippet
					})]
				}),
				/* @__PURE__ */ X("div", {
					className: "flex flex-wrap items-center gap-x-3 gap-y-1 sm:flex-nowrap",
					children: [
						r?.tag && /* @__PURE__ */ Y(ol, {
							label: r.tag.label,
							kind: r.tag.kind
						}),
						/* @__PURE__ */ Y(sl, {
							filesCount: r?.filesCount,
							artefactsCount: r?.artefactsCount
						}),
						/* @__PURE__ */ Y("span", {
							className: "font-mono text-xs text-muted-foreground whitespace-nowrap",
							children: u
						})
					]
				})
			]
		}), a && o && /* @__PURE__ */ Y($c, {
			conversationTitle: t.title,
			onRename: a,
			onRegenerate: o,
			onDelete: s,
			triggerClassName: "transition-opacity pointer-fine:opacity-0 group-hover/conversation-item:opacity-100 focus-visible:opacity-100 data-[state=open]:opacity-100"
		})]
	});
}
//#endregion
//#region src/pages/home.tsx
function ll() {
	let { t: e } = Z(), t = Gt(), n = Xr(), r = Ui(), { conversations: i, handleSendMessage: a } = Bi(), { isExhausted: o } = Li(), s = Bc(), { invitations: c, accept: l, decline: u } = Qa(), d = da("HomeOutlet");
	Ji({ title: e("nav.home") });
	let f = n?.user?.name, [p, m] = G(""), [h, g] = G(!1), _ = B(async (e, t) => {
		let n = e.trim();
		if (!(!n || h)) {
			g(!0);
			try {
				await a(n, t), m("");
			} finally {
				g(!1);
			}
		}
	}, [a, h]);
	Yc(m);
	let v = i.slice(0, 4);
	return /* @__PURE__ */ Y("div", {
		className: "h-full overflow-y-auto",
		children: /* @__PURE__ */ X("div", {
			className: "mx-auto flex w-full max-w-3xl flex-col gap-8 px-4 py-10 md:px-6",
			children: [
				/* @__PURE__ */ X("header", {
					className: "flex flex-col gap-2",
					children: [/* @__PURE__ */ Y("p", {
						className: "font-mono text-[11px] uppercase tracking-[0.12em] text-muted-foreground",
						children: f ? e("home.greeting", { name: f }) : e("home.greetingFallback")
					}), /* @__PURE__ */ Y("h1", {
						className: "text-3xl font-semibold tracking-tight md:text-4xl",
						children: e("home.heading")
					})]
				}),
				/* @__PURE__ */ X("section", {
					"aria-label": e("home.composer.label"),
					children: [o && /* @__PURE__ */ Y(qc, {}), /* @__PURE__ */ Y(Gc, {
						input: p,
						setInput: m,
						onSend: (e, t) => {
							_(e, t);
						},
						isLoading: h,
						isStopping: !1,
						status: "ready",
						isMobile: r,
						isHomeSuggestionsVisible: !1,
						isCenteredMode: !0,
						isDisabled: o
					})]
				}),
				/* @__PURE__ */ Y(Hc, {
					suggestions: s,
					isDisabled: h || o,
					onSelect: (e) => {
						_(e, []);
					}
				}),
				/* @__PURE__ */ Y(Za, {
					invitations: c,
					onAccept: l,
					onDecline: u
				}),
				v.length > 0 && /* @__PURE__ */ X("section", {
					"aria-label": e("home.resume.title"),
					className: "flex flex-col gap-3 pb-4",
					children: [/* @__PURE__ */ X("div", {
						className: "flex items-center justify-between gap-2",
						children: [/* @__PURE__ */ Y("h2", {
							className: "text-lg font-semibold",
							children: e("home.resume.title")
						}), /* @__PURE__ */ X(K, {
							to: "/conversations",
							className: "inline-flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground",
							children: [e("home.resume.viewAll"), /* @__PURE__ */ Y(tn, {
								className: "size-3.5",
								"aria-hidden": "true"
							})]
						})]
					}), /* @__PURE__ */ Y("div", {
						className: "grid grid-cols-1 gap-3 sm:grid-cols-2",
						children: v.map((e) => /* @__PURE__ */ Y(cl, {
							variant: "card",
							conversation: e,
							onClick: () => {
								t(Qr(e.id));
							}
						}, e.id))
					})]
				}),
				d && /* @__PURE__ */ Y(d, {})
			]
		})
	});
}
//#endregion
//#region src/components/ui/conversation-search-bar.tsx
function ul({ value: e, onChange: t, placeholder: n, clearLabel: r = "Clear search", className: i }) {
	return /* @__PURE__ */ X(vc, {
		className: i,
		children: [
			/* @__PURE__ */ Y(bc, { children: /* @__PURE__ */ Y(Yn, {}) }),
			/* @__PURE__ */ Y(Cc, {
				type: "search",
				value: e,
				onChange: (e) => {
					t(e.target.value);
				},
				placeholder: n
			}),
			e && /* @__PURE__ */ Y(bc, {
				align: "inline-end",
				children: /* @__PURE__ */ Y(Sc, {
					"aria-label": r,
					onClick: () => {
						t("");
					},
					children: /* @__PURE__ */ Y(mr, {})
				})
			})
		]
	});
}
//#endregion
//#region src/lib/normalize-string.ts
function dl(e) {
	return e.normalize("NFD").replaceAll(/\p{Diacritic}/gu, "").toLowerCase();
}
//#endregion
//#region src/lib/group-conversations-by-date.ts
function fl() {
	let [e, t] = G(() => /* @__PURE__ */ new Date());
	return H(() => {
		let e = () => {
			t(/* @__PURE__ */ new Date());
		}, n = () => {
			document.visibilityState === "visible" && e();
		};
		return document.addEventListener("visibilitychange", n), globalThis.addEventListener("focus", e), () => {
			document.removeEventListener("visibilitychange", n), globalThis.removeEventListener("focus", e);
		};
	}, []), e;
}
function pl(e, t, n) {
	let r = new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime(), i = new Date(r).getDay() === 0 ? 6 : new Date(r).getDay() - 1;
	return {
		startOfToday: r,
		startOfYesterday: r - 864e5,
		startOfWeek: r - i * 864e5,
		startOfMonth: new Date(e.getFullYear(), e.getMonth(), 1).getTime(),
		formatter: new Intl.DateTimeFormat(t, {
			month: "long",
			year: "numeric"
		}),
		t: n
	};
}
function ml(e, t) {
	let n = e.getTime();
	if (n >= t.startOfToday) return t.t("time.today");
	if (n >= t.startOfYesterday) return t.t("time.yesterday");
	if (n >= t.startOfWeek) return t.t("time.thisWeek");
	if (n >= t.startOfMonth) return t.t("time.thisMonth");
	let r = t.formatter.format(e);
	return r.charAt(0).toUpperCase() + r.slice(1);
}
function hl(e) {
	let { t, i18n: n } = Z(), r = fl();
	return U(() => {
		let i = pl(r, n.language, t), a = /* @__PURE__ */ new Map(), o = [];
		for (let t of e) {
			let e = ml(typeof t.updatedAt == "string" ? new Date(t.updatedAt) : t.updatedAt, i);
			a.has(e) || (a.set(e, []), o.push(e)), a.get(e).push(t);
		}
		return o.map((e) => ({
			label: e,
			conversations: a.get(e)
		}));
	}, [
		e,
		r,
		t,
		n.language
	]);
}
//#endregion
//#region src/pages/conversations-list.tsx
function gl() {
	let { t: e } = Z(), t = Gt(), { conversations: n, handleDeleteConversation: r, renameConversation: i, regenerateTitle: a } = Bi(), [o, s] = G(""), c = U(() => {
		if (!o) return n;
		let e = dl(o);
		return n.filter((t) => dl(t.title).includes(e));
	}, [n, o]), l = hl(c);
	return /* @__PURE__ */ Y(_a, {
		title: e("conversations.title"),
		meta: /* @__PURE__ */ Y("span", {
			className: "inline-flex h-6 items-center rounded-md bg-muted px-2 text-xs font-medium text-muted-foreground",
			children: e("conversations.total", { count: n.length })
		}),
		toolbar: /* @__PURE__ */ Y(ul, {
			value: o,
			onChange: s,
			placeholder: e("conversations.searchPlaceholder"),
			clearLabel: e("sidebar.clearSearch"),
			className: "w-full md:max-w-[280px] bg-card"
		}),
		action: {
			label: e("conversations.new"),
			icon: Gn,
			onClick() {
				t(Zr());
			}
		},
		children: /* @__PURE__ */ X("div", {
			className: "flex flex-col gap-6",
			children: [
				n.length === 0 && /* @__PURE__ */ Y(Et, {
					icon: /* @__PURE__ */ Y(In, { className: "size-7" }),
					title: e("sidebar.empty"),
					description: e("sidebar.emptyHint"),
					className: "py-12"
				}),
				n.length > 0 && c.length === 0 && /* @__PURE__ */ Y(Et, {
					icon: /* @__PURE__ */ Y(Zn, { className: "size-7" }),
					title: e("sidebar.noResults"),
					className: "py-12"
				}),
				l.map((e) => /* @__PURE__ */ Y(Nt, { children: /* @__PURE__ */ X("section", {
					className: "flex flex-col gap-2",
					children: [/* @__PURE__ */ Y("p", {
						className: "font-mono text-[11px] uppercase tracking-[0.12em] text-muted-foreground",
						children: e.label
					}), /* @__PURE__ */ Y("div", {
						className: "overflow-hidden rounded-xl border border-border bg-card divide-y divide-border",
						children: e.conversations.map((e) => /* @__PURE__ */ Y(cl, {
							variant: "row",
							conversation: e,
							onClick: () => {
								t(Qr(e.id));
							},
							onRename: async (t) => i(e.id, t),
							onRegenerate: async () => a(e.id),
							onDelete: () => {
								r(e);
							}
						}, e.id))
					})]
				}) }, e.label))
			]
		})
	});
}
//#endregion
//#region src/components/share-button.tsx
function _l({ isShared: e, onClick: t, className: n, size: r = "icon" }) {
	let { t: i } = Z();
	return /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
		asChild: !0,
		children: /* @__PURE__ */ Y(I, {
			variant: e ? "default" : "ghost",
			size: r,
			className: M("transition-all", n),
			onClick: t,
			children: Y(e ? An : $n, { className: "h-4 w-4" })
		})
	}), /* @__PURE__ */ Y(N, { children: i(e ? "share.manageShare" : "share.shareArtifact") })] });
}
//#endregion
//#region src/components/share-dialog.tsx
function vl(e) {
	return `${globalThis.location.origin}/share/${e}`;
}
function yl({ isOpen: e, onOpenChange: t, conversationId: n, artifactId: r, artifactVersion: i, shareToken: a, onShareChange: o }) {
	let { t: s } = Z(), { showToast: c } = Q(), [l, u] = G(!1), [d, f] = G(a);
	H(() => {
		f(a);
	}, [a]), H(() => {
		e && !d && !l && p();
	}, [e]);
	let p = B(async () => {
		u(!0);
		try {
			let e = await ae(n, r, i);
			f(e.shareToken), o(e.shareToken);
		} catch {
			c(s("share.errorCreating"), "error"), t(!1);
		} finally {
			u(!1);
		}
	}, [
		n,
		r,
		i,
		o,
		t,
		c,
		s
	]), m = B(async () => {
		u(!0);
		try {
			await Te(n, r, i), f(void 0), o(void 0), t(!1), c(s("share.removed"), "success");
		} catch {
			c(s("share.errorRemoving"), "error");
		} finally {
			u(!1);
		}
	}, [
		n,
		r,
		i,
		o,
		t,
		c,
		s
	]), h = B(async () => {
		if (!d) return;
		let e = vl(d);
		try {
			await navigator.clipboard.writeText(e), c(s("share.copied"), "success");
		} catch {
			c(s("share.errorCopying"), "error");
		}
	}, [
		d,
		c,
		s
	]), g = B(async () => {
		d && !a ? await m() : t(!1);
	}, [
		d,
		a,
		m,
		t
	]), _ = d ? vl(d) : "";
	return /* @__PURE__ */ Y(Qe, {
		open: e,
		onOpenChange: t,
		children: /* @__PURE__ */ X(Xe, { children: [
			/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: s("share.title") }), /* @__PURE__ */ Y(qe, { children: s(d ? "share.descriptionShared" : "share.descriptionCreating") })] }),
			l ? /* @__PURE__ */ Y("div", {
				className: "flex items-center justify-center py-8",
				children: /* @__PURE__ */ Y(q, { className: "h-6 w-6 animate-spin text-muted-foreground" })
			}) : d ? /* @__PURE__ */ Y("div", {
				className: "flex flex-col gap-4",
				children: /* @__PURE__ */ X("div", {
					className: "flex gap-2",
					children: [/* @__PURE__ */ Y(St, {
						readOnly: !0,
						value: _,
						className: "flex-1 text-sm"
					}), /* @__PURE__ */ Y(I, {
						variant: "outline",
						size: "icon",
						onClick: h,
						"aria-label": s("share.copyLink"),
						children: /* @__PURE__ */ Y(gn, { className: "h-4 w-4" })
					})]
				})
			}) : null,
			/* @__PURE__ */ Y(Ke, { children: d ? /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ X(I, {
				variant: "destructive",
				onClick: m,
				disabled: l,
				children: [/* @__PURE__ */ Y(cr, { className: "h-4 w-4 mr-2" }), s("share.removeShare")]
			}), /* @__PURE__ */ Y(I, {
				variant: "outline",
				onClick: () => {
					t(!1);
				},
				children: s("share.close")
			})] }) : /* @__PURE__ */ Y(I, {
				variant: "outline",
				onClick: g,
				disabled: l,
				children: s("share.cancel")
			}) })
		] })
	});
}
//#endregion
//#region src/components/artifact-card.tsx
function bl({ title: e, type: t, version: n, onClick: r, isActive: i = !1, conversationId: a, artifactId: o, shareToken: s, onShareChange: c }) {
	let { t: l } = Z(), [u, d] = G(!1), f = !!(a && o && c);
	return /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ X("div", {
		onClick: r,
		onKeyDown: (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), r?.());
		},
		role: "button",
		tabIndex: 0,
		className: M("group flex w-full max-w-full overflow-hidden items-center gap-3 rounded-lg border bg-card px-3 py-2.5 text-left shadow-sm transition-all cursor-pointer", "hover:shadow-md hover:border-primary/50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2", i ? "border-primary ring-2 ring-primary ring-offset-2" : "border-border"),
		children: [
			/* @__PURE__ */ Y("div", {
				className: M("flex h-10 w-10 shrink-0 items-center justify-center rounded-md transition-colors", gt(t).base, gt(t).hover),
				children: /* @__PURE__ */ Y(ut, {
					type: t,
					size: "md"
				})
			}),
			/* @__PURE__ */ X("div", {
				className: "min-w-0 flex-1",
				children: [/* @__PURE__ */ Y(L, {
					as: "div",
					variant: "caption",
					weight: "medium",
					className: "truncate text-card-foreground",
					children: e
				}), /* @__PURE__ */ X("div", {
					className: "flex items-center gap-2 text-xs text-muted-foreground",
					children: [
						/* @__PURE__ */ Y("span", { children: l(`artifact.type.${t}`) }),
						/* @__PURE__ */ Y("span", { children: "•" }),
						/* @__PURE__ */ Y("span", { children: l("artifact.version", { version: n }) })
					]
				})]
			}),
			f && /* @__PURE__ */ Y(_l, {
				isShared: !!s,
				onClick: (e) => {
					e.stopPropagation(), d(!0);
				},
				size: "sm"
			})
		]
	}), f && /* @__PURE__ */ Y(yl, {
		isOpen: u,
		onOpenChange: d,
		conversationId: a,
		artifactId: o,
		artifactVersion: n,
		shareToken: s,
		onShareChange: c
	})] });
}
//#endregion
//#region src/components/tool-call-generation-progress.tsx
var xl = 2e4, Sl = new Set(["writeFile", "editFile"]), Cl = "text-muted-foreground/70 italic";
function wl(e) {
	return Sl.has(e);
}
var Tl = /* @__PURE__ */ new Map();
function El(e) {
	let t = Tl.get(e);
	if (t !== void 0) return t;
	let n = Date.now();
	return Tl.set(e, n), n;
}
function Dl({ toolKey: e }) {
	let { t } = Z(), [n, r] = G(() => Date.now() - El(e));
	if (H(() => {
		r(Date.now() - El(e));
		let t = setInterval(() => {
			r(Date.now() - El(e));
		}, 1e3);
		return () => {
			clearInterval(t);
		};
	}, [e]), n < xl) return null;
	let i = Math.floor(n / 1e3), a = `${Math.floor(i / 60)}:${(i % 60).toString().padStart(2, "0")}`;
	return /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ X("span", {
		className: `shrink-0 ${Cl}`,
		children: ["· ", a]
	}), /* @__PURE__ */ X("span", {
		className: `hidden truncate sm:block ${Cl}`,
		children: ["· ", t("chatPanel.tool.generationHint")]
	})] });
}
//#endregion
//#region src/components/tool-call-card.tsx
function Ol({ isSuccess: e, isCancelled: t, isDenied: n }) {
	let { t: r } = Z();
	return n ? /* @__PURE__ */ Y(nr, {
		className: "h-3 w-3 text-muted-foreground",
		"aria-label": r("chatPanel.tool.approval.denied")
	}) : t ? /* @__PURE__ */ Y(nn, {
		className: "h-3 w-3 text-muted-foreground",
		"aria-label": r("chatPanel.tool.cancelled")
	}) : e === void 0 ? /* @__PURE__ */ Y(q, { className: "h-3 w-3 animate-spin text-info" }) : e ? /* @__PURE__ */ Y(ln, { className: "h-3 w-3 text-success" }) : /* @__PURE__ */ Y(Yt, { className: "h-3 w-3 text-destructive" });
}
function kl({ title: e, toolName: t, isSuccess: n, isCancelled: r, isDenied: i, hasUserApproval: a, isStillRunning: o, duration: s, isExpandedInGroup: c = !1, toolKey: l }) {
	let { t: u } = Z(), d = r || i, f = !d && n === void 0, p = e || u(`chatPanel.tool.names.${t}`, { defaultValue: t });
	return /* @__PURE__ */ X("div", {
		className: "flex w-full min-w-0 items-center gap-2 py-1 text-xs text-muted-foreground",
		children: [
			/* @__PURE__ */ Y("div", {
				className: "shrink-0",
				children: /* @__PURE__ */ Y(Ol, {
					isSuccess: n,
					isCancelled: r,
					isDenied: i
				})
			}),
			a && /* @__PURE__ */ Y(er, {
				className: "h-3 w-3 shrink-0 text-muted-foreground/70",
				"aria-label": u("chatPanel.tool.approval.approved")
			}),
			/* @__PURE__ */ Y("span", {
				className: "truncate",
				children: p
			}),
			!c && f && l && wl(t) && /* @__PURE__ */ Y(Dl, { toolKey: l }),
			o && !d && /* @__PURE__ */ X("span", {
				className: "text-muted-foreground italic",
				children: [
					"(",
					u("chatPanel.tool.stillRunning"),
					")"
				]
			}),
			s !== void 0 && !d && /* @__PURE__ */ X("span", {
				className: "text-muted-foreground",
				children: [
					"(",
					nl(s),
					")"
				]
			})
		]
	});
}
//#endregion
//#region src/components/tool-call-part.tsx
function Al(e) {
	let { type: t } = e;
	return typeof t != "string" || t === "tool-web_search" || t === "tool-call" && "toolName" in e && e.toolName === "web_search" ? !1 : t === "tool-call" || t === "dynamic-tool" || t.startsWith("tool-input-available") || t.startsWith("tool-output-available") || t.startsWith("tool-");
}
function jl(e) {
	if (!Al(e)) return !1;
	let { state: t, approval: n } = e;
	return !!n && (t === "approval-requested" || t === "approval-responded");
}
function Ml(e) {
	return e.toolName ? String(e.toolName) : e.type.replace("tool-", "").replace("-input-available", "").replace("-output-available", "");
}
function Nl(e, t) {
	if (e.state === "output-denied" || e.approval?.approved === !1) return "denied";
	let n = e.output ?? {};
	return e.output !== void 0 && Object.keys(n).length > 0 ? n.success === !1 ? "error" : "success" : t ? "running" : "cancelled";
}
var Pl = {
	writeFile: "chatPanel.tool.writeFileTitle",
	editFile: "chatPanel.tool.editFileTitle",
	readFile: "chatPanel.tool.readFileTitle",
	viewImage: "chatPanel.tool.viewImageTitle"
};
function Fl(e, t) {
	let n = Ml(e), r = e.input ?? {};
	if (n === "loadSkill" && typeof r.name == "string") return t("chatPanel.tool.loadSkillTitle", { name: r.name });
	let i = Pl[n], a = n === "readFile" && typeof r.path == "string" && r.path.startsWith("/workspace/.runs");
	return i && typeof r.path == "string" && !a ? t(i, { name: r.path.split("/").pop() ?? r.path }) : r.title ?? r.intent;
}
function Il(e, t) {
	let n = Ml(e);
	return Fl(e, t) ?? t(`chatPanel.tool.names.${n}`, { defaultValue: n });
}
function Ll({ part: e, isStreaming: t, isExpandedInGroup: n = !1 }) {
	let { i18n: r, t: i } = Z();
	if (!Al(e)) return null;
	let a = Ml(e);
	if (!r.exists(`chatPanel.tool.names.${a}`)) return null;
	let o = e.output ?? {}, s = Nl(e, t), c = s === "success" ? !0 : s === "error" ? !1 : void 0, l = s === "cancelled", u = s === "denied", d = e.approval?.approved === !0, f = a === "exec" && o.status === "running", p = o.duration;
	return /* @__PURE__ */ Y(kl, {
		title: Fl(e, i),
		toolName: a,
		isSuccess: c,
		isCancelled: l,
		isDenied: u,
		hasUserApproval: d,
		isStillRunning: f,
		duration: p,
		isExpandedInGroup: n,
		toolKey: e.toolCallId ?? e.input?.path
	});
}
//#endregion
//#region src/components/tool-call-group.tsx
function Rl(e, t) {
	let n = 0, r = 0, i = 0, a = 0, o;
	for (let s of e) switch (Nl(s, t)) {
		case "running":
			n += 1, o ||= s;
			break;
		case "error":
			r += 1;
			break;
		case "cancelled":
			i += 1;
			break;
		case "denied":
			a += 1;
			break;
		case "success": break;
	}
	return {
		total: e.length,
		runningCount: n,
		errorCount: r,
		cancelledCount: i,
		deniedCount: a,
		firstRunningPart: o
	};
}
function zl({ runningCount: e }) {
	return e > 0 ? "running" : "done";
}
function Bl({ status: e }) {
	return e === "running" ? /* @__PURE__ */ Y(q, { className: "h-3 w-3 animate-spin text-info" }) : /* @__PURE__ */ Y(ln, { className: "h-3 w-3 text-success" });
}
function Vl({ part: e }) {
	let t = e.toolCallId ?? e.input?.path;
	return !t || !wl(Ml(e)) ? null : /* @__PURE__ */ Y(Dl, { toolKey: t });
}
function Hl({ errorCount: e, cancelledCount: t, deniedCount: n }, r) {
	let i = [];
	return e > 0 && i.push(r("chatPanel.tool.group.failed", { count: e })), t > 0 && i.push(r("chatPanel.tool.group.cancelled", { count: t })), n > 0 && i.push(r("chatPanel.tool.group.denied", { count: n })), i;
}
function Ul(e, t) {
	let { total: n, runningCount: r, firstRunningPart: i } = e;
	return i && r === 1 ? Il(i, t) : r > 1 ? t("chatPanel.tool.group.running", { count: r }) : t("chatPanel.tool.group.summary", { count: n });
}
function Wl({ parts: e, isStreaming: t }) {
	let { t: n } = Z(), [r, i] = G(!1), a = U(() => Rl(e, t), [e, t]);
	if (e.length === 0) return null;
	if (e.length === 1) return /* @__PURE__ */ Y(Ll, {
		part: e[0],
		isStreaming: t
	});
	let { total: o, runningCount: s, firstRunningPart: c } = a, l = !!c && s === 1, u = zl(a), d = Ul(a, n), f = l && o > 1 ? n("chatPanel.tool.group.moreCount", { count: o - 1 }) : void 0, p = l ? [] : Hl(a, n), m = s > 1 ? n("chatPanel.tool.group.summary", { count: o }) : void 0;
	return /* @__PURE__ */ X("div", {
		className: "flex w-full min-w-0 flex-col",
		children: [/* @__PURE__ */ X("button", {
			type: "button",
			onClick: () => {
				i((e) => !e);
			},
			"aria-expanded": r,
			"aria-label": n(r ? "chatPanel.tool.group.collapse" : "chatPanel.tool.group.expand"),
			className: M("flex w-full items-center gap-2 rounded py-1 text-left text-xs text-muted-foreground", "hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"),
			children: [
				/* @__PURE__ */ Y("span", {
					className: "shrink-0",
					children: /* @__PURE__ */ Y(Bl, { status: u })
				}),
				/* @__PURE__ */ Y("span", {
					className: "truncate",
					children: d
				}),
				l && c && /* @__PURE__ */ Y(Vl, { part: c }),
				f && /* @__PURE__ */ Y("span", {
					className: "shrink-0 text-muted-foreground/70",
					children: f
				}),
				p.length > 0 && /* @__PURE__ */ X("span", {
					className: "shrink-0 text-muted-foreground/70",
					children: ["· ", p.join(" · ")]
				}),
				m && /* @__PURE__ */ X("span", {
					className: "shrink-0 text-muted-foreground/70",
					children: ["· ", m]
				}),
				/* @__PURE__ */ Y("span", {
					"aria-hidden": "true",
					className: "ml-auto shrink-0 text-muted-foreground/60",
					children: Y(r ? dn : pn, { className: "h-3 w-3" })
				})
			]
		}), r && /* @__PURE__ */ Y("div", {
			className: "ml-[5px] flex flex-col border-l border-border/60 pl-3",
			children: e.map((e, n) => /* @__PURE__ */ Y(Ll, {
				part: e,
				isStreaming: t,
				isExpandedInGroup: !0
			}, n))
		})]
	});
}
//#endregion
//#region src/components/tool-call-approval.tsx
function Gl({ label: e, isAwaiting: t, isApproved: n, onDecide: r }) {
	let { t: i } = Z();
	return /* @__PURE__ */ X("div", {
		className: "flex w-full min-w-0 flex-col gap-2 rounded-md border border-border/60 px-3 py-2 text-xs",
		children: [/* @__PURE__ */ X("div", {
			className: "flex min-w-0 items-center gap-2",
			children: [
				t && /* @__PURE__ */ Y(tr, { className: "h-3 w-3 shrink-0 text-info" }),
				!t && n && /* @__PURE__ */ Y(er, { className: "h-3 w-3 shrink-0 text-success" }),
				!t && !n && /* @__PURE__ */ Y(nr, { className: "h-3 w-3 shrink-0 text-muted-foreground" }),
				/* @__PURE__ */ Y("span", {
					className: "truncate",
					children: e
				})
			]
		}), t ? /* @__PURE__ */ X("div", {
			className: "flex items-center gap-2",
			children: [
				/* @__PURE__ */ Y("span", {
					className: "text-muted-foreground",
					children: i("chatPanel.tool.approval.question")
				}),
				/* @__PURE__ */ Y(I, {
					size: "sm",
					onClick: () => {
						r(!0);
					},
					children: i("chatPanel.tool.approval.approve")
				}),
				/* @__PURE__ */ Y(I, {
					size: "sm",
					variant: "outline",
					onClick: () => {
						r(!1);
					},
					children: i("chatPanel.tool.approval.deny")
				})
			]
		}) : /* @__PURE__ */ Y("span", {
			className: "text-muted-foreground",
			children: i(n ? "chatPanel.tool.approval.approved" : "chatPanel.tool.approval.denied")
		})]
	});
}
function Kl({ part: e }) {
	let { t } = Z(), { respondToToolApproval: n } = Bi(), { approval: r, state: i } = e;
	return r ? /* @__PURE__ */ Y(Gl, {
		label: Il(e, t),
		isAwaiting: i === "approval-requested" && !r.isAutomatic,
		isApproved: r.approved === !0,
		onDecide: (e) => {
			n({
				id: r.id,
				approved: e
			});
		}
	}) : null;
}
//#endregion
//#region src/components/file-card.tsx
var ql = "\n  group flex min-w-0 max-w-full items-center gap-3 rounded-md border border-border/70 bg-card px-3 py-2 text-xs\n  text-muted-foreground transition-colors\n";
function Jl({ conversationId: e, origin: t, path: n, size: r }) {
	let { t: i } = Z(), [a, o] = G();
	H(() => {
		if (!e) {
			o(void 0);
			return;
		}
		let r = !1;
		return o(void 0), (async () => {
			try {
				let { downloadUrl: i } = await Ce(e, {
					origin: t,
					path: n
				});
				r || o(i);
			} catch {
				r || o(void 0);
			}
		})(), () => {
			r = !0;
		};
	}, [
		e,
		t,
		n
	]);
	let s = /* @__PURE__ */ X(J, { children: [
		/* @__PURE__ */ Y(Cn, { className: "h-4 w-4 shrink-0 text-primary" }),
		/* @__PURE__ */ Y("span", {
			className: "min-w-0 flex-1 truncate font-medium text-foreground",
			title: n,
			children: n
		}),
		r !== void 0 && /* @__PURE__ */ Y("span", {
			className: "shrink-0 text-muted-foreground",
			children: el(r)
		}),
		/* @__PURE__ */ Y(yn, { className: "h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-foreground" }),
		/* @__PURE__ */ Y("span", {
			className: "sr-only",
			children: i("fileCard.download")
		})
	] });
	return a ? /* @__PURE__ */ Y("a", {
		href: a,
		download: n.split("/").pop() || n,
		className: `${ql} cursor-pointer hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30`,
		children: s
	}) : /* @__PURE__ */ Y("div", {
		className: `${ql} cursor-default opacity-70`,
		"aria-disabled": "true",
		children: s
	});
}
//#endregion
//#region src/components/archived-notice.tsx
function Yl({ archivedBy: e, className: t }) {
	let { t: n } = Z(), r = n(e === "system" ? "chatPanel.archived.system" : "chatPanel.archived.admin");
	return /* @__PURE__ */ X("div", {
		role: "status",
		className: M("flex items-start gap-3 rounded-md border border-border bg-muted/50 p-4 text-sm text-muted-foreground", t),
		children: [/* @__PURE__ */ Y(Zt, { className: "mt-0.5 h-4 w-4 shrink-0" }), /* @__PURE__ */ Y(L, {
			className: "text-sm",
			children: r
		})]
	});
}
//#endregion
//#region src/components/ai-elements/conversation.tsx
function Xl({ className: e, contextRef: t, ...n }) {
	return /* @__PURE__ */ Y(Wr, {
		className: M("relative flex-1 overflow-y-hidden", e),
		initial: "instant",
		resize: "instant",
		role: "log",
		contextRef: t,
		...n
	});
}
function Zl({ className: e, ...t }) {
	return /* @__PURE__ */ Y(Wr.Content, {
		id: "conversation-content",
		className: M("conversation-container flex min-w-0 flex-col gap-stack-lg px-(--spacing-page) py-section", e),
		...t
	});
}
function Ql({ className: e, ...t }) {
	let { isAtBottom: n, scrollToBottom: r } = Gr(), i = B(async () => {
		await r();
	}, [r]);
	return !n && /* @__PURE__ */ Y(I, {
		className: M("absolute bottom-4 left-[50%] translate-x-[-50%] rounded-full", e),
		onClick: i,
		size: "icon",
		type: "button",
		variant: "outline",
		...t,
		children: /* @__PURE__ */ Y(Qt, { className: "size-4" })
	});
}
//#endregion
//#region src/components/turn-error-notice.tsx
var $l = (e) => M("message-margin-right flex max-w-lg flex-col gap-2 rounded-lg border px-3 py-2 text-sm", e === "info" ? "border-info/50 bg-info/10" : "border-destructive/50 bg-destructive/10");
function eu({ error: e }) {
	let { t } = Z(), n = ee(e)?.explanation;
	return n ? /* @__PURE__ */ X("details", {
		className: "text-xs text-muted-foreground",
		children: [/* @__PURE__ */ Y("summary", {
			className: "cursor-pointer hover:text-foreground",
			children: t("chatPanel.error.details")
		}), /* @__PURE__ */ Y("pre", {
			className: "mt-1 whitespace-pre-wrap font-mono",
			children: n
		})]
	}) : null;
}
function tu({ message: e, onRetry: t, children: n }) {
	let { t: r } = Z();
	return /* @__PURE__ */ X("div", {
		className: $l("info"),
		children: [
			/* @__PURE__ */ Y("div", {
				className: "text-info-text",
				children: e
			}),
			t && /* @__PURE__ */ Y("div", { children: /* @__PURE__ */ Y(I, {
				variant: "outline",
				size: "sm",
				onClick: t,
				children: r("chatPanel.error.retryButton")
			}) }),
			n
		]
	});
}
function nu({ error: e, isLoading: t = !1, onRetry: n }) {
	let { t: r } = Z();
	return /* @__PURE__ */ Y(tu, {
		message: r("chatPanel.error.providerUnavailable"),
		onRetry: t ? void 0 : n,
		children: /* @__PURE__ */ Y(eu, { error: e })
	});
}
function ru({ error: e, isLoading: t = !1, onRetry: n }) {
	let { t: r } = Z();
	return /* @__PURE__ */ Y(tu, {
		message: r("chatPanel.error.sandboxUnavailable"),
		onRetry: t ? void 0 : n,
		children: /* @__PURE__ */ Y(eu, { error: e })
	});
}
function iu({ onRetry: e }) {
	let { t } = Z();
	return /* @__PURE__ */ Y(tu, {
		message: t("chatPanel.connection.lost"),
		onRetry: e
	});
}
function au({ connection: e, onRetry: t }) {
	let { t: n } = Z();
	return e === "reconnecting" ? /* @__PURE__ */ X("div", {
		role: "status",
		"aria-label": n("chatPanel.connection.reconnecting"),
		className: M(Wc, "flex items-center gap-2 text-muted-foreground"),
		children: [/* @__PURE__ */ Y(q, {
			"aria-hidden": "true",
			className: "h-3 w-3 animate-spin text-info"
		}), n("chatPanel.connection.reconnecting")]
	}) : e === "lost" ? /* @__PURE__ */ Y(iu, { onRetry: t }) : null;
}
function ou({ error: e }) {
	let { t } = Z();
	return /* @__PURE__ */ X("div", {
		className: $l("destructive"),
		children: [/* @__PURE__ */ Y("div", {
			className: "text-destructive",
			children: t("chatPanel.error.generic")
		}), /* @__PURE__ */ Y(eu, { error: e })]
	});
}
//#endregion
//#region src/components/chat-panel.tsx
var su = Ft(async () => {
	let { MessageResponse: e } = await import("./message-jvQFZ7yZ.js");
	return { default: e };
});
function cu({ messages: e, onSendMessage: t, onStopGeneration: n, onRenameConversation: r, onRegenerateTitle: i, isLoading: a = !1, isConversationLoading: o = !1, isStopping: s = !1, conversationId: c, conversation: l, error: u, isMainContentVisible: d = !0, evaluationControl: f, className: p, style: m, isInert: h }) {
	let g = l?.title, _ = !!l?.archivedAt, v = l?.model ?? Lc(e), y = l?.archivedBy, b = Ui(), [x, S] = G(""), C = W(/* @__PURE__ */ new Set()), w = W(c);
	H(() => {
		w.current !== c && (S(""), w.current = c);
	}, [c]);
	let T = (e, n) => {
		_ || (t(e, n), S(""));
	};
	Yc(S);
	let E = a ? "streaming" : "ready";
	return /* @__PURE__ */ Y("div", {
		className: M("flex h-full flex-col overflow-hidden border-r border-border bg-card transition-colors duration-300", b ? "w-full" : "w-md lg:w-lg", p),
		style: m,
		inert: h,
		children: /* @__PURE__ */ Y(lu, {
			messages: e,
			input: x,
			setInput: S,
			onSend: T,
			onSendMessage: t,
			status: E,
			isLoading: a,
			isConversationLoading: o,
			isStopping: s,
			onStopGeneration: n,
			conversationId: c,
			error: u,
			isMobile: b,
			isMainContentVisible: d,
			processedArtifactKeysRef: C,
			conversationTitle: g,
			onRenameConversation: r,
			onRegenerateTitle: i,
			isArchived: _,
			archivedBy: y,
			conversationModelId: v,
			evaluationControl: f
		})
	});
}
function lu({ messages: e, input: t, setInput: n, onSend: r, onSendMessage: i, status: a, isLoading: o, isConversationLoading: s, isStopping: c, onStopGeneration: l, conversationId: u, error: d, isMobile: f, isMainContentVisible: p, processedArtifactKeysRef: m, conversationTitle: h, onRenameConversation: g, onRegenerateTitle: _, isArchived: v, archivedBy: y, conversationModelId: b, evaluationControl: x }) {
	let { t: S } = Z(), { isExhausted: C } = Li(), w = W(null), T = W(!1), E = e.length === 0, D = E && !s, O = D && !f && !p, { connection: ee } = uu(), te = C || ee !== "connected", k = da("Logo"), ne = (e, t) => {
		r(e, t), w.current?.scrollToBottom();
	};
	return H(() => {
		T.current = !1;
	}, [u]), H(() => {
		e.length > 0 && !T.current && (T.current = !0, w.current?.scrollToBottom({ animation: "instant" }));
	}, [e.length]), /* @__PURE__ */ Y("div", {
		className: "flex h-full flex-col",
		children: O ? /* @__PURE__ */ X("div", {
			className: "flex min-h-0 flex-1 flex-col items-center justify-center overflow-y-auto p-section",
			children: [k && /* @__PURE__ */ Y("div", {
				className: "mb-6 flex justify-center",
				children: /* @__PURE__ */ Y(k, { variant: "splash" })
			}), /* @__PURE__ */ X("div", {
				className: M(Uc, "py-8"),
				children: [
					/* @__PURE__ */ X("div", {
						className: "mb-8 text-center",
						children: [/* @__PURE__ */ Y(wt, {
							level: "h1",
							size: "5xl",
							responsive: !0,
							className: "font-medium",
							children: S("chatPanel.home.greeting")
						}), /* @__PURE__ */ Y(L, {
							color: "muted",
							className: "mx-auto mt-4 max-w-2xl text-lg",
							children: S("chatPanel.home.subtitle")
						})]
					}),
					C && /* @__PURE__ */ Y(qc, {}),
					/* @__PURE__ */ Y(Gc, {
						input: t,
						setInput: n,
						onSend: ne,
						isLoading: o,
						isStopping: c,
						onStopGeneration: l,
						status: a,
						isMobile: f,
						isHomeSuggestionsVisible: !0,
						isCenteredMode: !0,
						isDisabled: te,
						conversationModelId: b
					})
				]
			})]
		}) : /* @__PURE__ */ X(J, { children: [
			/* @__PURE__ */ X(kt, {
				hasNoBorder: !0,
				className: "z-10 gap-3",
				children: [
					/* @__PURE__ */ Y(I, {
						variant: "ghost",
						size: "icon-sm",
						"aria-label": S("chat.backToList"),
						className: "h-7 w-7 text-muted-foreground",
						isAsChild: !0,
						children: /* @__PURE__ */ Y(K, {
							to: "/conversations",
							children: /* @__PURE__ */ Y($t, { className: "h-4 w-4" })
						})
					}),
					/* @__PURE__ */ Y(L, {
						className: "min-w-0 flex-1 truncate text-sm font-medium",
						children: h && h !== br ? h : S("sidebar.newChat")
					}),
					u && g && _ && /* @__PURE__ */ Y($c, {
						conversationTitle: h ?? "",
						onRename: g,
						onRegenerate: _
					})
				]
			}),
			/* @__PURE__ */ X(Xl, {
				className: "min-h-0 flex-1",
				contextRef: w,
				children: [/* @__PURE__ */ Y(Zl, {
					className: M("gap-stack", !f && "mx-auto w-full max-w-[960px]", !f && !p && "px-page-lg"),
					children: /* @__PURE__ */ Y(fu, {
						messages: e,
						isLoading: o,
						isConversationLoading: s,
						error: d,
						conversationId: u,
						processedArtifactKeysRef: m,
						onContinue: v ? void 0 : () => {
							i(S("chatPanel.continue.message")), w.current?.scrollToBottom();
						},
						onRetry: v ? void 0 : () => {
							i(S("chatPanel.error.retryMessage")), w.current?.scrollToBottom();
						}
					})
				}), /* @__PURE__ */ Y(Ql, {})]
			}),
			v ? /* @__PURE__ */ Y("div", {
				className: M("shrink-0", f ? "p-inline" : "p-section"),
				children: /* @__PURE__ */ Y(Yl, {
					archivedBy: y,
					className: M(!f && "mx-auto w-full max-w-[960px]")
				})
			}) : /* @__PURE__ */ X(J, { children: [C && /* @__PURE__ */ Y("div", {
				className: M("shrink-0", f ? "px-inline pt-inline" : "px-section pt-section"),
				children: /* @__PURE__ */ Y(qc, {})
			}), /* @__PURE__ */ Y(Gc, {
				input: t,
				setInput: n,
				onSend: ne,
				isLoading: o,
				isStopping: c,
				onStopGeneration: l,
				status: a,
				isMobile: f,
				isHomeSuggestionsVisible: D,
				isDisabled: te,
				isAiDisclaimerVisible: !E,
				conversationModelId: b,
				evaluationControl: x
			})] })
		] })
	});
}
function uu() {
	let e = Vi();
	return {
		connection: e?.connection ?? "connected",
		retryConnection: e?.retryConnection
	};
}
function du(e) {
	let t = e.at(-1);
	return t?.role === "assistant" && !!t.metadata?.stoppedAtStepLimit;
}
function fu({ messages: e, isLoading: t, isConversationLoading: n, error: r, conversationId: i, processedArtifactKeysRef: a, onContinue: o, onRetry: s }) {
	let c = da("Logo"), l = Ui(), { t: d } = Z(), { pathname: f } = Wt(), p = ys(cs.agent), { navigateToArtifact: m, shareTokens: h, updateShareToken: g } = ai(), { rightRegion: _ } = ni(), v = W(void 0), { connection: y, retryConnection: b } = uu(), x = U(() => {
		if (_.mode !== "detail" || _.view.type !== "artifact-detail") return;
		let { artifactId: e, version: t } = _.view;
		return t ? `${e}:${t}` : e;
	}, [_]), S = U(() => [...h.entries()].map(([e, t]) => ({
		artifactId: e,
		shareToken: t
	})), [h]), C = B((e) => {
		i && m(i, e);
	}, [i, m]);
	if (H(() => {
		if (!i || e.length === 0) return;
		if (v.current !== i) {
			let t = /* @__PURE__ */ new Set();
			for (let n of e) for (let e of n.parts) {
				if (e.type !== "data-artifact") continue;
				let n = e.data;
				n && t.add(`${n.artifactId}:${n.version}`);
			}
			a.current = t, v.current = i;
			return;
		}
		let t = e.at(-1);
		if (t) for (let e of t.parts) {
			if (e.type !== "data-artifact") continue;
			let t = e.data;
			if (!t) continue;
			let n = `${t.artifactId}:${t.version}`;
			a.current.has(n) || (a.current.add(n), m(i, t));
		}
	}, [
		e,
		i,
		m,
		a
	]), e.length === 0) return n ? null : /* @__PURE__ */ X("div", {
		className: "flex size-full flex-col p-6 text-center",
		children: [c && /* @__PURE__ */ Y("div", {
			className: "flex justify-center pb-3 pt-4",
			children: l ? /* @__PURE__ */ Y("div", {
				className: "size-20",
				children: /* @__PURE__ */ Y(c, { variant: "compact" })
			}) : /* @__PURE__ */ Y(c, { variant: "splash" })
		}), /* @__PURE__ */ X("div", {
			className: "flex flex-1 flex-col items-center justify-center",
			children: [/* @__PURE__ */ Y(wt, {
				level: "h2",
				size: "4xl",
				responsive: !0,
				className: "font-medium",
				children: d("chatPanel.home.greeting")
			}), /* @__PURE__ */ Y(L, {
				color: "muted",
				className: "mt-3 max-w-xl text-base sm:text-lg",
				children: d("chatPanel.home.subtitle")
			})]
		})]
	});
	let T = e.at(-1)?.parts.at(-1), E = T?.type === "text" && T.state === "streaming" && !!T.text?.trim(), D = T !== void 0 && Al(T) && (!("output" in T) || T.output === void 0), O = T?.type === "data-sandbox" && T.data?.status === "pending", ee = y === "resuming" || t && !E && !D && !O, te = t ? [...e].reverse().find((e) => e.role === "assistant")?.id : void 0, k = !!o && !t && du(e);
	return /* @__PURE__ */ X(J, { children: [
		e.map((t, n) => /* @__PURE__ */ Y(hu, {
			message: t,
			isStreaming: t.id === te,
			isLastMessage: n === e.length - 1,
			conversationId: i,
			openArtifact: C,
			openArtifacts: S,
			activeArtifactKey: x,
			updateArtifactShareToken: g
		}, t.id)),
		k && /* @__PURE__ */ X("div", {
			className: "message-margin-right flex max-w-lg flex-col items-start gap-2 rounded-lg border border-info/50 bg-info/10 px-3 py-2 text-sm",
			children: [/* @__PURE__ */ Y(L, {
				className: "text-info-text",
				children: d("chatPanel.continue.notice")
			}), /* @__PURE__ */ X("div", {
				className: "flex flex-wrap items-center gap-3",
				children: [/* @__PURE__ */ Y(I, {
					variant: "outline",
					size: "sm",
					onClick: o,
					children: d("chatPanel.continue.button")
				}), p && /* @__PURE__ */ Y(K, {
					to: p,
					state: { from: f },
					className: "font-medium text-info-text underline underline-offset-2",
					children: d("chatPanel.continue.settingsLink")
				})]
			})]
		}),
		ee && /* @__PURE__ */ Y("div", {
			role: "status",
			"aria-label": d("chatPanel.thinking"),
			className: "message-margin-right w-fit rounded-xl bg-muted/50 px-4 py-2.5 text-sm",
			children: /* @__PURE__ */ X("div", {
				"aria-hidden": "true",
				className: "flex gap-1",
				children: [
					/* @__PURE__ */ Y("span", {
						className: "animate-bounce",
						children: "."
					}),
					/* @__PURE__ */ Y("span", {
						className: "animate-bounce delay-100",
						children: "."
					}),
					/* @__PURE__ */ Y("span", {
						className: "animate-bounce delay-200",
						children: "."
					})
				]
			})
		}),
		/* @__PURE__ */ Y(au, {
			connection: y,
			onRetry: b
		}),
		r && (u(r) ? /* @__PURE__ */ Y(nu, {
			error: r,
			isLoading: t,
			onRetry: s
		}) : w(r) ? /* @__PURE__ */ Y(ru, {
			error: r,
			isLoading: t,
			onRetry: s
		}) : /* @__PURE__ */ Y(ou, { error: r }))
	] });
}
function pu(e) {
	return e.type === "step-start" || e.type === "text" && typeof e.text == "string" && e.text.trim() === "";
}
function mu(e, t) {
	let n = [], r;
	for (let [i, a] of e.parts.entries()) {
		let o = "toolCallId" in a ? a.toolCallId : `${a.type}-${i}`, s = `${e.id}-${o}`;
		if (t && jl(a)) {
			r = void 0, n.push({
				kind: "approval",
				part: a,
				key: s
			});
			continue;
		}
		if (Al(a)) {
			r || (r = [], n.push({
				kind: "tool-group",
				parts: r,
				key: s
			})), r.push(a);
			continue;
		}
		pu(a) || (r = void 0, n.push({
			kind: "part",
			part: a,
			key: s
		}));
	}
	return n;
}
function hu({ message: e, isStreaming: t, isLastMessage: n, conversationId: r, openArtifact: i, openArtifacts: a, activeArtifactKey: o, updateArtifactShareToken: s }) {
	let c = U(() => mu(e, n), [e, n]);
	return /* @__PURE__ */ X("div", {
		className: M("flex min-w-0 flex-col gap-2", e.role === "user" ? "items-end message-margin-left" : "items-start message-margin-right"),
		children: [c.map((n) => n.kind === "tool-group" ? /* @__PURE__ */ Y(Wl, {
			parts: n.parts,
			isStreaming: t
		}, n.key) : n.kind === "approval" ? /* @__PURE__ */ Y(Kl, { part: n.part }, n.key) : /* @__PURE__ */ Y(_u, {
			part: n.part,
			messageRole: e.role,
			conversationId: r,
			openArtifact: i,
			openArtifacts: a,
			activeArtifactKey: o,
			updateArtifactShareToken: s
		}, n.key)), e.role === "assistant" && e.metadata && /* @__PURE__ */ Y(gu, { metadata: e.metadata })]
	});
}
function gu({ metadata: e }) {
	let { inputTokens: t, outputTokens: n, durationMs: r } = e, i = [];
	return t !== void 0 && n !== void 0 && i.push(`${tl(t)} → ${tl(n)} tokens`), r !== void 0 && i.push(nl(r)), i.length === 0 ? null : /* @__PURE__ */ Y("div", {
		className: "text-[11px] text-muted-foreground/50 select-none",
		children: i.join(" · ")
	});
}
function _u({ part: e, messageRole: t, conversationId: n, openArtifact: r, openArtifacts: i, activeArtifactKey: a, updateArtifactShareToken: o }) {
	let { t: s, i18n: c } = Z();
	if (e.type === "text" && e.text) return /* @__PURE__ */ Y("div", {
		className: M("message-content max-w-full break-words text-sm leading-relaxed", t === "user" ? "w-fit rounded-xl bg-muted px-4 py-2.5" : "text-foreground"),
		children: /* @__PURE__ */ Y(Pt, {
			fallback: /* @__PURE__ */ Y("div", {
				className: "whitespace-pre-wrap",
				children: e.text
			}),
			children: /* @__PURE__ */ Y(su, {
				translations: s("streamdown", { returnObjects: !0 }),
				children: e.text
			}, c.language)
		})
	});
	if (e.type === "data-artifact") return /* @__PURE__ */ Y(vu, {
		part: e,
		conversationId: n,
		openArtifact: r,
		openArtifacts: i,
		activeArtifactKey: a,
		updateArtifactShareToken: o
	});
	if (e.type === "data-file" && "data" in e) {
		let t = e.data;
		return /* @__PURE__ */ Y("div", {
			className: "min-w-0 max-w-full",
			children: /* @__PURE__ */ Y(Jl, {
				conversationId: n,
				origin: t.origin ?? "workflow",
				path: t.path,
				size: t.size
			})
		});
	}
	if (e.type === "data-sandbox" && "data" in e) {
		let { wait: t, status: n } = e.data;
		return /* @__PURE__ */ X("div", {
			className: "flex w-full min-w-0 items-center gap-2 py-1 text-xs text-muted-foreground",
			children: [/* @__PURE__ */ X("div", {
				className: "shrink-0",
				children: [
					n === "pending" && /* @__PURE__ */ Y(q, { className: "h-3 w-3 animate-spin text-info" }),
					n === "done" && /* @__PURE__ */ Y(ln, { className: "h-3 w-3 text-success" }),
					n === "failed" && /* @__PURE__ */ Y(Yt, { className: "h-3 w-3 text-destructive" })
				]
			}), /* @__PURE__ */ Y("span", {
				className: "truncate",
				children: s(`chatPanel.sandbox.${t}.${n}`)
			})]
		});
	}
	return (e.type === "tool-web_search" || e.type === "tool-call" && "toolName" in e && e.toolName === "web_search") && "state" in e && (e.state === "output-available" || !e.state) ? /* @__PURE__ */ Y(yu, {
		part: e,
		t: s
	}) : null;
}
function vu({ part: e, conversationId: t, openArtifact: n, openArtifacts: r, activeArtifactKey: i, updateArtifactShareToken: a }) {
	let o = e.data, s = r.find((e) => e.artifactId === o.artifactId), c = `${o.artifactId}:${o.version}`;
	return /* @__PURE__ */ Y("div", {
		className: "min-w-0 max-w-full",
		children: /* @__PURE__ */ Y(bl, {
			title: o.title,
			type: o.type,
			version: o.version,
			isActive: i === c,
			onClick: () => {
				n(o);
			},
			conversationId: t,
			artifactId: o.artifactId,
			shareToken: s?.shareToken ?? void 0,
			onShareChange: (e) => {
				a(o.artifactId, e ?? void 0);
			}
		})
	});
}
function yu({ part: e, t }) {
	let n = ("output" in e && e.output)?.sources;
	return /* @__PURE__ */ Y("div", { children: /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-2 rounded-lg bg-muted px-3 py-2 text-sm",
		children: [/* @__PURE__ */ X("div", {
			className: "flex items-center gap-2 text-muted-foreground",
			children: [/* @__PURE__ */ Y(En, { className: "h-4 w-4" }), /* @__PURE__ */ Y("span", { children: t("chatPanel.webSearch.searching") })]
		}), n && n.length > 0 && /* @__PURE__ */ X("div", {
			className: "flex flex-wrap gap-1 text-xs",
			children: [n.slice(0, 3).map((e) => /* @__PURE__ */ Y("a", {
				href: e.url,
				target: "_blank",
				rel: "noopener noreferrer",
				className: "text-primary hover:underline",
				children: new URL(e.url).hostname
			}, e.url)), n.length > 3 && /* @__PURE__ */ X("span", {
				className: "text-muted-foreground",
				children: ["+", n.length - 3]
			})]
		})]
	}) });
}
//#endregion
//#region src/components/ui/scroll-area.tsx
function bu({ className: e, children: t, orientation: n = "vertical", contentClassName: r, ...i }) {
	return /* @__PURE__ */ X(Kr.Root, {
		"data-slot": "scroll-area",
		className: M("relative", e),
		...i,
		children: [
			/* @__PURE__ */ Y(Kr.Viewport, {
				"data-slot": "scroll-area-viewport",
				className: M("focus-visible:ring-ring/50 size-full rounded-[inherit] transition-[color,box-shadow]", "outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:outline-1", r, {
					"overflow-x-hidden! [&>div]:!block [&>div]:!min-w-0": n === "vertical",
					"overflow-y-hidden!": n === "horizontal"
				}),
				children: t
			}),
			/* @__PURE__ */ Y(xu, { orientation: n === "both" ? "vertical" : n }),
			n === "both" && /* @__PURE__ */ Y(xu, { orientation: "horizontal" }),
			/* @__PURE__ */ Y(Kr.Corner, {})
		]
	});
}
function xu({ className: e, orientation: t = "vertical", ...n }) {
	return /* @__PURE__ */ Y(Kr.ScrollAreaScrollbar, {
		"data-slot": "scroll-area-scrollbar",
		orientation: t,
		className: M("flex touch-none p-px transition-colors select-none", t === "vertical" && "h-full w-2.5 border-l border-l-transparent", t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent", e),
		...n,
		children: /* @__PURE__ */ Y(Kr.ScrollAreaThumb, {
			"data-slot": "scroll-area-thumb",
			className: "bg-border relative flex-1 rounded-full"
		})
	});
}
//#endregion
//#region src/hooks/use-conversation-sandbox.ts
function Su(e, t) {
	let { t: n } = Z(), { showToast: r } = Q(), [i, a] = G(), [o, s] = G(!1), c = W(0), l = B(async () => {
		let t = ++c.current;
		if (e) try {
			let n = await b(e);
			t === c.current && a(n);
		} catch (e) {
			console.warn("Failed to load the conversation sandbox:", e);
		}
	}, [e]);
	return H(() => {
		a(void 0), s(!1);
	}, [e]), H(() => {
		l();
	}, [l, t]), {
		sandbox: i,
		isPausing: o,
		pause: B(async () => {
			if (!e) return;
			let t = ++c.current;
			s(!0);
			try {
				let n = await oe(e);
				t === c.current && a(n);
			} catch (e) {
				r(await y(e) ?? n("panel.sandbox.pauseFailed"), "error");
			} finally {
				s(!1);
			}
		}, [
			e,
			r,
			n
		])
	};
}
//#endregion
//#region src/utils/artifacts.ts
function Cu(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = t.get(n.artifactId);
		(!e || n.version > e.version) && t.set(n.artifactId, n);
	}
	return [...t.values()];
}
//#endregion
//#region src/utils/file-tree.ts
function wu(e, t) {
	let n = [], r = /* @__PURE__ */ new Map(), i = (e) => {
		let t = n, i = "";
		for (let n of e) if (i = i ? `${i}/${n}` : n, r.has(i)) t = r.get(i).children;
		else {
			let e = {
				name: n,
				type: "folder",
				path: i,
				children: []
			};
			r.set(i, e), t.push(e), t = e.children;
		}
		return t;
	}, a = new Set(t.map((e) => e.path));
	for (let t of e) {
		if (a.has(t.path)) continue;
		let e = t.path.split("/").filter(Boolean), n = e.slice(0, -1), r = e.at(-1) || t.path;
		i(n).push({
			name: r,
			type: "file",
			path: t.path,
			file: t
		});
	}
	for (let e of t) {
		let t = e.path.split("/").filter(Boolean), n = t.slice(0, -1), r = t.at(-1) || e.path;
		i(n).push({
			name: r,
			type: "file",
			path: e.path,
			upload: {
				id: e.id,
				progress: e.progress,
				error: e.error,
				status: e.status
			}
		});
	}
	let o = (e) => {
		e.sort((e, t) => e.type === "folder" && t.type === "file" ? -1 : e.type === "file" && t.type === "folder" ? 1 : e.name.localeCompare(t.name, void 0, {
			numeric: !0,
			sensitivity: "base"
		}));
		for (let t of e) t.children && o(t.children);
	};
	return o(n), n;
}
function Tu(e) {
	return e.type === "file" ? 1 : e.children?.reduce((e, t) => e + Tu(t), 0) ?? 0;
}
//#endregion
//#region src/components/ui/truncated-name.tsx
function Eu(e) {
	let t = e.lastIndexOf(".");
	return t > 0 && e.length - t <= 10 ? {
		start: e.slice(0, t),
		end: e.slice(t)
	} : e.length <= 12 ? {
		start: e,
		end: ""
	} : {
		start: e.slice(0, -6),
		end: e.slice(-6)
	};
}
function Du({ name: e, className: t }) {
	let n = W(null), [r, i] = G(!1), { start: a, end: o } = Eu(e);
	return Rt(() => {
		let e = n.current;
		if (!e) return;
		let t = () => {
			i(e.scrollWidth > e.clientWidth);
		};
		t();
		let r = new ResizeObserver(t);
		return r.observe(e), () => {
			r.disconnect();
		};
	}, [e]), /* @__PURE__ */ X(P, {
		delayDuration: 400,
		children: [/* @__PURE__ */ Y(F, {
			asChild: !0,
			children: /* @__PURE__ */ X("span", {
				className: M("flex min-w-0", t),
				children: [/* @__PURE__ */ Y("span", {
					ref: n,
					className: "truncate",
					children: a
				}), o && /* @__PURE__ */ Y("span", {
					className: "shrink-0",
					children: o
				})]
			})
		}), r && /* @__PURE__ */ Y(N, {
			side: "top",
			className: "max-w-xs break-words pointer-events-none",
			children: e
		})]
	});
}
//#endregion
//#region src/components/panel/compact-file-tree-node.tsx
function Ou({ node: e, level: t = 0, onFileClick: n, attaching: r }) {
	let { t: i } = Z(), [a, o] = G(!1);
	if (e.type === "folder") {
		let i = Tu(e);
		return /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ X("button", {
			onClick: () => {
				o((e) => !e);
			},
			className: "flex items-center gap-3 w-full min-w-0 px-4 py-2.5 hover:bg-muted/30 hover:cursor-pointer transition-colors text-left",
			style: { paddingLeft: `${t * 16 + 16}px` },
			children: [
				Y(a ? dn : pn, { className: "h-3 w-3 shrink-0 text-muted-foreground" }),
				Y(a ? Tn : wn, { className: "h-4 w-4 shrink-0 text-muted-foreground" }),
				/* @__PURE__ */ Y(Du, {
					name: e.name,
					className: "text-xs font-medium text-foreground flex-1 min-w-0"
				}),
				/* @__PURE__ */ Y("span", {
					className: "text-[10px] text-muted-foreground shrink-0 font-mono bg-muted px-1.5 py-0.5 rounded",
					children: i
				})
			]
		}), a && e.children?.map((e) => /* @__PURE__ */ Y(Ou, {
			node: e,
			level: t + 1,
			onFileClick: n,
			attaching: r
		}, e.path))] });
	}
	let { Icon: s, color: c } = lt(e.name);
	if (e.upload) return e.upload.error ? /* @__PURE__ */ X("div", {
		className: "flex items-center gap-3 w-full min-w-0 px-4 py-2.5 text-left",
		style: { paddingLeft: `${t * 16 + 16}px` },
		children: [/* @__PURE__ */ Y(s, { className: `h-4 w-4 shrink-0 ${c}` }), /* @__PURE__ */ Y(Du, {
			name: `${e.name} (${i("fileSystem.uploadError")})`,
			className: "text-xs font-medium text-destructive flex-1 min-w-0"
		})]
	}) : /* @__PURE__ */ X("div", {
		className: "flex items-center gap-3 w-full min-w-0 px-4 py-2.5 text-left",
		style: { paddingLeft: `${t * 16 + 16}px` },
		children: [
			/* @__PURE__ */ Y(s, { className: `h-4 w-4 shrink-0 ${c}` }),
			/* @__PURE__ */ Y(Du, {
				name: e.name,
				className: "text-xs font-medium text-foreground flex-1 min-w-0"
			}),
			/* @__PURE__ */ X("span", {
				className: "relative text-[10px] shrink-0 font-mono px-1.5 py-0.5 rounded overflow-hidden bg-muted w-10 text-center",
				children: [/* @__PURE__ */ Y("span", {
					className: "absolute inset-0 bg-primary/20 transition-all duration-300",
					style: { width: `${e.upload.progress}%` }
				}), /* @__PURE__ */ Y("span", {
					className: "relative text-muted-foreground",
					children: e.upload.status === "preparing" ? "..." : `${e.upload.progress}%`
				})]
			})
		]
	});
	if (!e.file) return null;
	let { file: l } = e, u = r?.isAttached(l.path) ?? !1;
	return /* @__PURE__ */ X("button", {
		onClick: () => {
			n(l.id);
		},
		className: "group flex items-center gap-3 w-full min-w-0 px-4 py-2.5 hover:bg-muted/30 hover:cursor-pointer transition-colors text-left",
		style: { paddingLeft: `${t * 16 + 16}px` },
		children: [
			/* @__PURE__ */ Y(s, { className: `h-4 w-4 shrink-0 ${c}` }),
			/* @__PURE__ */ Y(Du, {
				name: e.name,
				className: "text-xs font-medium text-foreground flex-1 min-w-0"
			}),
			/* @__PURE__ */ Y("span", {
				className: M("text-[10px] text-muted-foreground shrink-0 font-mono bg-muted px-1.5 py-0.5 rounded", r && (u ? "hidden" : "not-pointer-fine:hidden group-hover:hidden group-focus-within:hidden")),
				children: el(l.size)
			}),
			r && /* @__PURE__ */ Y("span", {
				role: "button",
				tabIndex: 0,
				"aria-pressed": u,
				"aria-label": i(u ? "fileSystem.detach" : "fileSystem.attach"),
				className: M("inline-flex shrink-0 items-center justify-center rounded-md p-1 transition-colors", u ? "bg-current/15 text-primary hover:bg-current/25" : "pointer-fine:hidden text-muted-foreground group-hover:inline-flex group-focus-within:inline-flex hover:bg-accent hover:text-accent-foreground"),
				onClick: (e) => {
					e.stopPropagation(), r.onToggleAttachment(l.path);
				},
				onKeyDown: (e) => {
					(e.key === "Enter" || e.key === " ") && (e.preventDefault(), e.stopPropagation(), r.onToggleAttachment(l.path));
				},
				children: /* @__PURE__ */ Y(Vn, { className: "h-3.5 w-3.5" })
			})
		]
	});
}
//#endregion
//#region src/components/panel/panel-section-card.tsx
function ku({ item: e }) {
	return /* @__PURE__ */ X("button", {
		onClick: e.onClick,
		className: "flex items-center gap-3 w-full min-w-0 px-4 py-2.5 hover:bg-muted/30 hover:cursor-pointer transition-colors text-left",
		children: [
			e.icon,
			/* @__PURE__ */ Y(Du, {
				name: e.label,
				className: "text-xs font-medium text-foreground flex-1 min-w-0"
			}),
			e.meta && /* @__PURE__ */ Y("span", {
				className: "text-[10px] text-muted-foreground shrink-0 font-mono bg-muted px-1.5 py-0.5 rounded",
				children: e.meta
			})
		]
	});
}
function Au({ headerIcon: e, title: t, subtitle: n, headerAction: r, children: i, items: a, maxVisible: o, emptyState: s, showMoreLabel: c, showLessLabel: l }) {
	let [u, d] = G(!1), f = i ? jt.toArray(i) : a?.map((e) => /* @__PURE__ */ Y(ku, { item: e }, e.id)), p = f && f.length > 0, m = p && o !== void 0 && f.length > o, h = m && !u ? f.slice(0, o) : f;
	return /* @__PURE__ */ X("div", {
		className: "rounded-xl bg-background border border-border shadow-sm overflow-hidden",
		children: [/* @__PURE__ */ X("div", {
			className: "flex items-center justify-between w-full px-4 py-3",
			children: [/* @__PURE__ */ X("div", {
				className: "flex items-center gap-3",
				children: [e, /* @__PURE__ */ X("div", {
					className: "text-left",
					children: [/* @__PURE__ */ Y("h3", {
						className: "text-sm font-semibold text-foreground",
						children: t
					}), /* @__PURE__ */ Y("p", {
						className: "text-xs text-muted-foreground",
						children: n
					})]
				})]
			}), r && /* @__PURE__ */ Y("div", {
				className: "shrink-0",
				children: r
			})]
		}), /* @__PURE__ */ X("div", {
			className: "border-t border-border",
			children: [
				p && h,
				m && /* @__PURE__ */ Y("button", {
					onClick: () => {
						d((e) => !e);
					},
					className: "flex items-center justify-center gap-1 w-full px-4 py-2 text-xs text-muted-foreground hover:text-foreground hover:cursor-pointer transition-colors border-t border-border",
					children: u ? /* @__PURE__ */ X(J, { children: [l, /* @__PURE__ */ Y(mn, { className: "h-3 w-3" })] }) : /* @__PURE__ */ X(J, { children: [c, /* @__PURE__ */ Y(dn, { className: "h-3 w-3" })] })
				}),
				!p && s && /* @__PURE__ */ Y("div", {
					className: "px-4 py-3 text-xs text-muted-foreground",
					children: s
				})
			]
		})]
	});
}
//#endregion
//#region src/components/panel/sandbox-section.tsx
var ju = {
	none: "bg-muted-foreground/40",
	starting: "bg-sky-500 animate-pulse",
	active: "bg-emerald-500",
	paused: "bg-amber-500"
};
function Mu(e, t) {
	let n = e.toDateString() === (/* @__PURE__ */ new Date()).toDateString();
	return new Intl.DateTimeFormat(t, n ? {
		hour: "2-digit",
		minute: "2-digit"
	} : {
		day: "numeric",
		month: "short",
		hour: "2-digit",
		minute: "2-digit"
	}).format(e);
}
function Nu({ isBusy: e, isPausing: t, onPause: n }) {
	let { t: r } = Z(), i = /* @__PURE__ */ X(I, {
		size: "sm",
		variant: "ghost",
		className: "gap-1.5 h-7 text-xs",
		disabled: e || t,
		onClick: n,
		children: [t ? /* @__PURE__ */ Y(q, { className: "h-3.5 w-3.5 animate-spin" }) : /* @__PURE__ */ Y(Hn, { className: "h-3.5 w-3.5" }), r(t ? "panel.sandbox.pausing" : "panel.sandbox.pause")]
	});
	return !e || t ? i : /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
		asChild: !0,
		children: /* @__PURE__ */ Y("span", {
			className: "inline-flex",
			children: i
		})
	}), /* @__PURE__ */ Y(N, { children: r("panel.sandbox.pauseBusy") })] });
}
function Pu({ status: e, since: t, isBusy: n = !1, isPausing: r = !1, onPause: i }) {
	let { t: a, i18n: o } = Z();
	return /* @__PURE__ */ Y(Au, {
		headerIcon: /* @__PURE__ */ Y(ct, { feature: "sandbox" }),
		title: a("panel.sandbox.title"),
		subtitle: a(`panel.sandbox.status.${e}`),
		headerAction: e === "active" && i ? /* @__PURE__ */ Y(Nu, {
			isBusy: n,
			isPausing: r,
			onPause: i
		}) : void 0,
		children: /* @__PURE__ */ X("div", {
			className: "flex items-start gap-3 px-4 py-3",
			children: [/* @__PURE__ */ Y("span", {
				"aria-hidden": "true",
				className: M("mt-1 h-2 w-2 shrink-0 rounded-full", ju[e])
			}), /* @__PURE__ */ X("div", {
				className: "min-w-0 text-xs",
				children: [t && e !== "none" && /* @__PURE__ */ Y("p", {
					className: "font-medium text-foreground",
					children: a("panel.sandbox.since", { time: Mu(t, o.language) })
				}), /* @__PURE__ */ Y("p", {
					className: "text-muted-foreground",
					children: a(`panel.sandbox.hint.${e}`)
				})]
			})]
		})
	});
}
//#endregion
//#region src/components/panel/sections-column.tsx
function Fu({ conversationId: e, isStreaming: t = !1, className: n }) {
	let { t: r } = Z(), { files: i, uploads: a, addFiles: o } = pi(), { files: s, isLoading: c } = _i(), { openDetail: l } = ni(), { open: u, inputElement: d } = zc({ onFiles: o }), { isAttached: f, toggleAttachment: p } = Si(), [m, h] = G([]), { sandbox: g, isPausing: v, pause: y } = Su(e, t), b = U(() => ({
		isAttached: (e) => f({
			origin: "user",
			path: e
		}),
		onToggleAttachment(e) {
			p({
				origin: "user",
				path: e
			});
		}
	}), [f, p]), x = U(() => ({
		isAttached: (e) => f({
			origin: "workflow",
			path: e
		}),
		onToggleAttachment(e) {
			p({
				origin: "workflow",
				path: e
			});
		}
	}), [f, p]), S = B(async (e) => {
		try {
			h(Cu(await _(e)));
		} catch (e) {
			console.warn("Failed to load artifacts for sections column:", e);
		}
	}, []);
	H(() => {
		h([]), e && S(e);
	}, [e, S]), mi(t, () => {
		e && S(e);
	});
	let C = U(() => wu(i, a), [i, a]), w = U(() => wu(s, []), [s]), T = U(() => [...m].reverse().map((e) => ({
		id: e.id,
		icon: /* @__PURE__ */ Y(ut, {
			type: e.type,
			size: "sm",
			className: "shrink-0"
		}),
		label: e.title,
		meta: `v${e.version}`,
		onClick() {
			l({
				type: "artifact-detail",
				artifactId: e.artifactId
			});
		}
	})), [m, l]);
	return /* @__PURE__ */ Y("div", {
		className: M("h-full overflow-hidden", n),
		children: /* @__PURE__ */ X(bu, {
			className: "h-full",
			children: [d, /* @__PURE__ */ X("div", {
				className: "p-4 space-y-4",
				children: [
					/* @__PURE__ */ Y(Au, {
						headerIcon: /* @__PURE__ */ Y(ct, { feature: "file" }),
						title: r("panel.sections.files"),
						subtitle: r("panel.sections.filesCount", { count: i.length }),
						headerAction: /* @__PURE__ */ X(I, {
							onClick: u,
							size: "sm",
							variant: "ghost",
							className: "gap-1.5 h-7 text-xs",
							children: [/* @__PURE__ */ Y(ur, { className: "h-3.5 w-3.5" }), r("fileSystem.addFiles")]
						}),
						maxVisible: 5,
						showMoreLabel: r("panel.sections.showMoreFiles"),
						showLessLabel: r("panel.sections.showLessFiles"),
						emptyState: r("fileSystem.emptyHint"),
						children: C.map((e) => /* @__PURE__ */ Y(Ou, {
							node: e,
							attaching: b,
							onFileClick: (e) => {
								l({
									type: "file-detail",
									fileId: e,
									origin: "user"
								});
							}
						}, e.path))
					}),
					s.length > 0 && /* @__PURE__ */ Y(Au, {
						headerIcon: /* @__PURE__ */ Y(ct, { feature: "agent" }),
						title: r("panel.sections.producedFiles"),
						subtitle: c ? "" : r("panel.sections.producedFilesCount", { count: s.length }),
						maxVisible: 5,
						showMoreLabel: r("panel.sections.showMoreProducedFiles"),
						showLessLabel: r("panel.sections.showLessProducedFiles"),
						children: w.map((e) => /* @__PURE__ */ Y(Ou, {
							node: e,
							attaching: x,
							onFileClick: (e) => {
								l({
									type: "file-detail",
									fileId: e,
									origin: "workflow"
								});
							}
						}, e.path))
					}),
					m.length > 0 && /* @__PURE__ */ Y(Au, {
						headerIcon: /* @__PURE__ */ Y(ct, { feature: "artifact" }),
						title: r("panel.sections.artifacts"),
						subtitle: r("panel.sections.artifactsCount", { count: m.length }),
						items: T,
						maxVisible: 10,
						showMoreLabel: r("panel.sections.showMoreArtifacts"),
						showLessLabel: r("panel.sections.showLessArtifacts")
					}),
					e && g && /* @__PURE__ */ Y(Pu, {
						status: g.status,
						since: g.since ? new Date(g.since) : void 0,
						isBusy: t,
						isPausing: v,
						onPause: () => {
							y();
						}
					})
				]
			})]
		})
	});
}
//#endregion
//#region src/components/panel/panel-detail-header.tsx
function Iu({ title: e, actions: t, onClose: n }) {
	let { t: r } = Z(), i = r("panel.closeDetail");
	return /* @__PURE__ */ X("div", {
		className: "flex items-center gap-2 border-b border-border p-2 md:px-3 md:py-1.5",
		children: [e ? /* @__PURE__ */ Y(wt, {
			level: "h2",
			size: "sm",
			className: "truncate font-medium flex-1",
			title: e,
			children: e
		}) : /* @__PURE__ */ Y("div", { className: "flex-1" }), /* @__PURE__ */ X("div", {
			className: "flex items-center gap-2 shrink-0",
			children: [t && /* @__PURE__ */ X(J, { children: [t, /* @__PURE__ */ Y("span", {
				"aria-hidden": !0,
				className: "hidden h-5 w-px bg-border md:block"
			})] }), /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
				asChild: !0,
				children: /* @__PURE__ */ Y(I, {
					type: "button",
					variant: "ghost",
					size: "icon-sm",
					"aria-label": i,
					className: "size-8",
					onClick: n,
					children: /* @__PURE__ */ Y(mr, { className: "size-4" })
				})
			}), /* @__PURE__ */ Y(N, { children: i })] })]
		})]
	});
}
//#endregion
//#region src/components/panel/panel-file-detail-view.tsx
function Lu({ conversationId: e, fileId: t, origin: n, onClose: r }) {
	let { t: i, i18n: a } = Z(), { Icon: o } = pt("agent"), { files: s, removeFile: c } = pi(), { files: l } = _i(), { isAttached: u, toggleAttachment: d } = Si(), [f, p] = G(), [m, h] = G(!1), [g, _] = G(!1), [v, y] = G(!1), b = (n === "user" ? s : l).find((e) => e.id === t);
	if (H(() => {
		if (!e || !t || b?.uploadStatus !== "completed") {
			p(void 0), h(!1);
			return;
		}
		let n = !1;
		return p(void 0), h(!0), (async () => {
			try {
				let r = await x(e, t);
				n || p(r.downloadUrl);
			} catch {
				n || p(void 0);
			} finally {
				n || h(!1);
			}
		})(), () => {
			n = !0;
		};
	}, [
		e,
		t,
		b?.uploadStatus
	]), !b) return /* @__PURE__ */ X("div", {
		className: "flex h-full w-full flex-col overflow-hidden",
		children: [/* @__PURE__ */ Y(Iu, { onClose: r }), /* @__PURE__ */ Y("div", {
			className: "flex-1 overflow-hidden",
			children: /* @__PURE__ */ Y(R, {
				variant: "error",
				title: i("fileDetail.notFound")
			})
		})]
	});
	let S = b.path.split("/").pop() || b.path, C = b.completedAt ?? b.createdAt;
	return /* @__PURE__ */ X("div", {
		className: "flex h-full w-full flex-col overflow-hidden",
		children: [
			/* @__PURE__ */ Y(Iu, {
				title: S,
				actions: f ? /* @__PURE__ */ Y(I, {
					variant: "ghost",
					size: "sm",
					className: "gap-2",
					isAsChild: !0,
					children: /* @__PURE__ */ Y("a", {
						href: f,
						download: S,
						children: /* @__PURE__ */ Y(yn, { className: "h-4 w-4" })
					})
				}) : m ? /* @__PURE__ */ Y(I, {
					variant: "ghost",
					size: "sm",
					className: "gap-2",
					disabled: !0,
					children: /* @__PURE__ */ Y(q, { className: "h-4 w-4 animate-spin" })
				}) : /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
					asChild: !0,
					children: /* @__PURE__ */ Y("span", {
						className: "inline-flex",
						children: /* @__PURE__ */ Y(I, {
							variant: "ghost",
							size: "sm",
							className: "gap-2",
							disabled: !0,
							children: /* @__PURE__ */ Y(yn, { className: "h-4 w-4" })
						})
					})
				}), /* @__PURE__ */ Y(N, { children: i("fileDetail.downloadComingSoon") })] }),
				onClose: r
			}),
			/* @__PURE__ */ Y("div", {
				className: "flex-1 overflow-auto p-page",
				children: /* @__PURE__ */ X(Tt, {
					gap: "stack-lg",
					className: "mx-auto max-w-lg",
					children: [
						/* @__PURE__ */ X("div", {
							className: "flex items-start gap-4 rounded-lg border border-border bg-card p-4",
							children: [/* @__PURE__ */ Y(xn, { className: "h-10 w-10 shrink-0 text-muted-foreground" }), /* @__PURE__ */ X(Tt, {
								gap: "inline",
								className: "min-w-0 flex-1",
								children: [
									/* @__PURE__ */ X("div", {
										className: "flex flex-wrap items-center gap-2",
										children: [/* @__PURE__ */ Y(L, {
											weight: "medium",
											className: "truncate",
											children: S
										}), n === "workflow" && /* @__PURE__ */ X(Ea, {
											variant: "muted",
											children: [/* @__PURE__ */ Y(o, { className: "h-3 w-3" }), i("fileDetail.producedByAssistant")]
										})]
									}),
									/* @__PURE__ */ X("div", {
										className: "space-y-1 text-sm text-muted-foreground",
										children: [/* @__PURE__ */ X("p", { children: [
											/* @__PURE__ */ X("span", {
												className: "font-medium",
												children: [i("fileDetail.size"), ":"]
											}),
											" ",
											el(b.size)
										] }), /* @__PURE__ */ X("p", { children: [
											/* @__PURE__ */ X("span", {
												className: "font-medium",
												children: [i("fileDetail.lastUpdated"), ":"]
											}),
											" ",
											rl(new Date(C), a.language)
										] })]
									}),
									/* @__PURE__ */ X(I, {
										variant: "outline",
										size: "sm",
										className: "gap-2 self-start",
										"aria-pressed": u({
											origin: n,
											path: b.path
										}),
										onClick: () => {
											d({
												origin: n,
												path: b.path
											});
										},
										children: [/* @__PURE__ */ Y(Vn, { className: M("h-4 w-4", u({
											origin: n,
											path: b.path
										}) && "text-primary") }), u({
											origin: n,
											path: b.path
										}) ? i("fileSystem.detach") : i("fileSystem.attach")]
									})
								]
							})]
						}),
						/* @__PURE__ */ X("div", {
							className: "rounded-lg border border-dashed border-border bg-muted/30 p-6 text-center",
							children: [
								/* @__PURE__ */ Y(bn, { className: "mx-auto h-10 w-10 text-muted-foreground/50" }),
								/* @__PURE__ */ Y(L, {
									variant: "body",
									weight: "medium",
									className: "mt-3 text-sm",
									children: i("fileDetail.preview.title")
								}),
								/* @__PURE__ */ Y(L, {
									variant: "caption",
									color: "muted",
									className: "mt-1",
									children: i("fileDetail.preview.body")
								}),
								/* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
									asChild: !0,
									children: /* @__PURE__ */ Y("span", {
										className: "mt-3 inline-flex",
										children: /* @__PURE__ */ X(I, {
											variant: "outline",
											size: "sm",
											disabled: !0,
											children: [/* @__PURE__ */ Y(bn, { className: "h-4 w-4" }), i("fileDetail.preview.button")]
										})
									})
								}), /* @__PURE__ */ Y(N, { children: i("fileDetail.preview.tooltip") })] })
							]
						}),
						n === "user" && /* @__PURE__ */ Y("div", {
							className: "border-t border-border pt-4",
							children: /* @__PURE__ */ X(I, {
								variant: "ghost-destructive",
								size: "sm",
								className: "gap-2",
								onClick: () => {
									_(!0);
								},
								children: [/* @__PURE__ */ Y(cr, { className: "h-4 w-4" }), i("fileDetail.delete")]
							})
						})
					]
				})
			}),
			/* @__PURE__ */ Y(Qe, {
				open: g,
				onOpenChange: _,
				children: /* @__PURE__ */ X(Xe, {
					showCloseButton: !v,
					children: [/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: i("fileDetail.deleteConfirmTitle") }), /* @__PURE__ */ Y(qe, { children: i("fileDetail.deleteConfirmDescription", { filename: S }) })] }), /* @__PURE__ */ X(Ke, { children: [/* @__PURE__ */ Y(I, {
						variant: "ghost",
						onClick: () => {
							_(!1);
						},
						disabled: v,
						children: i("fileDetail.deleteConfirmCancel")
					}), /* @__PURE__ */ Y(I, {
						variant: "destructive",
						onClick: async () => {
							if (n !== "user") return;
							y(!0);
							let e = await c(t);
							y(!1), _(!1), e && r();
						},
						disabled: v,
						children: i(v ? "fileDetail.deleting" : "fileDetail.deleteConfirmSubmit")
					})] })]
				})
			})
		]
	});
}
//#endregion
//#region src/lib/artifact-registry.tsx
var Ru = Ft(async () => ({ default: (await import("./webpage-artifact-sLfWibHm.js")).WebpageArtifact })), zu = {
	table: { component: Ft(async () => ({ default: (await import("./table-artifact-BcIwVEpj.js")).TableArtifact })) },
	map: { component: Ft(async () => ({ default: (await import("./map-artifact-DVNuLpdc.js")).MapArtifact })) },
	chart: { component: Ft(async () => ({ default: (await import("./chart-artifact-BAeviU1r.js")).ChartArtifact })) },
	webpage: { component: Ru },
	html: { component: Ru }
};
function Bu(e) {
	return zu[e]?.component;
}
//#endregion
//#region src/components/artifact-render-boundary.tsx
function Vu(e, t) {
	return e === t ? !1 : e.length === t.length ? e.some((e, n) => !Object.is(e, t[n])) : !0;
}
var Hu = class extends Mt {
	static getDerivedStateFromError(e) {
		return { error: e };
	}
	state = { error: void 0 };
	componentDidCatch(e, t) {
		this.props.onError(e, t);
	}
	componentDidUpdate(e) {
		this.state.error && Vu(e.resetKeys, this.props.resetKeys) && this.setState({ error: void 0 });
	}
	render() {
		return this.state.error ? this.props.fallbackRender({ error: this.state.error }) : this.props.children;
	}
};
function Uu({ children: e, resetKeys: t, className: n, title: r, description: i }) {
	let { t: a } = Z();
	return /* @__PURE__ */ Y(Hu, {
		resetKeys: t ?? [],
		onError: (e) => {
			console.error("Artifact render error:", e);
		},
		fallbackRender: ({ error: e }) => /* @__PURE__ */ Y(Dt, {
			className: n,
			title: r || a("artifact.error.rendering"),
			description: i || a("artifact.error.renderingDescription"),
			detailsSummary: a("errors.technicalDetails"),
			details: e.message
		}),
		children: e
	});
}
//#endregion
//#region src/components/artifact-wrapper.tsx
function Wu({ Component: e, content: t }) {
	return /* @__PURE__ */ Y(e, { content: t });
}
Wu.displayName = "ArtifactRenderer";
var Gu = It(Wu);
function Ku({ conversationId: e, artifactId: t, version: n }) {
	let { t: i } = Z(), { updateShareToken: a } = ai(), [o, s] = G(void 0), [c, l] = G(void 0), [u, d] = G(!0), [f, p] = G(void 0);
	if (H(() => {
		let i = new AbortController();
		return (async () => {
			try {
				(!o || c === void 0) && d(!0), p(void 0);
				let u = await r(e, t, n, { signal: i.signal });
				s(u.content), l(u.type), u.shareToken && a(t, u.shareToken);
			} catch (e) {
				if (e instanceof Error && e.name === "AbortError") return;
				p(e instanceof Error ? e.message : "Failed to load artifact");
			} finally {
				d(!1);
			}
		})(), () => {
			i.abort();
		};
	}, [
		e,
		t,
		n,
		a
	]), u) return /* @__PURE__ */ Y(R, {
		variant: "loading",
		title: i("artifact.loading")
	});
	if (f) return /* @__PURE__ */ Y(Dt, {
		title: i("artifact.error.loading"),
		description: i("artifact.error.loadingDescription"),
		detailsSummary: i("errors.technicalDetails"),
		details: f,
		className: "h-full"
	});
	if (!o || !c) return /* @__PURE__ */ Y(R, {
		variant: "loading",
		title: i("artifact.loading")
	});
	let m = Bu(c);
	return m ? /* @__PURE__ */ Y(Uu, {
		className: "h-full",
		resetKeys: [
			e,
			t,
			n,
			c
		],
		children: /* @__PURE__ */ Y(Pt, {
			fallback: /* @__PURE__ */ Y(R, {
				variant: "loading",
				title: i("artifact.loading")
			}),
			children: /* @__PURE__ */ Y(Gu, {
				Component: m,
				content: o
			})
		})
	}) : /* @__PURE__ */ Y(Dt, {
		title: i("artifact.error.unsupportedType", { type: c }),
		description: i("artifact.error.unsupportedTypeDescription"),
		className: "h-full"
	});
}
//#endregion
//#region src/components/panel/panel-artifact-detail-view.tsx
function qu({ conversationId: e, artifactId: t, version: n, isExpandable: i = !1, onVersionChange: a, onClose: o }) {
	let { t: s } = Z(), [c, l] = G(void 0), [u, d] = G([]), [f, p] = G(void 0), [m, h] = G(void 0), [g, _] = G(!1), v = W(0), y = W(void 0);
	return H(() => {
		if (!e || !t) return;
		let i = new AbortController();
		v.current += 1;
		let a = v.current;
		return (y.current?.conversationId !== e || y.current?.artifactId !== t) && l(void 0), (async () => {
			try {
				p(void 0), h(void 0);
				let [o, s] = await Promise.all([r(e, t, n, { signal: i.signal }), E(e, t, { signal: i.signal })]);
				if (a !== v.current) return;
				y.current = {
					conversationId: e,
					artifactId: t
				}, l(o), d(s);
			} catch (e) {
				if (e instanceof Error && e.name === "AbortError" || a !== v.current) return;
				p(s("errors.artifactLoadFailed")), h(e instanceof Error ? e.message : void 0);
			}
		})(), () => {
			i.abort();
		};
	}, [
		e,
		t,
		n,
		s
	]), /* @__PURE__ */ X("div", {
		className: "flex h-full w-full flex-col overflow-hidden",
		children: [
			/* @__PURE__ */ Y(Iu, {
				title: c?.title,
				actions: c && /* @__PURE__ */ Y(Ju, {
					artifact: c,
					versions: u,
					isExpandable: i,
					onVersionChange: a,
					onShare: () => {
						_(!0);
					}
				}),
				onClose: o
			}),
			/* @__PURE__ */ Y("div", {
				className: "flex-1 overflow-hidden",
				children: !e || !t ? /* @__PURE__ */ Y(R, {
					variant: "info",
					title: s("errors.invalidConversationOrArtifact")
				}) : f ? m ? /* @__PURE__ */ Y(Dt, {
					title: f,
					description: s("errors.inlineErrorDescription"),
					detailsSummary: s("errors.technicalDetails"),
					details: m,
					className: "h-full"
				}) : /* @__PURE__ */ Y(Dt, {
					title: f,
					description: s("errors.inlineErrorDescription"),
					className: "h-full"
				}) : c ? /* @__PURE__ */ Y(Ku, {
					conversationId: e,
					artifactId: t,
					version: n
				}) : /* @__PURE__ */ Y(R, {
					variant: "loading",
					title: s("artifact.loading")
				})
			}),
			c && e && /* @__PURE__ */ Y(yl, {
				isOpen: g,
				onOpenChange: _,
				conversationId: e,
				artifactId: t,
				artifactVersion: c.version,
				shareToken: c.shareToken,
				onShareChange: (e) => {
					c && l({
						...c,
						shareToken: e
					});
				}
			})
		]
	});
}
function Ju({ artifact: e, versions: t, isExpandable: n, onVersionChange: r, onShare: i }) {
	return /* @__PURE__ */ X(J, { children: [
		t.length > 1 && /* @__PURE__ */ X(va, {
			value: e.version.toString(),
			onValueChange: (e) => {
				r(Number.parseInt(e, 10));
			},
			children: [/* @__PURE__ */ Y(ba, {
				className: "hover:cursor-pointer w-20 h-8 border-none bg-transparent",
				children: /* @__PURE__ */ Y(ya, {})
			}), /* @__PURE__ */ Y(xa, { children: t.map((e) => /* @__PURE__ */ X(Sa, {
				value: e.version.toString(),
				children: ["v", e.version]
			}, e.version)) })]
		}),
		/* @__PURE__ */ Y(_l, {
			isShared: !!e.shareToken,
			onClick: i,
			size: "sm"
		}),
		n && /* @__PURE__ */ Y(Yu, {})
	] });
}
function Yu() {
	let { t: e } = Z(), { rightRegion: t, toggleDetailExpanded: n } = ni(), r = t.mode === "detail" && t.isExpanded, i = e(r ? "artifact.collapse" : "artifact.expand");
	return /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
		asChild: !0,
		children: /* @__PURE__ */ Y(I, {
			type: "button",
			variant: "ghost",
			size: "icon-sm",
			"aria-label": i,
			className: "size-8",
			onClick: n,
			children: /* @__PURE__ */ Y(r ? Ln : Pn, { className: "size-4" })
		})
	}), /* @__PURE__ */ Y(N, { children: i })] });
}
//#endregion
//#region src/components/panel/detail-panel.tsx
function Xu({ conversationId: e, className: t, isExpandable: n = !1 }) {
	let { rightRegion: r, closeDetail: i, openDetail: a, toggleDetailExpanded: o } = ni(), s = W(null), c = r.mode === "detail", l = c && r.isExpanded;
	if (H(() => {
		if (!c) return;
		let e = (e) => {
			if (!(e.key !== "Escape" || e.defaultPrevented)) {
				if (e.preventDefault(), l) {
					o();
					return;
				}
				i();
			}
		};
		return document.addEventListener("keydown", e), () => {
			document.removeEventListener("keydown", e);
		};
	}, [
		c,
		l,
		i,
		o
	]), H(() => {
		if (!c) return;
		let e = document.activeElement instanceof HTMLElement ? document.activeElement : void 0;
		return () => {
			e?.isConnected && e.focus();
		};
	}, [c]), r.mode !== "detail") return null;
	let { view: u } = r;
	return /* @__PURE__ */ Y("div", {
		ref: s,
		className: M("flex flex-col h-full overflow-hidden bg-muted", t),
		children: /* @__PURE__ */ Y("div", {
			className: "flex-1 overflow-hidden px-3 pb-3 pt-1.5",
			children: /* @__PURE__ */ X("div", {
				className: "h-full overflow-hidden rounded-lg bg-background",
				children: [u.type === "file-detail" && /* @__PURE__ */ Y(Lu, {
					conversationId: e,
					fileId: u.fileId,
					origin: u.origin,
					onClose: i
				}), u.type === "artifact-detail" && /* @__PURE__ */ Y(qu, {
					conversationId: e,
					artifactId: u.artifactId,
					version: u.version,
					isExpandable: n,
					onClose: i,
					onVersionChange: (e) => {
						a({
							...u,
							version: e
						});
					}
				})]
			})
		})
	});
}
//#endregion
//#region src/components/ui/resize-handle.tsx
function Zu({ onResizeStart: e, ariaLabel: t, className: n }) {
	let [r, i] = G(!1), [a, o] = G(!1);
	return H(() => {
		if (!a) return;
		let e = () => {
			o(!1);
		};
		return document.addEventListener("mouseup", e), () => {
			document.removeEventListener("mouseup", e);
		};
	}, [a]), /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y("div", {
		"aria-hidden": "true",
		"data-slot": "resize-handle-border",
		className: M("absolute inset-y-0 left-0 z-10 w-px bg-primary/20 pointer-events-none transition-all", (r || a) && "w-0.5 bg-muted-foreground")
	}), /* @__PURE__ */ Y("div", {
		role: "separator",
		"aria-orientation": "vertical",
		"aria-label": t,
		"data-slot": "resize-handle",
		className: M("absolute top-0 -left-1.75 z-20 h-full w-4 cursor-col-resize group", n),
		onMouseDown: (t) => {
			o(!0), e?.(t);
		},
		onMouseEnter: () => {
			i(!0);
		},
		onMouseLeave: () => {
			i(!1);
		},
		children: /* @__PURE__ */ Y("div", { className: M("absolute top-1/2 left-1 h-12 w-1.75 -translate-y-1/2 rounded-full bg-primary/20 transition-all group-hover:w-2.5 group-hover:bg-muted-foreground pointer-events-none", (r || a) && "bg-muted-foreground w-2.5") })
	})] });
}
//#endregion
//#region src/hooks/use-reset-panel-on-conversation-change.ts
function Qu(e) {
	let { resetPanel: t } = ni(), n = Ui(), r = W(void 0), i = W(!1);
	H(() => {
		let a = r.current, o = i.current;
		if (o && a === e) return;
		let s = o && a === void 0 && !!e;
		if (r.current = e, i.current = !0, n) {
			t(!1);
			return;
		}
		s || t(!0);
	}, [
		e,
		n,
		t
	]);
}
//#endregion
//#region src/hooks/use-presence.ts
function $u(e, t) {
	let [n, r] = G(e);
	return H(() => {
		if (e) {
			r(!0);
			return;
		}
		let n = setTimeout(() => {
			r(!1);
		}, t);
		return () => {
			clearTimeout(n);
		};
	}, [e, t]), {
		rendered: n,
		dataState: e ? "open" : "closed"
	};
}
//#endregion
//#region src/components/layouts/desktop-layout.tsx
var ed = 340, td = 560, nd = 400, rd = 1e3, id = "detail-panel-width", ad = 300, od = 480;
function sd() {
	if (typeof globalThis > "u" || typeof localStorage > "u") return td;
	let e = localStorage.getItem(id);
	if (!e) return td;
	let t = Number.parseInt(e, 10);
	return Number.isNaN(t) || t < nd || t > rd ? td : t;
}
function cd(e, t, n) {
	return Math.max(t, Math.min(n, e));
}
function ld(e, t) {
	let n = (t) => {
		e(t);
	}, r = () => {
		document.removeEventListener("mousemove", n), document.removeEventListener("mouseup", r), document.body.style.cursor = "", document.body.style.userSelect = "", t();
	};
	return document.body.style.cursor = "col-resize", document.body.style.userSelect = "none", document.addEventListener("mousemove", n), document.addEventListener("mouseup", r), r;
}
function ud({ conversation: e, messages: t, currentConversationId: n, isLoading: r, isConversationLoading: i, isStopping: a, error: o, onSendMessage: s, onStopGeneration: c, onRenameConversation: l, onRegenerateTitle: u, evaluationControl: d }) {
	let { rightRegion: f } = ni(), { isCompact: p, setCompact: m } = na(), [h, g] = G(sd), [_, v] = G(!1), [y, b] = G(0), x = W(h), S = W(null);
	H(() => {
		x.current = h;
	}, [h]), H(() => {
		let e = S.current;
		if (!e) return;
		b(e.offsetWidth);
		let t = new ResizeObserver((e) => {
			let t = e[0];
			t && b(t.contentRect.width);
		});
		return t.observe(e), () => {
			t.disconnect();
		};
	}, []);
	let C = f.mode === "detail", w = f.mode === "idle" && f.sectionsVisible, T = C || w, E = C && f.isExpanded, D = C ? h : 0, O = E ? y : h, ee = w ? ed : 0, te = $u(C, ad), k = $u(w, ad);
	Qu(n), H(() => {
		if (!C || p || !y) return;
		let e = y - h - (w ? ed : 0);
		e < od && e + 188 >= od && m(!0);
	}, [
		p,
		C,
		w,
		y,
		m,
		h
	]), H(() => {
		if (!C || !y) return;
		let e = y - od;
		if (h > e && e >= nd) {
			let t = cd(e, nd, rd);
			g(t);
			try {
				localStorage.setItem(id, String(t));
			} catch {}
		}
	}, [
		C,
		y,
		h
	]);
	let ne = B((e) => {
		e.preventDefault(), v(!0);
		let t = e.clientX, n = x.current, r = S.current?.offsetWidth ?? 0, i = w ? ed : 0, a = Math.max(nd, r - od - i), o = !1;
		ld((e) => {
			let r = cd(n + (t - e.clientX), nd, rd), i = cd(r, nd, o ? a + 188 : a);
			if (r > i && !o && !p) {
				o = !0, m(!0), g(cd(r, nd, a + 188));
				return;
			}
			g(i);
		}, () => {
			v(!1);
			try {
				localStorage.setItem(id, String(x.current));
			} catch {}
		});
	}, [
		p,
		w,
		m
	]), A = _ ? "none" : `width ${ad}ms ease-out`;
	return /* @__PURE__ */ X(Tt, {
		ref: S,
		direction: "horizontal",
		gap: 0,
		className: "h-full overflow-hidden bg-background min-w-0",
		children: [
			/* @__PURE__ */ Y(cu, {
				messages: t,
				onSendMessage: s,
				onStopGeneration: c,
				onRenameConversation: l,
				onRegenerateTitle: u,
				evaluationControl: d,
				isLoading: r,
				isConversationLoading: i,
				isStopping: a,
				conversationId: n,
				conversation: e,
				error: o,
				isMainContentVisible: T,
				className: "flex-1 h-full border-0",
				style: { minWidth: `${od}px` },
				isInert: E
			}),
			/* @__PURE__ */ Y("div", {
				className: M("shrink-0 relative h-full", C ? "overflow-visible" : "overflow-hidden", E && "z-10"),
				style: {
					width: `${D}px`,
					transition: A
				},
				"aria-hidden": !C,
				children: te.rendered && /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y("div", {
					className: M("absolute inset-0", !E && "overflow-hidden"),
					children: /* @__PURE__ */ Y("div", {
						className: "absolute inset-y-0 right-0",
						style: {
							width: `${O}px`,
							transition: A
						},
						children: /* @__PURE__ */ Y(Xu, {
							isExpandable: !0,
							conversationId: n,
							className: "h-full"
						})
					})
				}), !E && /* @__PURE__ */ Y(Zu, {
					ariaLabel: "Resize detail panel",
					onResizeStart: ne
				})] })
			}),
			/* @__PURE__ */ Y("div", {
				className: "shrink-0 h-full overflow-hidden bg-card",
				style: {
					width: `${ee}px`,
					transition: `width ${ad}ms ease-out`
				},
				"aria-hidden": !w,
				children: k.rendered && /* @__PURE__ */ Y("div", {
					className: "h-full",
					style: { width: `${ed}px` },
					children: /* @__PURE__ */ Y(Fu, {
						conversationId: n,
						isStreaming: r,
						className: "h-full"
					})
				})
			})
		]
	});
}
//#endregion
//#region src/components/layouts/mobile-layout.tsx
var dd = 300, fd = `${[
	"absolute inset-0 z-50 bg-background duration-300",
	"data-[state=open]:animate-in data-[state=closed]:animate-out",
	"data-[state=closed]:fill-mode-forwards"
].join(" ")} data-[state=open]:slide-in-from-right data-[state=closed]:slide-out-to-right`;
function pd({ conversation: e, messages: t, currentConversationId: n, isLoading: r, isConversationLoading: i, isStopping: a, error: o, onSendMessage: s, onStopGeneration: c, onRenameConversation: l, onRegenerateTitle: u, evaluationControl: d }) {
	let { rightRegion: f } = ni(), p = f.mode === "detail", m = f.mode === "idle" && f.sectionsVisible, h = p || m, g = $u(m, dd), _ = $u(p, dd);
	return Qu(n), /* @__PURE__ */ X("div", {
		className: "relative h-full overflow-hidden bg-background",
		children: [
			/* @__PURE__ */ Y(cu, {
				messages: t,
				onSendMessage: s,
				onStopGeneration: c,
				onRenameConversation: l,
				onRegenerateTitle: u,
				evaluationControl: d,
				isLoading: r,
				isConversationLoading: i,
				isStopping: a,
				conversationId: n,
				conversation: e,
				error: o,
				isMainContentVisible: h,
				className: "h-full"
			}),
			g.rendered && /* @__PURE__ */ Y("div", {
				"data-state": g.dataState,
				className: fd,
				children: /* @__PURE__ */ Y(Fu, {
					conversationId: n,
					isStreaming: r,
					className: "h-full"
				})
			}),
			_.rendered && /* @__PURE__ */ Y("div", {
				"data-state": _.dataState,
				className: fd,
				children: /* @__PURE__ */ Y(Xu, {
					conversationId: n,
					className: "h-full"
				})
			})
		]
	});
}
//#endregion
//#region src/components/conversation-evaluation-control.tsx
function md({ evaluation: e, onEvaluate: t, className: n }) {
	let { t: r } = Z(), i = Lt(), [a, o] = G(!1), [s, c] = G(""), l = e?.rating, u = a && l === "negative";
	return /* @__PURE__ */ X("div", {
		className: M("flex items-center justify-end gap-1", n),
		children: [
			/* @__PURE__ */ Y(L, {
				variant: "detail",
				color: "muted",
				className: "mr-1",
				children: r("chatPanel.evaluation.question")
			}),
			/* @__PURE__ */ Y(hd, {
				label: r("chatPanel.evaluation.positive"),
				isActive: l === "positive",
				onClick: () => {
					o(!1), t({ rating: l === "positive" ? "neutral" : "positive" });
				},
				children: /* @__PURE__ */ Y(sr, {})
			}),
			/* @__PURE__ */ X(sc, {
				open: u,
				onOpenChange: o,
				children: [/* @__PURE__ */ Y(lc, {
					asChild: !0,
					children: /* @__PURE__ */ Y("span", { children: /* @__PURE__ */ Y(hd, {
						label: r("chatPanel.evaluation.negative"),
						isActive: l === "negative",
						onClick: () => {
							let e = l === "negative";
							c(""), o(!e), t({ rating: e ? "neutral" : "negative" });
						},
						children: /* @__PURE__ */ Y(or, {})
					}) })
				}), /* @__PURE__ */ X(uc, {
					align: "end",
					className: "flex flex-col gap-stack",
					children: [
						/* @__PURE__ */ Y(L, {
							isAsChild: !0,
							variant: "detail",
							children: /* @__PURE__ */ Y("label", {
								htmlFor: i,
								children: r("chatPanel.evaluation.commentLabel")
							})
						}),
						/* @__PURE__ */ Y(He, {
							id: i,
							value: s,
							maxLength: vr,
							placeholder: r("chatPanel.evaluation.commentPlaceholder"),
							onChange: (e) => {
								c(e.target.value);
							}
						}),
						/* @__PURE__ */ Y(I, {
							size: "sm",
							className: "self-end",
							onClick: () => {
								let e = s.trim();
								o(!1), e && t({
									rating: "negative",
									comment: e
								});
							},
							children: r("chatPanel.evaluation.save")
						})
					]
				})]
			})
		]
	});
}
function hd({ label: e, isActive: t, onClick: n, children: r }) {
	return /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
		asChild: !0,
		children: /* @__PURE__ */ Y(I, {
			type: "button",
			variant: "ghost",
			size: "icon-sm",
			"aria-label": e,
			"aria-pressed": t,
			className: M("size-7 text-muted-foreground [&_svg]:size-4", t && "bg-primary/10 text-primary [&_svg]:fill-primary/20"),
			onClick: n,
			children: r
		})
	}), /* @__PURE__ */ Y(N, { children: e })] });
}
//#endregion
//#region src/pages/chat-route.tsx
function gd() {
	let { t: e } = Z(), t = Ui(), n = Bi(), { currentConversationId: r, renameConversation: i, regenerateTitle: a } = n, o = B(async (e) => {
		r && await i(r, e);
	}, [r, i]), s = B(async () => {
		r && await a(r);
	}, [r, a]), { rightRegion: c, toggleSections: l } = ni(), u = c.mode === "detail" || c.sectionsVisible ? e("app.hideMainContent") : e("app.showMainContent"), d = U(() => /* @__PURE__ */ X(P, { children: [/* @__PURE__ */ Y(F, {
		asChild: !0,
		children: /* @__PURE__ */ Y(I, {
			type: "button",
			variant: "ghost",
			size: "icon-sm",
			"aria-label": u,
			className: "size-8 text-muted-foreground",
			onClick: l,
			children: /* @__PURE__ */ Y(Bn, { className: "size-4" })
		})
	}), /* @__PURE__ */ Y(N, {
		side: "bottom",
		children: u
	})] }), [l, u]), f = U(() => /* @__PURE__ */ Y(I, {
		type: "button",
		variant: "default",
		size: "icon",
		"aria-label": u,
		className: "size-10",
		onClick: l,
		children: /* @__PURE__ */ Y(Bn, { className: "size-5" })
	}), [l, u]);
	Ji({
		title: e("nav.conversations"),
		trailing: d,
		mobileTrailing: f
	});
	let p = n.messages.some((e) => e.role === "assistant"), m = n.currentConversationId && p ? /* @__PURE__ */ Y(md, {
		evaluation: n.evaluation,
		onEvaluate: n.evaluateConversation
	}) : void 0, h = {
		conversation: n.conversation,
		messages: n.messages,
		currentConversationId: n.currentConversationId,
		isLoading: n.isLoading,
		isConversationLoading: n.isConversationLoading,
		isStopping: n.isStopping,
		error: n.error,
		onSendMessage: n.handleSendMessage,
		onStopGeneration: n.handleStopGeneration,
		onRenameConversation: o,
		onRegenerateTitle: s,
		evaluationControl: m
	};
	return Y(t ? pd : ud, { ...h });
}
//#endregion
//#region src/pages/share-artifact.tsx
function _d(e) {
	if (e instanceof Or) {
		let { status: t } = e.response;
		if (t === 403) return { type: "invalid-token" };
		if (t === 404) return { type: "not-found" };
		if (t >= 500) return {
			type: "server-error",
			message: e.message
		};
	}
	return e instanceof Error ? {
		type: "unknown",
		message: e.message
	} : { type: "unknown" };
}
function vd(e, t) {
	switch (e.type) {
		case "missing-token": return {
			title: t("share.page.missingToken"),
			description: t("share.page.missingTokenDescription"),
			details: void 0
		};
		case "invalid-token": return {
			title: t("share.page.invalidToken"),
			description: t("share.page.invalidTokenDescription"),
			details: void 0
		};
		case "not-found": return {
			title: t("share.page.notFound"),
			description: t("share.page.notFoundDescription"),
			details: void 0
		};
		case "server-error": return {
			title: t("share.page.serverError"),
			description: t("share.page.serverErrorDescription"),
			details: e.message
		};
		case "unknown": return {
			title: t("share.page.unknownError"),
			description: t("share.page.unknownErrorDescription"),
			details: e.message
		};
	}
}
function yd({ showWatermark: e = !0 } = {}) {
	let { t } = Z(), n = qt(), [r] = Jt(), i = n.shareToken ?? r.get("shareToken"), [a, o] = G(void 0), [s, c] = G(!0), [l, u] = G(void 0);
	if (H(() => {
		(async () => {
			if (!i) {
				u({ type: "missing-token" }), c(!1);
				return;
			}
			try {
				c(!0), u(void 0), o(await p(i));
			} catch (e) {
				u(_d(e));
			} finally {
				c(!1);
			}
		})();
	}, [i]), s) return /* @__PURE__ */ X("div", {
		className: "flex h-screen flex-col",
		children: [/* @__PURE__ */ Y(bd, { showWatermark: e }), /* @__PURE__ */ Y(R, {
			variant: "loading",
			icon: /* @__PURE__ */ Y(q, { className: "h-12 w-12 animate-spin text-primary" }),
			title: t("artifact.loading"),
			className: "flex-1"
		})]
	});
	if (l) {
		let n = vd(l, t);
		return n.details ? /* @__PURE__ */ X("div", {
			className: "flex h-screen flex-col",
			children: [/* @__PURE__ */ Y(bd, { showWatermark: e }), /* @__PURE__ */ Y(Dt, {
				className: "flex-1",
				title: n.title,
				description: n.description,
				detailsSummary: t("errors.technicalDetails"),
				details: n.details
			})]
		}) : /* @__PURE__ */ X("div", {
			className: "flex h-screen flex-col",
			children: [/* @__PURE__ */ Y(bd, { showWatermark: e }), /* @__PURE__ */ Y(Dt, {
				className: "flex-1",
				title: n.title,
				description: n.description
			})]
		});
	}
	if (!a) return /* @__PURE__ */ X("div", {
		className: "flex h-screen flex-col",
		children: [/* @__PURE__ */ Y(bd, { showWatermark: e }), /* @__PURE__ */ Y(Dt, {
			className: "flex-1",
			title: t("share.page.notFound"),
			description: t("share.page.notFoundDescription")
		})]
	});
	let d = Bu(a.type);
	return d ? /* @__PURE__ */ X("div", {
		className: "flex h-screen flex-col overflow-hidden",
		children: [/* @__PURE__ */ Y(bd, {
			title: a.title,
			showWatermark: e
		}), /* @__PURE__ */ Y("div", {
			className: "flex-1 overflow-hidden",
			children: /* @__PURE__ */ Y(Uu, {
				className: "h-full",
				resetKeys: [
					a.slug,
					a.type,
					a.version
				],
				children: /* @__PURE__ */ Y(Pt, {
					fallback: /* @__PURE__ */ Y(R, {
						variant: "loading",
						title: t("artifact.loading")
					}),
					children: /* @__PURE__ */ Y(d, { content: a.content })
				})
			})
		})]
	}) : /* @__PURE__ */ X("div", {
		className: "flex h-screen flex-col",
		children: [/* @__PURE__ */ Y(bd, { showWatermark: e }), /* @__PURE__ */ Y(Dt, {
			className: "flex-1",
			title: t("artifact.error.unsupportedType", { type: a.type }),
			description: t("artifact.error.unsupportedTypeDescription")
		})]
	});
}
function bd({ title: e, showWatermark: t = !0 }) {
	let { t: n } = Z();
	return /* @__PURE__ */ X("header", {
		className: "flex min-h-16 shrink-0 flex-col justify-center gap-1 border-b border-border bg-card px-4 py-3 md:h-16 md:flex-row md:items-center md:justify-between md:gap-4 md:px-6 md:py-0",
		children: [/* @__PURE__ */ Y(wt, {
			level: "h1",
			size: "base",
			className: "truncate md:text-lg",
			children: e || n("share.page.defaultTitle")
		}), t && /* @__PURE__ */ X("div", {
			className: "flex items-center gap-2 text-xs text-muted-foreground",
			children: [
				/* @__PURE__ */ Y("span", { children: n("share.madeWith") }),
				/* @__PURE__ */ Y("a", {
					href: "https://livingdata.co",
					target: "_blank",
					rel: "noopener noreferrer",
					className: "hover:text-foreground",
					children: "Living Data Playground"
				}),
				/* @__PURE__ */ Y("img", {
					src: "/watermark/living-data-logo.png",
					alt: "Living Data Logo",
					className: "h-4"
				})
			]
		})]
	});
}
//#endregion
//#region src/pages/not-found.tsx
function xd() {
	let { t: e } = Z();
	return /* @__PURE__ */ Y(Et, {
		icon: /* @__PURE__ */ Y("div", {
			className: "rounded-full bg-muted p-6",
			children: /* @__PURE__ */ Y(Sn, { className: "h-12 w-12 text-muted-foreground" })
		}),
		title: e("notFound.title"),
		description: e("notFound.description"),
		action: /* @__PURE__ */ Y(I, {
			isAsChild: !0,
			children: /* @__PURE__ */ Y(K, {
				to: Zr(),
				children: e("notFound.backToHome")
			})
		}),
		className: "h-screen w-full bg-background px-4"
	});
}
//#endregion
//#region src/lib/validate-email.ts
var Sd = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function Cd(e) {
	if (!e.trim()) return "required";
	if (!Sd.test(e)) return "invalid";
}
//#endregion
//#region src/services/auth.ts
async function wd(e) {
	return new Promise((t) => {
		setTimeout(t, e);
	});
}
async function Td(e) {
	return await wd(1500), e.endsWith("@error.com") ? {
		success: !1,
		error: "server_error"
	} : e.endsWith("@ratelimited.com") ? {
		success: !1,
		error: "rate_limited"
	} : { success: !0 };
}
//#endregion
//#region src/pages/login-page.tsx
function Ed() {
	let { t: e } = Z(), [t, n] = G(""), [r, i] = G("idle"), [a, o] = G(void 0), [s, c] = G(void 0), l = B(async (e) => {
		e.preventDefault();
		let n = Cd(t);
		if (o(n), n) return;
		i("submitting"), c(void 0);
		let r = await Td(t);
		r.success ? i("success") : (i("error"), c(r.error === "rate_limited" ? "rateLimited" : "serverError"));
	}, [t]), u = B((e) => {
		n(e.target.value), o(void 0);
	}, []);
	if (r === "success") return /* @__PURE__ */ Y("div", {
		className: "flex h-screen w-full items-center justify-center bg-background px-4",
		children: /* @__PURE__ */ X(Tt, {
			gap: 4,
			align: "center",
			className: "max-w-sm text-center",
			children: [
				/* @__PURE__ */ Y("div", {
					className: "rounded-full bg-green-100 p-4 dark:bg-green-900/30",
					children: /* @__PURE__ */ Y(cn, { className: "h-10 w-10 text-green-600 dark:text-green-400" })
				}),
				/* @__PURE__ */ Y(wt, {
					level: "h1",
					size: "xl",
					children: e("login.success.title")
				}),
				/* @__PURE__ */ Y(L, {
					color: "muted",
					children: e("login.success.description")
				})
			]
		})
	});
	let d = a !== void 0 || s !== void 0, f = r === "submitting";
	return /* @__PURE__ */ Y("div", {
		className: "flex h-screen w-full items-center justify-center bg-background px-4",
		children: /* @__PURE__ */ X(Tt, {
			gap: 6,
			align: "center",
			className: "w-full max-w-sm",
			children: [/* @__PURE__ */ X(Tt, {
				gap: 2,
				align: "center",
				className: "text-center",
				children: [/* @__PURE__ */ Y(wt, {
					level: "h1",
					size: "xl",
					children: e("login.title")
				}), /* @__PURE__ */ Y(L, {
					color: "muted",
					children: e("login.subtitle")
				})]
			}), /* @__PURE__ */ Y("form", {
				onSubmit: l,
				className: "w-full",
				children: /* @__PURE__ */ X(Tt, {
					gap: 4,
					children: [/* @__PURE__ */ X(Tt, {
						gap: 2,
						children: [
							/* @__PURE__ */ X(vc, { children: [/* @__PURE__ */ Y(bc, { children: /* @__PURE__ */ Y(Nn, { className: "h-4 w-4" }) }), /* @__PURE__ */ Y(Cc, {
								type: "email",
								placeholder: e("login.emailPlaceholder"),
								value: t,
								onChange: u,
								"aria-invalid": d,
								"aria-describedby": d ? "login-error" : void 0,
								disabled: f,
								autoFocus: !0
							})] }),
							a && /* @__PURE__ */ Y(L, {
								id: "login-error",
								variant: "detail",
								color: "destructive",
								children: e(`login.validation.${a}`)
							}),
							s && /* @__PURE__ */ Y(L, {
								id: "login-error",
								variant: "detail",
								color: "destructive",
								children: e(`login.error.${s}`)
							})
						]
					}), /* @__PURE__ */ Y(I, {
						type: "submit",
						disabled: f,
						className: "w-full",
						children: f ? /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y(q, { className: "h-4 w-4 animate-spin" }), e("login.submitting")] }) : e("login.submit")
					})]
				})
			})]
		})
	});
}
//#endregion
//#region src/components/ui/filter-tabs.tsx
function Dd({ value: e, tabs: t, onChange: n, className: r, "aria-label": i }) {
	return /* @__PURE__ */ Y("div", {
		role: "tablist",
		"aria-label": i,
		className: M("flex flex-wrap items-center gap-1.5", r),
		children: t.map((t) => {
			let r = t.value === e;
			return /* @__PURE__ */ X("button", {
				type: "button",
				role: "tab",
				"aria-selected": r,
				onClick: () => {
					n(t.value);
				},
				className: M("inline-flex cursor-pointer items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm transition-colors", "focus-visible:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring/50", r ? "bg-foreground text-background" : "text-muted-foreground hover:bg-muted"),
				children: [/* @__PURE__ */ Y("span", { children: t.label }), t.count !== void 0 && /* @__PURE__ */ Y("span", {
					className: M("font-mono text-[11px]", r ? "text-background/70" : "text-muted-foreground/60"),
					children: t.count
				})]
			}, t.value);
		})
	});
}
//#endregion
//#region src/components/ui/search-input.tsx
function Od({ value: e, onChange: t, placeholder: n, label: r, clearLabel: i = "Clear search", isSearching: a = !1, className: o }) {
	return /* @__PURE__ */ X(vc, {
		className: o,
		children: [
			/* @__PURE__ */ Y(bc, { children: /* @__PURE__ */ Y(Yn, {}) }),
			/* @__PURE__ */ Y(Cc, {
				type: "search",
				value: e,
				onChange: (e) => {
					t(e.target.value);
				},
				placeholder: n,
				"aria-label": r ?? n
			}),
			a && /* @__PURE__ */ Y(bc, {
				align: "inline-end",
				children: /* @__PURE__ */ Y(q, {
					"data-testid": "search-input-spinner",
					className: "size-4 animate-spin text-muted-foreground"
				})
			}),
			!a && e && /* @__PURE__ */ Y(bc, {
				align: "inline-end",
				children: /* @__PURE__ */ Y(Sc, {
					"aria-label": i,
					onClick: () => {
						t("");
					},
					children: /* @__PURE__ */ Y(mr, {})
				})
			})
		]
	});
}
//#endregion
//#region src/lib/skill-errors.ts
var kd = { "skills:invalid_frontmatter": "skills.bundle.errors.invalidSkill" };
function Ad(e, t, n) {
	let r = t.code === void 0 ? void 0 : kd[t.code];
	return r ? e(r) : t.message ?? e(n);
}
//#endregion
//#region src/hooks/use-skills.ts
function jd(e) {
	let t = e?.enabled ?? !0, { t: n } = Z(), [r, i] = G([]), [a, s] = G(t ? "loading" : "loaded"), [c, l] = G(!1), [u, d] = G(), f = W(void 0), p = W(!1), m = B(async () => {
		f.current?.abort();
		let e = new AbortController();
		f.current = e, s("loading");
		try {
			let t = await o({ signal: e.signal });
			if (e.signal.aborted) return;
			i(t), s("loaded");
		} catch {
			if (e.signal.aborted) return;
			s("error");
		}
	}, []);
	H(() => {
		t && m();
	}, [m, t]), H(() => () => {
		f.current?.abort();
	}, []);
	let h = B(async () => {
		await m();
	}, [m]), g = B(() => {
		d(void 0);
	}, []);
	return {
		skills: r,
		status: a,
		isCreating: c,
		createError: u,
		refetch: h,
		create: B(async (e) => {
			if (!p.current) {
				p.current = !0, d(void 0), l(!0);
				try {
					let n = await we(e);
					return t && await m(), n;
				} catch (e) {
					d(Ad(n, await Re(e), "skills.create.failed"));
					return;
				} finally {
					p.current = !1, l(!1);
				}
			}
		}, [
			t,
			m,
			n
		]),
		dismissCreateError: g,
		toggleAvailability: B(async (e, t) => {
			i((n) => n.map((n) => n.id === e ? {
				...n,
				available: t
			} : n));
			try {
				let n = await Pe(e, t);
				i((t) => t.map((t) => t.id === e ? n : t));
			} catch {
				i((n) => n.map((n) => n.id === e ? {
					...n,
					available: !t
				} : n));
			}
		}, [])
	};
}
//#endregion
//#region src/lib/format-relative-date.ts
var Md = 864e5, Nd = {
	fr: {
		day: "short",
		week: "short",
		month: "long",
		year: "long"
	},
	en: {
		day: "long",
		week: "long",
		month: "long",
		year: "long"
	}
};
function Pd(e) {
	return e.startsWith("en") ? "en" : "fr";
}
var Fd = /* @__PURE__ */ new Map();
function Id(e, t) {
	let n = `${e}-${t}`, r = Fd.get(n);
	return r || (r = new Intl.RelativeTimeFormat(e, {
		numeric: "auto",
		style: t
	}), Fd.set(n, r)), r;
}
function Ld(e) {
	return e < 7 ? {
		value: e,
		unit: "day"
	} : e < 30 ? {
		value: Math.floor(e / 7),
		unit: "week"
	} : e < 365 ? {
		value: Math.round(e / 30),
		unit: "month"
	} : {
		value: Math.floor(e / 365),
		unit: "year"
	};
}
function Rd(e, t = "fr", n = /* @__PURE__ */ new Date()) {
	let { value: r, unit: i } = Ld(Math.max(0, Math.floor((n.getTime() - new Date(e).getTime()) / Md)));
	return Id(t, Nd[t][i]).format(-r, i).replaceAll("’", "'");
}
//#endregion
//#region src/lib/skill-presentation.ts
var zd = {
	user: "skills.card.ownerType.user",
	system: "skills.card.ownerType.system"
}, Bd = {
	stable: "skills.card.status.stable",
	beta: "skills.card.status.beta",
	experimental: "skills.card.status.experimental",
	preview: "skills.card.status.preview",
	deprecated: "skills.card.status.deprecated"
}, Vd = "shrink-0 rounded-md bg-muted/60 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-muted-foreground";
//#endregion
//#region src/components/skills/skill-card.tsx
function Hd({ skill: e, className: t, now: n, onToggleAvailability: r }) {
	let { t: i, i18n: a } = Z(), o = Rd(e.updatedAt, Pd(a.language), n), [s, c] = G(!1);
	return /* @__PURE__ */ X("article", {
		className: M("group relative isolate flex min-h-[168px] cursor-pointer flex-col rounded-xl border border-border bg-card p-4 transition-all", "hover:border-border/80 hover:shadow-sm", t),
		children: [
			/* @__PURE__ */ Y(K, {
				to: `/skills/${e.id}`,
				className: "absolute inset-0 z-0 rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
				"aria-label": e.title
			}),
			/* @__PURE__ */ X("header", {
				className: "mb-3 flex items-start gap-3",
				children: [
					/* @__PURE__ */ Y(ct, {
						feature: "skill",
						size: "md"
					}),
					/* @__PURE__ */ X("div", {
						className: "min-w-0 flex-1",
						children: [/* @__PURE__ */ Y("div", {
							className: "line-clamp-2 text-sm font-medium",
							children: e.title
						}), /* @__PURE__ */ Y("div", {
							className: "font-mono text-[11px] text-muted-foreground",
							children: e.slug
						})]
					}),
					/* @__PURE__ */ Y("span", {
						className: Vd,
						children: i(zd[e.ownerType])
					})
				]
			}),
			/* @__PURE__ */ Y("p", {
				className: "line-clamp-2 text-sm leading-relaxed text-muted-foreground",
				children: e.description
			}),
			e.tags.length > 0 && /* @__PURE__ */ Y("div", {
				className: "mt-2 flex flex-wrap gap-1",
				children: e.tags.map((e) => /* @__PURE__ */ Y("span", {
					className: "rounded bg-muted/60 px-1.5 py-0.5 text-[10px] text-muted-foreground",
					children: e
				}, e))
			}),
			/* @__PURE__ */ X("footer", {
				className: "mt-auto flex items-center gap-2 pt-4",
				children: [
					e.status && e.status !== "stable" && /* @__PURE__ */ Y("span", {
						className: "shrink-0 rounded-md bg-muted/60 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-muted-foreground",
						children: i(Bd[e.status])
					}),
					/* @__PURE__ */ Y("span", {
						className: "text-[11px] text-muted-foreground/70",
						children: o
					}),
					/* @__PURE__ */ Y("div", { className: "flex-1" }),
					r && /* @__PURE__ */ Y(I, {
						type: "button",
						size: "sm",
						variant: e.available ? "outline" : "default",
						disabled: s,
						className: "relative z-10",
						onClick: (t) => {
							t.preventDefault(), t.stopPropagation(), (async () => {
								c(!0);
								try {
									await r(e.id, !e.available);
								} finally {
									c(!1);
								}
							})();
						},
						"aria-label": e.available ? i("skills.card.installed") : i("skills.card.install"),
						children: e.available ? /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y(sn, {
							className: "size-3.5",
							"aria-hidden": "true"
						}), i("skills.card.installed")] }) : i("skills.card.install")
					})
				]
			})
		]
	});
}
//#endregion
//#region src/components/skills/skills-empty-state.tsx
function Ud({ mode: e, onCreate: t, onClearFilters: n }) {
	let { t: r } = Z(), { Icon: i } = pt("skill");
	return /* @__PURE__ */ Y(Et, {
		className: "py-16",
		icon: /* @__PURE__ */ Y(i, { className: "size-8 opacity-50" }),
		title: r(`skills.empty.${e}.title`),
		description: r(`skills.empty.${e}.description`),
		action: /* @__PURE__ */ X("div", {
			className: "flex flex-col items-center gap-2",
			children: [/* @__PURE__ */ Y(I, {
				type: "button",
				onClick: t,
				children: r("skills.empty.cta")
			}), e !== "noSkills" && /* @__PURE__ */ Y(I, {
				type: "button",
				variant: "link",
				size: "sm",
				onClick: n,
				children: r("skills.empty.clearLink")
			})]
		})
	});
}
//#endregion
//#region src/components/skills/skill-tabs.ts
var Wd = [
	"all",
	"mine",
	"system"
];
//#endregion
//#region src/components/skills/skill-detail-header.tsx
function Gd({ skill: e, now: t, className: n, onToggleAvailability: r, titleRef: i }) {
	let { t: a, i18n: o } = Z(), s = Rd(e.updatedAt, Pd(o.language), t), [c, l] = G(!1);
	return /* @__PURE__ */ X("header", {
		className: M("flex flex-col gap-4", n),
		children: [/* @__PURE__ */ X("div", {
			className: "flex flex-col gap-4 sm:flex-row sm:items-start",
			children: [
				/* @__PURE__ */ Y(ct, {
					feature: "skill",
					size: "lg"
				}),
				/* @__PURE__ */ X("div", {
					className: "min-w-0 flex-1",
					children: [
						/* @__PURE__ */ X("div", {
							className: "flex flex-wrap items-center gap-2",
							children: [
								/* @__PURE__ */ Y("h1", {
									ref: i,
									className: "text-2xl font-semibold",
									children: e.title
								}),
								/* @__PURE__ */ Y("span", {
									className: Vd,
									children: a(zd[e.ownerType])
								}),
								e.status && e.status !== "stable" && /* @__PURE__ */ Y("span", {
									className: "shrink-0 rounded-md bg-muted/60 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-muted-foreground",
									children: a(Bd[e.status])
								}),
								e.hasDraftChanges && /* @__PURE__ */ Y("span", {
									className: "rounded border border-amber-500/40 bg-amber-500/10 px-1.5 py-0.5 text-[10px] font-medium text-amber-700 dark:text-amber-400",
									children: a("skills.detail.publish.badge")
								})
							]
						}),
						/* @__PURE__ */ X("div", {
							className: "mt-1 font-mono text-xs text-muted-foreground",
							children: [
								/* @__PURE__ */ Y("span", { children: e.slug }),
								" · ",
								a("skills.detail.updatedAt", { date: s })
							]
						}),
						e.tags.length > 0 && /* @__PURE__ */ Y("div", {
							className: "mt-2 flex flex-wrap gap-1",
							children: e.tags.map((e) => /* @__PURE__ */ Y("span", {
								className: "rounded bg-muted/60 px-1.5 py-0.5 text-[10px] text-muted-foreground",
								children: e
							}, e))
						})
					]
				}),
				r && /* @__PURE__ */ Y(I, {
					type: "button",
					variant: e.available ? "outline" : "default",
					disabled: c,
					onClick: () => {
						(async () => {
							l(!0);
							try {
								await r(!e.available);
							} finally {
								l(!1);
							}
						})();
					},
					"aria-label": e.available ? a("skills.card.installed") : a("skills.card.install"),
					children: e.available ? /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y(sn, {
						className: "size-4",
						"aria-hidden": "true"
					}), a("skills.card.installed")] }) : a("skills.card.install")
				})
			]
		}), /* @__PURE__ */ Y("p", {
			className: "max-w-[760px] text-[15px] leading-relaxed text-foreground/80",
			children: e.description
		})]
	});
}
//#endregion
//#region src/lib/skill-status-style.ts
var Kd = {
	added: "text-success-text",
	modified: "text-info-text",
	replaced: "text-warning-text",
	removed: "text-destructive"
};
//#endregion
//#region src/components/skills/skill-file-tree.tsx
function qd(e, t) {
	if (e === "readme") return {
		label: t("skills.detail.files.badge.readme"),
		className: "text-muted-foreground"
	};
	if (e === "skill") return {
		label: t("skills.detail.files.badge.skill"),
		className: "text-emerald-600 dark:text-emerald-400"
	};
}
function Jd({ files: e, activeFile: t, onSelect: n, className: r, mode: i = "view", entries: a, onAddFiles: o }) {
	let { t: s } = Z(), c = W(null), l = new Map((a ?? []).map((e) => [e.path, e.status])), u = e ?? (a ?? []).map((e) => e.path), d = (e, r) => {
		let a = mt(e), o = yt[a], c = e === t, u = l.get(e), d = u === "removed", f = i === "view" ? qd(a, s) : void 0, p = i === "edit" && u && u !== "unchanged" ? {
			label: s(`skills.bundle.status.${u}`),
			className: Kd[u]
		} : void 0;
		return /* @__PURE__ */ X("button", {
			type: "button",
			onClick: () => {
				n(e);
			},
			"aria-current": c ? "true" : void 0,
			className: M("flex items-center gap-2 rounded-md px-2.5 py-1.5 text-left font-mono text-xs transition-colors", r === "row" ? "w-full" : "shrink-0", c ? "bg-primary/10 text-primary" : "text-foreground/80 hover:bg-muted"),
			children: [
				/* @__PURE__ */ Y(o, {
					className: M("size-3.5 shrink-0", c ? "text-primary" : "text-muted-foreground"),
					"aria-hidden": "true"
				}),
				/* @__PURE__ */ Y("span", {
					className: M("truncate", r === "row" && "flex-1", d && "text-muted-foreground line-through"),
					children: e
				}),
				f && /* @__PURE__ */ Y("span", {
					className: M("shrink-0 text-[9px] font-medium uppercase tracking-wide", f.className),
					children: f.label
				}),
				p && /* @__PURE__ */ Y("span", {
					className: M("shrink-0 text-[9px] font-medium uppercase tracking-wide", p.className),
					children: p.label
				})
			]
		}, e);
	};
	return /* @__PURE__ */ X("div", {
		className: r,
		children: [
			/* @__PURE__ */ X("aside", {
				className: "hidden self-start rounded-xl border border-border bg-card p-2 md:sticky md:top-4 md:block",
				children: [
					/* @__PURE__ */ X("div", {
						className: "px-2.5 pt-1 pb-1.5 font-mono text-[10px] uppercase tracking-wider text-muted-foreground",
						children: [
							s("skills.detail.files.label"),
							" · ",
							u.length
						]
					}),
					/* @__PURE__ */ Y("div", {
						className: "flex flex-col gap-0.5",
						children: u.map((e) => d(e, "row"))
					}),
					i === "edit" && o && /* @__PURE__ */ Y("div", {
						className: "px-1 pt-2",
						children: /* @__PURE__ */ X(I, {
							type: "button",
							variant: "outline",
							size: "sm",
							className: "w-full",
							onClick: () => c.current?.click(),
							children: [/* @__PURE__ */ Y(Gn, { className: "size-4" }), s("skills.bundle.addFiles")]
						})
					})
				]
			}),
			/* @__PURE__ */ Y("div", {
				className: "flex gap-1.5 overflow-x-auto rounded-xl border border-border bg-card p-1.5 md:hidden",
				children: u.map((e) => d(e, "column"))
			}),
			i === "edit" && o && /* @__PURE__ */ X(J, { children: [/* @__PURE__ */ Y("div", {
				className: "mt-2 md:hidden",
				children: /* @__PURE__ */ X(I, {
					type: "button",
					variant: "outline",
					size: "sm",
					className: "w-full",
					onClick: () => c.current?.click(),
					children: [/* @__PURE__ */ Y(Gn, { className: "size-4" }), s("skills.bundle.addFiles")]
				})
			}), /* @__PURE__ */ Y("input", {
				ref: c,
				type: "file",
				hidden: !0,
				multiple: !0,
				"data-testid": "skill-tree-add-input",
				onChange: (e) => {
					let t = [...e.target.files ?? []];
					t.length > 0 && o(t, t.map(() => void 0)), e.target.value = "";
				}
			})] })
		]
	});
}
//#endregion
//#region src/lib/skill-bundle.ts
var Yd = "SKILL.md";
function Xd(e) {
	return e.split("/").at(-1) ?? e;
}
function Zd(e) {
	return [...e].sort((e, t) => e.localeCompare(t)).map((e) => ({
		path: e,
		origin: "server",
		status: "unchanged"
	}));
}
function Qd(e) {
	return e.length === 0 || e.startsWith("/") || e.includes("\\") ? !1 : e.split("/").every((e) => e.length > 0 && e !== "." && e !== "..");
}
function $d(e, t) {
	let n = [...e];
	for (let { path: e, file: r } of t) {
		let t = n.findIndex((t) => t.path === e);
		if (t === -1) {
			n.push({
				path: e,
				origin: "added",
				status: "added",
				file: r
			});
			continue;
		}
		let i = n[t];
		n[t] = i.origin === "server" ? {
			...i,
			status: "replaced",
			file: r,
			draft: void 0
		} : {
			...i,
			status: "added",
			file: r,
			draft: void 0
		};
	}
	return n;
}
function ef(e, t) {
	if (t === "SKILL.md") return [...e];
	let n = e.find((e) => e.path === t);
	return n ? n.origin === "added" ? e.filter((e) => e.path !== t) : e.map((e) => e.path === t ? {
		...e,
		status: "removed"
	} : e) : [...e];
}
function tf(e, t) {
	let n = e.map((e, n) => {
		let r = t[n];
		return {
			path: r ? `${r}/${e.name}` : e.name,
			file: e
		};
	}), r = n.map(({ path: e }) => e.split("/")[0]), i = r[0], a = r.length > 0 && r.every((e) => e === i), o = n.some(({ path: e }) => e.includes("/"));
	return !a || !o ? n : n.map(({ path: e, file: t }) => ({
		path: e.slice(i.length + 1),
		file: t
	}));
}
function nf(e, t, n) {
	let r = e.find((e) => e.path === t);
	return r ? r.origin === "server" ? e.map((e) => e.path === t ? {
		...e,
		status: "replaced",
		file: n,
		draft: void 0
	} : e) : t === "SKILL.md" ? e.map((e) => e.path === t ? {
		...e,
		status: "added",
		file: n,
		draft: void 0
	} : e) : $d(e.filter((e) => e.path !== t), [{
		path: n.name,
		file: n
	}]) : [...e];
}
function rf(e, t, n, r) {
	return e.map((e) => {
		if (e.path !== t) return e;
		if (e.origin === "server" && e.status !== "replaced" && r !== void 0 && n === r) {
			let { draft: t, file: n, ...r } = e;
			return {
				...r,
				status: "unchanged"
			};
		}
		return e.origin === "server" && e.status !== "replaced" ? {
			...e,
			status: "modified",
			draft: n
		} : {
			...e,
			draft: n
		};
	});
}
function af(e, t) {
	let n = new Set([
		"removed",
		"modified",
		"replaced"
	]);
	return e.map((e) => e.path === t && e.origin === "server" && n.has(e.status) ? {
		path: e.path,
		origin: "server",
		status: "unchanged"
	} : e);
}
function of(e, t) {
	let n = t ?? e.draft;
	return n === void 0 ? e.file : new File([n], Xd(e.path), { type: "text/markdown" });
}
var sf = new TextEncoder();
function cf(e) {
	return e.draft === void 0 ? e.file?.size ?? 0 : sf.encode(e.draft).length;
}
function lf(e, t) {
	return {
		upserts: e.filter((e) => e.status === "added" || e.status === "replaced" || e.status === "modified").map((e) => ({
			path: e.path,
			file: of(e, t?.[e.path])
		})).filter((e) => e.file !== void 0),
		deletes: e.filter((e) => e.status === "removed").map((e) => e.path)
	};
}
async function uf(e) {
	let t = e.find((e) => e.path === Yd)?.draft;
	if (t === void 0) return;
	let { outgoingSkillMd: n } = await import("./skill-form-BxJLCkrx.js");
	return n(t);
}
function df(e) {
	return e.some((e) => e.status !== "unchanged");
}
function ff(e, t) {
	let n = e.filter((e) => e.status !== "removed");
	if (t === "create" && !n.some((e) => e.path === "SKILL.md")) return {
		ok: !1,
		messageKey: "skills.bundle.errors.missingSkillMd"
	};
	if (n.length > 50) return {
		ok: !1,
		messageKey: "skills.bundle.errors.tooManyFiles",
		params: { max: 50 }
	};
	for (let e of n) if (e.origin === "added" && !Qd(e.path)) return {
		ok: !1,
		messageKey: "skills.bundle.errors.invalidPath",
		params: { path: e.path }
	};
	let r = n.map((e) => e.path);
	if (new Set(r).size !== r.length) return {
		ok: !1,
		messageKey: "skills.bundle.errors.duplicatePath"
	};
	let i = 0;
	for (let e of n) {
		let t = cf(e);
		if (t > 5242880) return {
			ok: !1,
			messageKey: "skills.bundle.errors.fileTooLarge",
			params: {
				name: e.path,
				maxMb: 5
			}
		};
		i += t;
	}
	return i > 52428800 ? {
		ok: !1,
		messageKey: "skills.bundle.errors.totalTooLarge",
		params: { maxMb: 50 }
	} : { ok: !0 };
}
//#endregion
//#region src/components/skills/skill-file-viewer.tsx
var pf = Ft(async () => {
	let { MarkdownEditor: e } = await import("./markdown-editor-vlp4uKPN.js").then((e) => e.t);
	return { default: e };
}), mf = Ft(async () => {
	let { SkillMdEditor: e } = await import("./skill-md-editor-DYj6mfLX.js");
	return { default: e };
});
function hf({ path: e, content: t, status: n, rawHref: r, className: i, mode: a = "view", fileStatus: o, isBinary: s, onEdit: c, onDropFile: l, onDelete: u, onRestore: d }) {
	let { t: f } = Z(), p = a === "edit", m = o === "removed", [h, g] = G("form"), _ = p && e === "SKILL.md" && !s && !m && t !== void 0;
	return /* @__PURE__ */ X("section", {
		className: M("overflow-hidden rounded-xl border border-border bg-card", i),
		children: [/* @__PURE__ */ Y(gf, {
			path: e,
			rawHref: r,
			isRemoved: m,
			fileStatus: o,
			edit: p ? {
				onRestore: d,
				onDropFile: l,
				onDelete: u
			} : void 0,
			toggle: _ ? {
				mode: h,
				onChange: g
			} : void 0
		}), /* @__PURE__ */ X("div", {
			className: M("min-w-0", p ? "p-3" : "p-5"),
			children: [
				n === "loading" && /* @__PURE__ */ Y(wf, { label: f("skills.detail.files.loading") }),
				n === "error" && /* @__PURE__ */ Y("p", {
					className: "text-sm text-destructive",
					children: f("skills.detail.files.loadError")
				}),
				n === "loaded" && (p ? /* @__PURE__ */ Y(xf, {
					path: e,
					content: t,
					isBinary: s,
					fileStatus: o,
					editorMode: _ ? h : void 0,
					onEdit: c
				}) : /* @__PURE__ */ Y(Sf, {
					path: e,
					content: t
				}))
			]
		})]
	});
}
function gf({ path: e, rawHref: t, isRemoved: n, fileStatus: r, edit: i, toggle: a }) {
	let { t: o } = Z(), s = r && r !== "unchanged" ? Kd[r] : void 0;
	return /* @__PURE__ */ X("div", {
		className: "flex flex-wrap items-center gap-2.5 border-b border-border bg-muted/40 px-4 py-2.5",
		children: [
			/* @__PURE__ */ Y("span", {
				className: M("truncate font-mono text-xs text-foreground/80", n && "line-through"),
				children: e
			}),
			s && /* @__PURE__ */ Y("span", {
				className: M("shrink-0 text-[10px] font-medium uppercase tracking-wide", s),
				children: o(`skills.bundle.status.${r}`)
			}),
			/* @__PURE__ */ Y("div", { className: "flex-1" }),
			a && /* @__PURE__ */ Y(_f, { ...a }),
			i ? /* @__PURE__ */ Y(vf, {
				path: e,
				isRemoved: n,
				fileStatus: r,
				...i
			}) : /* @__PURE__ */ Y(yf, { rawHref: t })
		]
	});
}
function _f({ mode: e, onChange: t }) {
	let { t: n } = Z();
	return /* @__PURE__ */ Y(Ge, {
		value: e,
		options: [{
			value: "form",
			label: n("skills.form.modeForm")
		}, {
			value: "raw",
			label: n("skills.form.modeRaw")
		}],
		"aria-label": n("skills.form.modeLabel"),
		onChange: t
	});
}
function vf({ path: e, isRemoved: t, fileStatus: n, onRestore: r, onDropFile: i, onDelete: a }) {
	let { t: o } = Z();
	return /* @__PURE__ */ X(J, { children: [
		(n === "removed" || n === "modified" || n === "replaced") && /* @__PURE__ */ X(I, {
			type: "button",
			variant: "ghost",
			size: "sm",
			onClick: r,
			children: [/* @__PURE__ */ Y(Jn, { className: "size-3.5" }), o("skills.bundle.restore")]
		}),
		!t && /* @__PURE__ */ X(I, {
			type: "button",
			variant: "ghost",
			size: "sm",
			onClick: i,
			children: [/* @__PURE__ */ Y(qn, { className: "size-3.5" }), o("skills.detail.edit.dropFile")]
		}),
		!t && e !== "SKILL.md" && /* @__PURE__ */ X(I, {
			type: "button",
			variant: "ghost-destructive",
			size: "sm",
			onClick: a,
			children: [/* @__PURE__ */ Y(cr, { className: "size-3.5" }), o("skills.detail.edit.delete")]
		})
	] });
}
function yf({ rawHref: e }) {
	let { t } = Z();
	return /* @__PURE__ */ X("a", {
		href: e,
		target: "_blank",
		rel: "noreferrer",
		className: "inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs text-muted-foreground hover:bg-card hover:text-foreground",
		children: [/* @__PURE__ */ Y(yn, {
			className: "size-3",
			"aria-hidden": "true"
		}), t("skills.detail.files.raw")]
	});
}
function bf(e, t) {
	return dt(e) && vt(t).frontmatter === void 0;
}
function xf({ path: e, content: t, isBinary: n, fileStatus: r, editorMode: i, onEdit: a }) {
	let { t: o } = Z();
	return r === "removed" ? /* @__PURE__ */ Y("p", {
		className: "text-sm text-muted-foreground",
		children: o("skills.bundle.status.removed")
	}) : n ? /* @__PURE__ */ Y("p", {
		className: "text-sm text-muted-foreground",
		children: o("skills.detail.edit.binaryHint")
	}) : i ? /* @__PURE__ */ Y(Pt, {
		fallback: /* @__PURE__ */ Y(wf, { label: o("skills.detail.files.loading") }),
		children: /* @__PURE__ */ Y(mf, {
			content: t ?? "",
			mode: i,
			onEdit: (e) => a?.(e)
		})
	}) : bf(e, t ?? "") ? /* @__PURE__ */ Y(Pt, {
		fallback: /* @__PURE__ */ Y(wf, { label: o("skills.detail.files.loading") }),
		children: /* @__PURE__ */ Y(pf, {
			value: t ?? "",
			placeholder: o("skills.detail.edit.editorPlaceholder"),
			textareaClassName: "min-h-[420px] resize-y",
			onChange: (e) => a?.(e)
		})
	}) : /* @__PURE__ */ Y(Ct, {
		value: t ?? "",
		onChange: (e) => a?.(e)
	});
}
function Sf({ path: e, content: t }) {
	return t === void 0 ? null : dt(e) ? /* @__PURE__ */ Y(Tf, { content: t }) : /* @__PURE__ */ Y(Ef, { content: t });
}
var Cf = [
	"w-1/3",
	"w-5/6",
	"w-full",
	"w-2/3",
	"w-11/12",
	"w-1/2"
];
function wf({ label: e }) {
	return /* @__PURE__ */ Y("div", {
		className: "flex min-h-[200px] flex-col gap-3",
		role: "status",
		"aria-label": e,
		children: Cf.map((e) => /* @__PURE__ */ Y("div", { className: M("h-3 animate-pulse rounded bg-muted", e) }, e))
	});
}
function Tf({ content: e }) {
	let { frontmatter: t, body: n } = vt(e);
	return /* @__PURE__ */ X("div", {
		className: "min-w-0",
		children: [t !== void 0 && /* @__PURE__ */ Y("pre", {
			className: "mb-4 max-w-full overflow-x-auto rounded-lg border border-border bg-muted/50 p-3 font-mono text-xs leading-relaxed text-foreground/80",
			children: t
		}), n.trim().length > 0 && /* @__PURE__ */ Y("div", {
			className: "message-content",
			children: /* @__PURE__ */ Y(We, {
				content: n,
				linkTarget: "blank"
			})
		})]
	});
}
function Ef({ content: e }) {
	return /* @__PURE__ */ Y("pre", {
		className: "overflow-x-auto rounded-lg bg-muted px-4 py-3 font-mono text-xs leading-relaxed",
		children: /* @__PURE__ */ Y("code", { children: e })
	});
}
//#endregion
//#region src/hooks/use-skill-file-content.ts
function Df(e, t) {
	let n = W(/* @__PURE__ */ new Map()), [r, i] = G(), [a, o] = G(t ? "loading" : "idle");
	return H(() => {
		if (!t) {
			i(void 0), o("idle");
			return;
		}
		let r = `${e}\n${t}`, a = n.current.get(r);
		if (a !== void 0) {
			i(a), o("loaded");
			return;
		}
		let s = new AbortController();
		return o("loading"), i(void 0), (async () => {
			try {
				let a = await m(e, t, { signal: s.signal });
				if (s.signal.aborted) return;
				n.current.set(r, a), i(a), o("loaded");
			} catch {
				if (s.signal.aborted) return;
				o("error");
			}
		})(), () => {
			s.abort();
		};
	}, [e, t]), {
		content: r,
		status: a
	};
}
//#endregion
//#region src/components/skills/skill-file-browser.tsx
function Of(e) {
	return e.mode === "edit" ? /* @__PURE__ */ Y(Af, { ...e }) : /* @__PURE__ */ Y(kf, { ...e });
}
function kf({ skillId: e, files: t, activeFile: r, onSelect: i }) {
	let { t: a, i18n: o } = Z(), { language: s } = o, [c, l] = G(() => ht(t, s));
	H(() => {
		i || l(ht(t, s));
	}, [
		t,
		s,
		i
	]);
	let u = i ? r : c, d = i ?? l, { content: f, status: p } = Df(e, u), m = !_t(t), h = u ? `${n()}/skills/${e}/files/content?path=${encodeURIComponent(u)}` : "#";
	return t.length === 0 || !u ? null : /* @__PURE__ */ X("div", {
		className: "grid grid-cols-1 gap-4 md:grid-cols-[260px_1fr]",
		children: [/* @__PURE__ */ Y(Jd, {
			files: t,
			activeFile: u,
			onSelect: d
		}), /* @__PURE__ */ X("div", {
			className: "flex min-w-0 flex-col gap-3",
			children: [m && /* @__PURE__ */ X("div", {
				className: "flex items-center gap-2 rounded-lg border border-border bg-muted/40 px-3 py-2 text-xs text-muted-foreground",
				children: [/* @__PURE__ */ Y(Yt, {
					className: "size-3.5",
					"aria-hidden": "true"
				}), /* @__PURE__ */ Y("span", { children: a("skills.detail.noReadme") })]
			}), /* @__PURE__ */ Y(hf, {
				path: u,
				content: f,
				status: p,
				rawHref: h
			})]
		})]
	});
}
function Af(e) {
	let { t } = Z(), { skillId: r, entries: i, activePath: a, activeContent: o, activeContentStatus: s, activeIsBinary: c, isSaving: l, pendingCount: u, isNew: d, errorMessage: f, onDismissError: p, validationWarning: m, canSave: h, saveLabel: g, savingLabel: _, onSelect: v, onEdit: y, onDropFile: b, onDelete: x, onRestore: S, onAddFiles: C, onSave: w, onCancel: T } = e, E = i.map((e) => e.path), D = i.find((e) => e.path === a), O = a ? `${n()}/skills/${r}/files/content?path=${encodeURIComponent(a)}` : "#";
	return /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-4",
		children: [
			f && /* @__PURE__ */ Y(xt, {
				variant: "error",
				onDismiss: p,
				dismissLabel: t("skills.createError.dismiss"),
				children: f
			}),
			m && /* @__PURE__ */ Y(xt, {
				variant: "warning",
				children: m
			}),
			/* @__PURE__ */ X("div", {
				className: "flex flex-wrap items-center gap-3",
				children: [!d && u > 0 && /* @__PURE__ */ Y("span", {
					className: "text-sm text-muted-foreground",
					children: t("skills.bundle.pendingChanges", { count: u })
				}), /* @__PURE__ */ X("div", {
					className: "ml-auto flex gap-2",
					children: [/* @__PURE__ */ Y(I, {
						type: "button",
						variant: "outline",
						disabled: l,
						onClick: T,
						children: t("skills.bundle.cancel")
					}), /* @__PURE__ */ Y(I, {
						type: "button",
						disabled: !h,
						onClick: w,
						children: l ? _ ?? t("skills.bundle.saving") : g ?? t("skills.bundle.save")
					})]
				})]
			}),
			/* @__PURE__ */ Y(ic, {
				fullPage: !0,
				label: t("skills.bundle.dropLabel"),
				onDrop: C,
				children: /* @__PURE__ */ X("div", {
					className: "grid grid-cols-1 gap-4 md:grid-cols-[260px_1fr]",
					children: [/* @__PURE__ */ Y(Jd, {
						mode: "edit",
						files: E,
						entries: d ? void 0 : i,
						activeFile: a,
						onSelect: v,
						onAddFiles: C
					}), a && /* @__PURE__ */ Y("div", {
						className: "flex min-w-0 flex-col gap-3",
						children: /* @__PURE__ */ Y(hf, {
							mode: "edit",
							path: a,
							content: o,
							status: s,
							rawHref: O,
							fileStatus: d ? void 0 : D?.status,
							isBinary: c,
							onEdit: y,
							onDropFile: b,
							onDelete: x,
							onRestore: S
						})
					})]
				})
			})
		]
	});
}
//#endregion
//#region src/components/skills/skill-dependencies.tsx
function jf({ requires: e }) {
	let { t } = Z(), { Icon: n, color: r } = pt("skill");
	return e.length === 0 ? null : /* @__PURE__ */ X("div", { children: [/* @__PURE__ */ Y("h2", {
		className: "mb-2 text-xs font-medium uppercase tracking-wide text-muted-foreground",
		children: t("skills.detail.dependencies.title")
	}), /* @__PURE__ */ Y("div", {
		className: "flex flex-wrap gap-2",
		children: e.map((e) => /* @__PURE__ */ X(K, {
			to: `/skills/${e.id}`,
			className: "inline-flex items-center gap-1.5 rounded-md border border-border bg-muted/40 px-2 py-1 text-xs hover:border-border/80 hover:bg-muted",
			children: [/* @__PURE__ */ Y(n, {
				className: M("size-3", r),
				"aria-hidden": "true"
			}), e.title]
		}, e.id))
	})] });
}
//#endregion
//#region src/components/skills/delete-skill-dialog.tsx
function Mf({ isOpen: e, onOpenChange: t, skillTitle: n, isDeleting: r, error: i, onConfirm: a }) {
	let { t: o } = Z();
	return /* @__PURE__ */ Y(Qe, {
		open: e,
		onOpenChange: t,
		children: /* @__PURE__ */ X(Xe, { children: [
			/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: o("skills.detail.deleteDialog.title", { title: n }) }), /* @__PURE__ */ Y(qe, { children: o("skills.detail.deleteDialog.description") })] }),
			i && /* @__PURE__ */ Y("p", {
				className: "text-sm text-destructive",
				children: i
			}),
			/* @__PURE__ */ X(Ke, { children: [/* @__PURE__ */ Y(I, {
				variant: "outline",
				disabled: r,
				onClick: () => {
					t(!1);
				},
				children: o("skills.detail.deleteDialog.cancel")
			}), /* @__PURE__ */ Y(I, {
				variant: "destructive",
				disabled: r,
				onClick: a,
				children: o(r ? "skills.detail.deleteDialog.deleting" : "skills.detail.deleteDialog.confirm")
			})] })
		] })
	});
}
//#endregion
//#region src/components/skills/skill-danger-zone.tsx
function Nf({ skillTitle: e, onConfirmDelete: t }) {
	let { t: n } = Z(), [r, i] = G(!1), [a, o] = G(!1), [s, c] = G();
	return /* @__PURE__ */ X(co, {
		title: n("skills.detail.danger.title"),
		children: [/* @__PURE__ */ Y(lo, {
			title: n("skills.detail.danger.deleteTitle"),
			description: n("skills.detail.danger.description"),
			actionLabel: n("skills.detail.danger.delete"),
			onAction: () => {
				i(!0);
			}
		}), /* @__PURE__ */ Y(Mf, {
			isOpen: r,
			onOpenChange: i,
			skillTitle: e,
			isDeleting: a,
			error: s,
			onConfirm: () => {
				(async () => {
					c(void 0), o(!0);
					try {
						await t(), i(!1);
					} catch {
						c(n("skills.detail.deleteDialog.failed"));
					} finally {
						o(!1);
					}
				})();
			}
		})]
	});
}
//#endregion
//#region src/pages/skills.tsx
function Pf(e) {
	return e && Wd.includes(e) ? e : "all";
}
function Ff(e, t) {
	let n = t.toLowerCase();
	return e.title.toLowerCase().includes(n) || e.description.toLowerCase().includes(n) || e.slug.toLowerCase().includes(n) || e.tags.some((e) => e.toLowerCase().includes(n));
}
function If() {
	let { t: e } = Z(), t = Gt(), [n, r] = Jt(), i = Pf(n.get("tab") ?? void 0), [a, o] = G(""), { skills: s, status: c, refetch: l, toggleAvailability: u } = jd(), d = U(() => {
		let e = i === "all" ? s : s.filter((e) => i === "mine" ? e.ownerType === "user" : e.ownerType === "system");
		return a && (e = e.filter((e) => Ff(e, a))), e;
	}, [
		s,
		i,
		a
	]), f = U(() => {
		let e = a ? s.filter((e) => Ff(e, a)) : s;
		return {
			all: e.length,
			mine: e.filter((e) => e.ownerType === "user").length,
			system: e.filter((e) => e.ownerType === "system").length
		};
	}, [s, a]), p = U(() => Wd.map((t) => ({
		value: t,
		label: e(`skills.tabs.${t}`),
		count: f[t]
	})), [f, e]), m = B((e) => {
		let t = new URLSearchParams(n);
		e === "all" ? t.delete("tab") : t.set("tab", e), r(t, { replace: !0 });
	}, [n, r]), h = B(() => {
		o(""), m("all");
	}, [m]), g = B(() => {
		t("/skills/new");
	}, [t]), _ = "noSkills";
	return a.length > 0 ? _ = "noSearchResults" : i !== "all" && (_ = "noSkillsForTab"), /* @__PURE__ */ X(_a, {
		title: e("skills.title"),
		description: e("skills.description"),
		action: {
			label: e("skills.create.label"),
			icon: Gn,
			onClick: g
		},
		toolbar: /* @__PURE__ */ X("div", {
			className: "flex flex-wrap items-center gap-3",
			children: [
				/* @__PURE__ */ Y(Dd, {
					value: i,
					tabs: p,
					onChange: m,
					"aria-label": e("skills.title")
				}),
				/* @__PURE__ */ Y("div", { className: "flex-1" }),
				/* @__PURE__ */ Y(Od, {
					value: a,
					onChange: o,
					placeholder: e("skills.search.placeholder"),
					clearLabel: e("skills.search.clear"),
					className: "w-full md:max-w-[260px] bg-card"
				})
			]
		}),
		children: [
			c === "loading" && /* @__PURE__ */ Y(Lf, { count: 6 }),
			c === "error" && /* @__PURE__ */ X("div", {
				className: "flex flex-col items-start gap-3 rounded-lg border border-destructive/30 bg-destructive/5 p-4",
				children: [/* @__PURE__ */ X("div", {
					className: "flex items-center gap-2 text-sm text-destructive",
					children: [/* @__PURE__ */ Y(Yt, {
						className: "size-4",
						"aria-hidden": "true"
					}), /* @__PURE__ */ Y("span", { children: e("skills.error.title") })]
				}), /* @__PURE__ */ Y(I, {
					variant: "outline",
					size: "sm",
					onClick: () => {
						l();
					},
					children: e("skills.error.retry")
				})]
			}),
			c === "loaded" && d.length > 0 && /* @__PURE__ */ Y("div", {
				className: "grid grid-cols-1 gap-3.5 md:grid-cols-2 lg:grid-cols-3",
				children: d.map((e) => /* @__PURE__ */ Y(Hd, {
					skill: e,
					onToggleAvailability: u
				}, e.id))
			}),
			c === "loaded" && d.length === 0 && /* @__PURE__ */ Y(Ud, {
				mode: _,
				onCreate: g,
				onClearFilters: h
			})
		]
	});
}
function Lf({ count: e }) {
	return /* @__PURE__ */ Y("div", {
		className: "grid grid-cols-1 gap-3.5 md:grid-cols-2 lg:grid-cols-3",
		children: Array.from({ length: e }, (e, t) => /* @__PURE__ */ Y("div", { className: "h-[168px] animate-pulse rounded-xl bg-muted/40" }, t))
	});
}
//#endregion
//#region src/components/skills/discard-changes-dialog.tsx
function Rf({ isOpen: e, onOpenChange: t, onConfirm: n }) {
	let { t: r } = Z();
	return /* @__PURE__ */ Y(Qe, {
		open: e,
		onOpenChange: t,
		children: /* @__PURE__ */ X(Xe, { children: [/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: r("skills.detail.edit.discard.title") }), /* @__PURE__ */ Y(qe, { children: r("skills.detail.edit.discard.description") })] }), /* @__PURE__ */ X(Ke, { children: [/* @__PURE__ */ Y(I, {
			variant: "outline",
			onClick: () => {
				t(!1);
			},
			children: r("skills.detail.edit.discard.cancel")
		}), /* @__PURE__ */ Y(I, {
			variant: "destructive",
			onClick: n,
			children: r("skills.detail.edit.discard.confirm")
		})] })] })
	});
}
//#endregion
//#region src/hooks/use-skill-bundle.ts
function zf(e, t) {
	let n = e.filter((e) => e.status !== "removed").map((e) => e.path);
	return ht(n.length > 0 ? n : e.map((e) => e.path), t);
}
function Bf({ mode: e, initialEntries: t }) {
	let [n, r] = G(() => [...t]), [i, a] = G(() => zf(t)), o = B((e, t) => {
		r((n) => $d(n, tf(e, t)));
	}, []), s = B((e, t) => {
		r((n) => nf(n, e, t));
	}, []), c = B((e) => {
		r((t) => ef(t, e));
	}, []), l = B((e) => {
		r((t) => af(t, e));
	}, []), u = B((e, t, n) => {
		r((r) => rf(r, e, t, n));
	}, []), d = B((e) => {
		r(Zd(e));
	}, []);
	return H(() => {
		i && !n.some((e) => e.path === i) && a(n.some((e) => e.path === "SKILL.md") ? Yd : zf(n));
	}, [n, i]), {
		entries: n,
		activePath: i,
		setActivePath: a,
		validation: U(() => ff(n, e), [n, e]),
		dirty: U(() => df(n), [n]),
		pendingCount: U(() => n.filter((e) => e.status !== "unchanged").length, [n]),
		addFiles: o,
		replaceFile: s,
		removeFile: c,
		restoreFile: l,
		editFile: u,
		resetToServer: d,
		plan: B((e) => lf(n, e), [n])
	};
}
//#endregion
//#region src/hooks/use-active-file-content.ts
function Vf(e) {
	return dt(e) || mt(e) === "code";
}
function Hf(e, t, n, r) {
	let { draft: i, file: a, origin: o, status: s } = t.find((e) => e.path === n) ?? {}, c = r && i === void 0 && a === void 0 && o === "server" && s !== "removed", l = Df(e, c ? n : void 0), [u, d] = G(void 0), f = c && i === void 0 && u === void 0, p = n ? !Vf(n) : !1, m = i ?? u ?? (c ? l.content : void 0), h = f ? l.status : "loaded";
	return H(() => {
		d(void 0), i === void 0 && a && n && Vf(n) && a.text().then(d);
	}, [n, a]), {
		activeContent: m,
		activeContentStatus: h,
		activeIsBinary: p,
		originalForActive: c ? l.content : u
	};
}
//#endregion
//#region src/hooks/use-unsaved-changes-warning.ts
function Uf(e) {
	H(() => {
		if (!e) return;
		let t = (e) => {
			e.preventDefault(), e.returnValue = "";
		};
		return window.addEventListener("beforeunload", t), () => {
			window.removeEventListener("beforeunload", t);
		};
	}, [e]);
}
//#endregion
//#region src/pages/skills-new.tsx
var Wf = "---\nname:\ndescription:\n---\n\n", Gf = [{
	path: "SKILL.md",
	origin: "added",
	status: "added",
	draft: Wf
}];
function Kf() {
	let { t: e } = Z(), t = Gt(), { create: n, createError: r, isCreating: i, dismissCreateError: a } = jd({ enabled: !1 }), o = Bf({
		mode: "create",
		initialEntries: Gf
	}), [s, c] = G(!1), l = W(null), { activeContent: u, activeContentStatus: d, activeIsBinary: f } = Hf("new", o.entries, o.activePath, !0), p = U(() => o.entries.length !== 1 || o.entries[0].path !== "SKILL.md" || o.entries[0].draft !== Wf, [o.entries]);
	Uf(p);
	let [m, h] = G(!1), [g, _] = G(void 0), v = B(async () => {
		a(), _(void 0), h(!0);
		try {
			let e = await uf(o.entries), r = await n(o.plan(e === void 0 ? void 0 : { [Yd]: e.content }).upserts);
			r && await t(`/skills/${r.id}`);
		} catch {
			_(e("skills.bundle.errors.createFailed"));
		} finally {
			h(!1);
		}
	}, [
		n,
		o,
		t,
		a,
		e
	]), y = B(() => {
		if (p) {
			c(!0);
			return;
		}
		t("/skills");
	}, [p, t]);
	return /* @__PURE__ */ X(_a, {
		title: e("skills.new.title"),
		headerTitle: e("skills.title"),
		description: e("skills.new.intro"),
		leading: /* @__PURE__ */ Y(ha, {
			to: "/skills",
			label: e("skills.new.back")
		}),
		children: [
			/* @__PURE__ */ Y("input", {
				ref: l,
				type: "file",
				hidden: !0,
				"data-testid": "skill-new-replace-input",
				onChange: (e) => {
					let [t] = [...e.target.files ?? []];
					t && o.activePath && o.replaceFile(o.activePath, t), e.target.value = "";
				}
			}),
			/* @__PURE__ */ Y(Of, {
				mode: "edit",
				skillId: "new",
				entries: o.entries,
				activePath: o.activePath,
				activeContent: u,
				activeContentStatus: d,
				activeIsBinary: f,
				dirty: o.dirty,
				canSave: o.validation.ok && !i && !m,
				isSaving: i || m,
				pendingCount: o.pendingCount,
				isNew: !0,
				errorMessage: r ?? g,
				onDismissError: () => {
					a(), _(void 0);
				},
				validationWarning: o.validation.ok ? void 0 : e(o.validation.messageKey, o.validation.params),
				saveLabel: e("skills.bundle.create"),
				savingLabel: e("skills.bundle.creating"),
				onSelect: o.setActivePath,
				onEdit: (e) => {
					o.activePath && o.editFile(o.activePath, e);
				},
				onDropFile: () => l.current?.click(),
				onDelete: () => {
					o.activePath && o.removeFile(o.activePath);
				},
				onRestore: () => {
					o.activePath && o.restoreFile(o.activePath);
				},
				onAddFiles: o.addFiles,
				onSave: () => {
					v();
				},
				onCancel: y
			}),
			/* @__PURE__ */ Y(Rf, {
				isOpen: s,
				onOpenChange: c,
				onConfirm: () => {
					t("/skills");
				}
			})
		]
	});
}
//#endregion
//#region src/hooks/use-skill.ts
function qf(e) {
	let [t, n] = G(), [r, i] = G([]), [a, s] = G("loading"), c = W(void 0), l = W(void 0), u = B(async () => {
		c.current?.abort();
		let t = new AbortController();
		c.current = t, s("loading");
		try {
			let r = await o({ signal: t.signal });
			if (t.signal.aborted) return;
			let a = r.find((t) => t.id === e);
			if (!a) {
				n(void 0), s("not-found");
				return;
			}
			n(a);
			let c = await g(e, { signal: t.signal });
			if (t.signal.aborted) return;
			i(c), s("loaded");
		} catch {
			if (t.signal.aborted) return;
			s("error");
		}
	}, [e]);
	return H(() => {
		u();
	}, [u]), H(() => () => {
		c.current?.abort(), l.current?.abort();
	}, []), {
		skill: t,
		files: r,
		status: a,
		refetch: B(async () => {
			await u();
		}, [u]),
		refreshSkill: B(async () => {
			l.current?.abort();
			let t = new AbortController();
			l.current = t;
			try {
				let r = await o({ signal: t.signal });
				if (t.signal.aborted) return;
				let i = r.find((t) => t.id === e);
				i && n(i);
			} catch {}
		}, [e]),
		toggleAvailability: B(async (t) => {
			n((e) => e && {
				...e,
				available: t
			});
			try {
				n(await Pe(e, t));
			} catch {
				n((e) => e && {
					...e,
					available: !t
				});
			}
		}, [e]),
		remove: B(async () => {
			await Fe(e);
		}, [e])
	};
}
//#endregion
//#region src/hooks/use-skill-bundle-mutation.ts
function Jf(e) {
	let { t } = Z(), [n, r] = G(!1), [i, a] = G(), o = W(!1), s = B(() => {
		a(void 0);
	}, []);
	return {
		isSaving: n,
		error: i,
		save: B(async (n) => {
			if (o.current) return {
				status: "failed",
				serverChanged: !1,
				remainingDeletes: n.deletes,
				error: t("skills.bundle.errors.saveFailed")
			};
			o.current = !0, a(void 0), r(!0);
			let i = !1, s = 0;
			try {
				n.upserts.length > 0 && (await le(e, n.upserts), i = !0);
				for (let t of n.deletes) await ze(e, t), s++, i = !0;
				return { status: "saved" };
			} catch (e) {
				let r = Ad(t, await Re(e), "skills.bundle.errors.saveFailed");
				return a(r), {
					status: "failed",
					serverChanged: i,
					remainingDeletes: n.deletes.slice(s),
					error: r
				};
			} finally {
				o.current = !1, r(!1);
			}
		}, [e, t]),
		dismissError: s
	};
}
//#endregion
//#region src/hooks/use-skill-rename.ts
function Yf(e) {
	let { t } = Z(), [n, r] = G(!1), [i, a] = G(), o = W(!1), s = B(() => {
		a(void 0);
	}, []);
	return {
		isRenaming: n,
		error: i,
		rename: B(async (n) => {
			if (o.current) return {
				status: "failed",
				error: t("skills.detail.rename.failed")
			};
			o.current = !0, a(void 0), r(!0);
			try {
				return await te(e, n), { status: "renamed" };
			} catch (e) {
				let n = await y(e) ?? t("skills.detail.rename.failed");
				return a(n), {
					status: "failed",
					error: n
				};
			} finally {
				o.current = !1, r(!1);
			}
		}, [e, t]),
		dismissError: s
	};
}
//#endregion
//#region src/hooks/use-skill-publish.ts
function Xf(e) {
	let { t } = Z(), [n, r] = G(!1), [i, a] = G(), o = W(!1), s = B(() => {
		a(void 0);
	}, []);
	return {
		isPublishing: n,
		error: i,
		publish: B(async () => {
			if (o.current) return {
				status: "failed",
				error: t("skills.detail.publish.failed")
			};
			o.current = !0, a(void 0), r(!0);
			try {
				let { version: t } = await Me(e);
				return {
					status: "published",
					version: t
				};
			} catch (e) {
				let n = await y(e) ?? t("skills.detail.publish.failed");
				return a(n), {
					status: "failed",
					error: n
				};
			} finally {
				o.current = !1, r(!1);
			}
		}, [e, t]),
		dismissError: s
	};
}
//#endregion
//#region src/components/skills/rename-skill-dialog.tsx
function Zf({ isOpen: e, onOpenChange: t, fromName: n, toName: r, isRenaming: i, error: a, onConfirm: o }) {
	let { t: s } = Z();
	return /* @__PURE__ */ Y(Qe, {
		open: e,
		onOpenChange: t,
		children: /* @__PURE__ */ X(Xe, { children: [
			/* @__PURE__ */ X(Ye, { children: [/* @__PURE__ */ Y(Ze, { children: s("skills.detail.rename.title") }), /* @__PURE__ */ Y(qe, { children: s("skills.detail.rename.description") })] }),
			/* @__PURE__ */ X("div", {
				className: "flex items-center gap-3 rounded-md border border-border bg-muted/30 px-3 py-2 text-sm",
				children: [
					/* @__PURE__ */ Y("code", {
						className: "font-mono text-muted-foreground line-through",
						children: n
					}),
					/* @__PURE__ */ Y(en, {
						className: "size-4 shrink-0 text-muted-foreground",
						"aria-hidden": "true"
					}),
					/* @__PURE__ */ Y("code", {
						className: "font-mono font-medium",
						children: r
					})
				]
			}),
			a && /* @__PURE__ */ Y("p", {
				className: "text-sm text-destructive",
				children: a
			}),
			/* @__PURE__ */ X(Ke, { children: [/* @__PURE__ */ Y(I, {
				variant: "outline",
				disabled: i,
				onClick: () => {
					t(!1);
				},
				children: s("skills.detail.rename.cancel")
			}), /* @__PURE__ */ Y(I, {
				disabled: i,
				onClick: o,
				children: s(i ? "skills.detail.rename.renaming" : "skills.detail.rename.confirm")
			})] })
		] })
	});
}
//#endregion
//#region src/pages/skill-detail.tsx
function Qf() {
	let { t: e } = Z(), t = Gt(), { skillId: n = "" } = qt(), { skill: r, files: i, status: a, refetch: o, refreshSkill: s, toggleAvailability: c, remove: l } = qf(n), u = r?.ownerType === "user", { ref: d, isOutOfView: f } = ga();
	Ji({
		title: e("skills.title"),
		mobileTitle: f ? r?.title : void 0
	});
	let [p, m] = G(void 0), h = B(() => {
		m(void 0);
	}, []);
	return a !== "loaded" || !r ? /* @__PURE__ */ Y($f, {
		status: a,
		refetch: o,
		navigate: t
	}) : /* @__PURE__ */ Y($f, {
		status: "loaded",
		refetch: o,
		navigate: t,
		children: /* @__PURE__ */ X("div", {
			className: "flex flex-col gap-7",
			children: [/* @__PURE__ */ X("div", {
				className: "flex flex-col gap-4",
				children: [/* @__PURE__ */ Y(Gd, {
					skill: r,
					titleRef: d,
					onToggleAvailability: c
				}), /* @__PURE__ */ Y(jf, { requires: r.requires })]
			}), /* @__PURE__ */ Y(ep, {
				skillId: r.id,
				skillTitle: r.title,
				skillSlug: r.slug,
				hasDraftChanges: r.hasDraftChanges,
				files: i,
				isOwner: u,
				refetch: o,
				refreshSkill: s,
				remove: l,
				navigate: t,
				resume: p,
				onRequestResume: m,
				onClearResume: h
			}, i.join("|"))]
		})
	});
}
function $f({ status: e, refetch: t, navigate: n, children: r }) {
	let { t: i } = Z();
	return /* @__PURE__ */ Y("div", {
		className: "h-full overflow-y-auto",
		children: /* @__PURE__ */ X("div", {
			className: "mx-auto max-w-[1180px] px-4 py-8 md:px-10",
			children: [
				/* @__PURE__ */ Y(ha, {
					to: "/skills",
					label: i("skills.detail.back"),
					className: "mb-4"
				}),
				e === "loading" && /* @__PURE__ */ Y("div", { className: "h-40 animate-pulse rounded-xl bg-muted/40" }),
				e === "not-found" && /* @__PURE__ */ X("div", {
					className: "flex flex-col items-start gap-3 rounded-lg border border-border bg-muted/20 p-6",
					children: [
						/* @__PURE__ */ Y("h1", {
							className: "text-lg font-semibold",
							children: i("skills.detail.notFound.title")
						}),
						/* @__PURE__ */ Y("p", {
							className: "text-sm text-muted-foreground",
							children: i("skills.detail.notFound.description")
						}),
						/* @__PURE__ */ Y(I, {
							variant: "outline",
							size: "sm",
							onClick: () => {
								n("/skills");
							},
							children: i("skills.detail.notFound.back")
						})
					]
				}),
				e === "error" && /* @__PURE__ */ X("div", {
					className: "flex flex-col items-start gap-3 rounded-lg border border-destructive/30 bg-destructive/5 p-4",
					children: [/* @__PURE__ */ X("div", {
						className: "flex items-center gap-2 text-sm text-destructive",
						children: [/* @__PURE__ */ Y(Yt, {
							className: "size-4",
							"aria-hidden": "true"
						}), /* @__PURE__ */ Y("span", { children: i("skills.detail.error.title") })]
					}), /* @__PURE__ */ Y(I, {
						variant: "outline",
						size: "sm",
						onClick: () => {
							t();
						},
						children: i("skills.detail.error.retry")
					})]
				}),
				r
			]
		})
	});
}
function ep({ skillId: e, skillTitle: t, skillSlug: n, hasDraftChanges: r, files: i, isOwner: a, refetch: o, refreshSkill: s, remove: c, navigate: l, resume: u, onRequestResume: d, onClearResume: f }) {
	let { t: p, i18n: m } = Z(), { language: h } = m, [g, _] = G(() => !!u), [v, y] = G(!1), [b, x] = G(!1), [S, C] = G(() => u?.error), w = Bf({
		mode: "edit",
		initialEntries: Zd(i)
	}), { save: T, isSaving: E, error: D, dismissError: O } = Jf(e), { rename: ee, isRenaming: te, error: k, dismissError: ne } = Yf(e), { publish: A, isPublishing: re, error: ie, dismissError: ae } = Xf(e), oe = W(null), se = W(void 0);
	H(() => {
		if (u && u !== se.current) {
			se.current = u, _(!0), C(u.error), w.resetToServer(i);
			for (let e of u.deletes) w.removeFile(e);
		}
	}, [u]);
	let [j, ce] = G(() => ht(i, h));
	H(() => {
		ce(ht(i, h));
	}, [h]), H(() => {
		j && !w.entries.some((e) => e.path === j) && ce(Yd);
	}, [w.entries, j]);
	let { activeContent: le, activeContentStatus: ue, activeIsBinary: de, originalForActive: fe } = Hf(e, w.entries, j, g);
	Uf(g && w.dirty);
	let [pe, me] = G(void 0), [he, ge] = G(!1), [_e, ve] = G(void 0), ye = B(async () => {
		let e = await uf(w.entries);
		if (e === void 0) return;
		let { content: t, name: r } = e;
		return {
			content: t,
			rename: r && r !== n && Cr(r) ? r : void 0
		};
	}, [w.entries, n]), be = B(async (e) => {
		C(void 0);
		let t = await T(w.plan(e === void 0 ? void 0 : { [Yd]: e }));
		if (t.status === "saved") {
			f(), await o(), _(!1);
			return;
		}
		t.serverChanged && (d({
			deletes: t.remainingDeletes,
			error: t.error
		}), await o());
	}, [
		T,
		w,
		o,
		d,
		f
	]), xe = B(async () => {
		O(), C(void 0), ve(void 0), ge(!0);
		try {
			let e = await ye();
			if (me(e), e?.rename) {
				ne(), x(!0);
				return;
			}
			await be(e?.content);
		} catch {
			ve(p("skills.bundle.errors.saveFailed"));
		} finally {
			ge(!1);
		}
	}, [
		ye,
		be,
		ne,
		O,
		p
	]), Se = B(async () => {
		pe?.rename && (await ee(pe.rename)).status === "renamed" && (x(!1), await be(pe.content));
	}, [
		pe,
		ee,
		be
	]), Ce = B(() => {
		if (w.dirty) {
			y(!0);
			return;
		}
		f(), _(!1);
	}, [w.dirty, f]), we = B(() => {
		y(!1), O(), C(void 0), f(), _(!1);
	}, [O, f]), Te = B(async () => {
		await c(), await l("/skills");
	}, [c, l]), Ee = B(() => {
		oe.current?.click();
	}, []), De = B(async () => {
		await A(), await s();
	}, [A, s]);
	return g ? /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-7",
		children: [
			/* @__PURE__ */ Y("input", {
				ref: oe,
				type: "file",
				hidden: !0,
				"data-testid": "skill-edit-replace-input",
				onChange: (e) => {
					let [t] = [...e.target.files ?? []];
					t && j && w.replaceFile(j, t), e.target.value = "";
				}
			}),
			/* @__PURE__ */ Y(Of, {
				mode: "edit",
				skillId: e,
				entries: w.entries,
				activePath: j,
				activeContent: le,
				activeContentStatus: ue,
				activeIsBinary: de,
				dirty: w.dirty,
				canSave: w.validation.ok && !E && !he && w.dirty,
				isSaving: E || he,
				pendingCount: w.pendingCount,
				errorMessage: D ?? S ?? _e,
				onDismissError: () => {
					O(), C(void 0), ve(void 0);
				},
				validationWarning: w.dirty && !w.validation.ok ? p(w.validation.messageKey, w.validation.params) : void 0,
				onSelect: ce,
				onEdit: (e) => {
					j && w.editFile(j, e, fe);
				},
				onDropFile: Ee,
				onDelete: () => {
					j && w.removeFile(j);
				},
				onRestore: () => {
					j && w.restoreFile(j);
				},
				onAddFiles: w.addFiles,
				onSave: () => {
					xe();
				},
				onCancel: Ce
			}),
			a && /* @__PURE__ */ Y(Nf, {
				skillTitle: t,
				onConfirmDelete: Te
			}),
			/* @__PURE__ */ Y(Rf, {
				isOpen: v,
				onOpenChange: y,
				onConfirm: we
			}),
			pe?.rename && /* @__PURE__ */ Y(Zf, {
				isOpen: b,
				onOpenChange: x,
				fromName: n,
				toName: pe.rename,
				isRenaming: te,
				error: k,
				onConfirm: () => {
					Se();
				}
			})
		]
	}) : /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-3",
		children: [
			a && /* @__PURE__ */ X("div", {
				className: "flex justify-end gap-2",
				children: [r && /* @__PURE__ */ X(I, {
					type: "button",
					size: "sm",
					disabled: re,
					onClick: () => {
						De();
					},
					children: [/* @__PURE__ */ Y(ur, {
						className: "size-4",
						"aria-hidden": "true"
					}), p(re ? "skills.detail.publish.publishing" : "skills.detail.publish.button")]
				}), /* @__PURE__ */ X(I, {
					type: "button",
					variant: "outline",
					size: "sm",
					onClick: () => {
						ae(), _(!0);
					},
					children: [/* @__PURE__ */ Y(Un, {
						className: "size-4",
						"aria-hidden": "true"
					}), p("skills.detail.edit.button")]
				})]
			}),
			ie && /* @__PURE__ */ Y(xt, {
				variant: "error",
				onDismiss: ae,
				dismissLabel: p("skills.createError.dismiss"),
				children: ie
			}),
			/* @__PURE__ */ Y(Of, {
				skillId: e,
				files: i,
				activeFile: j,
				onSelect: ce
			})
		]
	});
}
//#endregion
//#region src/hooks/use-scrolled-to-bottom.ts
function tp() {
	let e = W(null), [t, n] = G(!1);
	return H(() => {
		let r = e.current;
		if (!r || t) return;
		let i = new IntersectionObserver((e) => {
			e.some((e) => e.isIntersecting) && n(!0);
		});
		return i.observe(r), () => {
			i.disconnect();
		};
	}, [t]), {
		sentinelRef: e,
		hasReachedBottom: t
	};
}
//#endregion
export { Jr as AuthProvider, ha as BackLink, ua as BrandProvider, I as Button, ls as CORE_ACCOUNT_SECTION_IDS, cs as CORE_SETTINGS_SECTION_IDS, gd as ChatRoute, gl as ConversationsListPage, Et as EmptyState, Dt as ErrorMessage, Ot as Grid, wt as Heading, ll as HomePage, Ed as LoginPage, We as Markdown, xd as NotFoundPage, _a as PageTemplate, ec as PlaygroundApp, $ as SectionCard, kt as SectionHeader, yd as ShareArtifactPage, Qf as SkillDetailPage, Kf as SkillsNewPage, If as SkillsPage, Tt as Stack, R as StatusMessage, L as Text, si as ToastProvider, Ds as accountRoutes, Ba as accountSectionPath, fe as apiFetch, Ne as configureApi, ca as defineBrand, l as fetchUser, Qr as getConversationURL, Zr as getNewConversationURL, fs as isAccountRoute, ds as isSettingsRoute, re as setOnNoPlan, _e as setOnUnauthorized, Es as settingsRoutes, za as settingsSectionPath, Yr as useAuth, da as useBrandComponent, fa as useBrandName, ms as useCoreAccountSections, ps as useCoreSettingsSections, Xr as useOptionalAuth, tp as useScrolledToBottom, ys as useSettingsPath, Q as useToast };

//# sourceMappingURL=index.js.map